(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CitySelector = exports.CitySelector = function () {
    function CitySelector(inputElement, cityListElement, cityInputElement) {
        var inputType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "zipCode";

        _classCallCheck(this, CitySelector);

        if (!inputElement || !cityListElement || !cityInputElement) {
            return;
        }
        this.inputType = inputType;
        if (this.inputType === "zipCode") {
            var minInputLength = parseInt(inputElement.dataset.lengthTriggerSearch);
            this.minInputLength = isNaN(minInputLength) ? 2 : minInputLength;
            this.cityUriSuffix = '__ZIPCODE__';
        }
        if (this.inputType === "cityName") {
            this.minInputLength = 3;
            this.cityUriSuffix = '__CITYNAME__';
        }
        this.keyupInterval = 400;
        this.inputElement = inputElement;
        this.cityListElement = cityListElement;
        this.cityInputElement = cityInputElement;
        this.cityListLabelElement = document.querySelector(cityListElement.dataset.labelElement);

        this.bindEvents();
    }

    _createClass(CitySelector, [{
        key: "bindEvents",
        value: function bindEvents() {
            var that = this;

            var keyupTimeout = void 0;
            this.inputElement.addEventListener('keyup', function (event) {

                clearTimeout(keyupTimeout);
                keyupTimeout = setTimeout(function () {
                    that.inputChanged(event.target.value);
                }, that.keyupInterval);
            });

            that.inputChanged(this.inputElement.value);
        }
    }, {
        key: "inputChanged",
        value: function inputChanged(inputValue) {
            var _this = this;

            if (inputValue.length < this.minInputLength) {
                return;
            }
            this.displayLabelZipCode(this.cityListLabelElement);
            this.getCities(inputValue).then(function (result) {
                if (result.cities) {
                    _this.clearCityList();

                    result.cities.forEach(function (city) {
                        _this.addCityToList(city);
                    });
                }
            });
        }
    }, {
        key: "clearCityList",
        value: function clearCityList() {
            this.cityListElement.innerHTML = '';
        }
    }, {
        key: "addCityToList",
        value: function addCityToList(city) {
            var cityElement = document.createElement('a');
            cityElement.innerText = city.name;
            cityElement.dataset.zipcode = city.zip_code;
            cityElement.classList.add('city-list-element');

            this.bindCitySelectEvent(cityElement);

            this.cityListElement.appendChild(cityElement);
        }
    }, {
        key: "bindCitySelectEvent",
        value: function bindCitySelectEvent(cityElement) {
            var _this2 = this;

            cityElement.addEventListener('click', function (event) {
                event.preventDefault();

                _this2.cityInputElement.value = cityElement.innerText;
                if (_this2.inputType === 'zipCode') {
                    _this2.inputElement.value = cityElement.dataset.zipcode;
                }
                if (_this2.inputType === 'cityName') {
                    _this2.inputElement.value = cityElement.innerText;
                }
            });
        }
    }, {
        key: "getCities",
        value: function getCities(inputValue) {
            return fetch(this.inputElement.dataset.cityUri.replace(this.cityUriSuffix, inputValue)).then(function (response) {
                return response.json();
            });
        }
    }, {
        key: "displayLabelZipCode",
        value: function displayLabelZipCode(element) {
            var observer = new MutationObserver(function () {
                element.style.display = "block";
            });
            observer.observe(this.cityListElement, { attributes: false, childList: true, subtree: false });
        }
    }]);

    return CitySelector;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setCookie = setCookie;
exports.getCookie = getCookie;
exports.deleteCookie = deleteCookie;
exports.hasCookie = hasCookie;
if (window.jQuery === undefined) {
    window.jQuery = window.$ = require('jquery');
}

function setCookie(cname, cvalue) {
    var exdays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';

    var d = new Date();
    var expires = "";
    if (exdays > 0) {
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        expires = "expires=" + d.toUTCString() + ";";
    }
    if (cvalue instanceof Object) {
        cvalue = JSON.stringify(cvalue);
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + "path=" + path + ";";
}

function getCookie(cname) {
    var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            var cookie = c.substring(name.length, c.length);
            return object ? toJson(cookie) : cookie;
        }
    }
    return "";
}

function deleteCookie(cname) {
    document.cookie = cname + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function hasCookie(cname) {
    return getCookie(cname) !== "";
}

function toJson(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return str;
    }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{"jquery":16}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.togglePassword = togglePassword;
function togglePassword() {
    if (document.getElementsByClassName('toggle-password').length > 0) {
        document.getElementsByClassName('toggle-password')[0].addEventListener('click', function (event) {
            var input = document.getElementById(event.target.getAttribute("data-toggle"));
            if (input.getAttribute("type") === "password") {
                input.setAttribute("type", "text");
                event.target.classList.remove("fa-eye");
                event.target.classList.add("fa-eye-slash");
            } else {
                input.setAttribute("type", "password");
                event.target.classList.remove("fa-eye-slash");
                event.target.classList.add("fa-eye");
            }
        });
    }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadNewsletter = loadNewsletter;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _cookie = require('./cookie');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadNewsletter() {

    /* Newletter Footer */
    var formNewsletter = document.getElementById('newsletter-sign-up');
    var submitNewsletter = document.getElementById('newsletter-submit');
    var alert = '#newsletter-sign-up .alert';
    var modalOverlay = document.getElementById("modal-overlay");
    var closeButton = document.getElementById("close-button");
    var closeNewsletter = document.getElementById("close-newsletter");

    (0, _jquery2.default)(alert).removeClass('hide').hide();

    if (null !== formNewsletter && null !== submitNewsletter) {

        var buttonBuffer = submitNewsletter.innerHTML;

        submitNewsletter.onclick = function () {
            toggleSubmitButton(true, buttonBuffer);
            subscribeNewsletter(buttonBuffer);
        };

        formNewsletter.onsubmit = function (e) {
            toggleSubmitButton(true, buttonBuffer);
            e.preventDefault();
            subscribeNewsletter(buttonBuffer);
        };
    }

    if (null !== closeButton && null !== modalOverlay) {
        closeButton.onclick = toggleModal;
        modalOverlay.onclick = toggleModal;
    }

    if (null !== closeNewsletter) {
        closeNewsletter.onclick = toggleModal;
    }

    /* Newletter Pop-up */
    var formNewsletterPopUp = document.getElementsByClassName('js-newsletter-popup-form')[0];
    var submitNewsletterPopUp = document.getElementsByClassName('js-newsletter-popup-submit')[0];
    var modalNewsletterPopUp = document.getElementsByClassName('js-newsletter-popup')[0];

    var modalMarketInfo = document.getElementsByClassName('js-market-popup')[0];

    if (null !== formNewsletterPopUp && undefined !== formNewsletterPopUp && null !== submitNewsletterPopUp && undefined !== submitNewsletterPopUp) {
        submitNewsletterPopUp.onclick = function () {
            subscribeNewsletterPopUp();
        };
        formNewsletterPopUp.onsubmit = function (e) {
            e.preventDefault();
            subscribeNewsletterPopUp();
        };
    }
    if (null !== modalNewsletterPopUp && undefined !== modalNewsletterPopUp) {
        /* Catch user when he go outside the viewport (99% want to leave the website) */
        (0, _jquery2.default)(document).bind("mouseleave", function (e) {
            if (!(0, _cookie.hasCookie)('has_displayed_newsletter_pop_up')) {
                (0, _jquery2.default)('.js-newsletter-popup').modal('show');
                (0, _cookie.setCookie)('has_displayed_newsletter_pop_up', true);
            }
        });
    }

    if (null !== modalMarketInfo && undefined !== modalMarketInfo) {
        (0, _jquery2.default)('.js-market-popup').modal('show');
    }
}

function subscribeNewsletter(buttonBuffer) {
    var formNewsletter = document.getElementById('newsletter-sign-up');
    var url = formNewsletter.getAttribute('data-action');
    hideNewsletterSignUpError('#newsletter-sign-up .alert');

    _jquery2.default.post(url, (0, _jquery2.default)(formNewsletter).serialize()).done(function (json) {
        toggleSubmitButton(false, buttonBuffer);
        if (!json.error) {
            document.getElementById('subscribe_newsletter_email').value = "";
            if (200 === json.statusCode) {
                modalOK();
            } else {
                modalOK(true);
            }
        } else {
            showNewsletterSignUpError('#newsletter-sign-up .alert');
        }
    }).fail(function () {
        toggleSubmitButton(false, buttonBuffer);
    });
}

function subscribeNewsletterPopUp() {
    var formNewsletterPopUp = document.getElementsByClassName('js-newsletter-popup-form')[0];
    var url = formNewsletterPopUp.getAttribute('data-action');
    var successText = formNewsletterPopUp.getAttribute('data-success');

    hideNewsletterSignUpError('.js-newsletter-popup-error');

    _jquery2.default.post(url, (0, _jquery2.default)(formNewsletterPopUp).serialize()).done(function (json) {
        if (!json.error) {
            formNewsletterPopUp.innerHTML = successText;
            formNewsletterPopUp.classList.add('success');
        } else {
            showNewsletterSignUpError('.js-newsletter-popup-error');
        }
    }).fail(function () {
        showNewsletterSignUpError('.js-newsletter-popup-error');
    });
}

function customToggle(element, klass) {
    if (!element) return;
    var classes = element.className.match(/\S+/g) || [],
        index = classes.indexOf(klass);

    index >= 0 ? classes.splice(index, 1) : classes.push(klass);
    element.className = classes.join(' ');
}

function toggleModal() {
    var modal = document.getElementById("modal");
    var modalOverlay = document.getElementById("modal-overlay");
    var modalNewsletter = document.getElementById("modal-newsletter");

    customToggle(modalOverlay, "closed");
    customToggle(modal, "closed");
    customToggle(modalNewsletter, "closed");
}

function toggleSubmitButton(isLoading, buttonBuffer) {
    var submitNewsletter = document.getElementById('newsletter-submit');
    submitNewsletter.innerHTML = isLoading ? "" : buttonBuffer;
    customToggle(submitNewsletter, 'loading');
}

function modalOK() {
    var hasConflict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var modalOKText = document.getElementById("subscribe-ok");
    var modalConflictText = document.getElementById("subscribe-conflict");

    if (!modalOKText || !modalConflictText) {
        console.warn('Modal text elements not found');
        return;
    }

    var modalToHide = hasConflict ? modalConflictText : modalOKText;

    if (hasConflict) {
        modalOKText.classList.add("hide");
    } else {
        modalConflictText.classList.add("hide");
    }

    if (modalToHide.className.indexOf('hide') !== -1) {
        customToggle(modalToHide, 'hide');
    }
    toggleModal();
}

function showNewsletterSignUpError(element) {
    (0, _jquery2.default)(element).slideDown();
}

function hideNewsletterSignUpError(element) {
    (0, _jquery2.default)(element).slideUp();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{"./cookie":2,"jquery":16}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.closeModalSendEmailOrderTracking = closeModalSendEmailOrderTracking;
exports.priceCalculOALR = priceCalculOALR;
exports.toolsBoxCall = toolsBoxCall;
exports.pageOrder = pageOrder;
exports.zoomAccessoryOrderPage = zoomAccessoryOrderPage;
exports.paymentPage = paymentPage;
exports.loadTemplate = loadTemplate;
exports.uploadInformationAccordion = uploadInformationAccordion;
exports.dynamicPriceProductCard = dynamicPriceProductCard;
exports.selectsStatutNotification = selectsStatutNotification;
exports.verifSelectInputStatutNotification = verifSelectInputStatutNotification;
exports.inputsStatutNotification = inputsStatutNotification;
exports.showFloristSchedules = showFloristSchedules;
exports.updateFloristDeliveryLocationValue = updateFloristDeliveryLocationValue;
exports.prefillAddressFields = prefillAddressFields;
exports.updateProductQuantityOnOrderPage = updateProductQuantityOnOrderPage;
exports.updateAccessoryQuantityOnOrderPage = updateAccessoryQuantityOnOrderPage;

var _utils = require('./utils');

if (window.jQuery === undefined) {
    window.jQuery = window.$ = require('jquery');
}

function priceCalcul(currencyCurrent) {

    if ($('.product-data .value[data-attr="summary-product-amount"]').length) {
        priceCalculOALR(currencyCurrent);
        return false;
    }

    var accessoriesPrice = 0;
    var servicesPrice = 0;
    var stickersPrice = 0;
    var totalProductPrice = 0;
    var separator = (0, _utils.getSeparator)(currencyCurrent);
    var currency = (0, _utils.getCurrency)(currencyCurrent);
    var $deliveryPriceId = $('#delivery-price');
    var $discountPriceId = $('#discount-price');
    var $specialDeliveryPrice = $('#special-delivery-price');
    var $companyDiscount = $('#company-discount');
    var productPrices = '#form_order_checkout_productPrices';
    var deliveryPrice = parseFloat($deliveryPriceId.attr('data-delivery-price'));
    var productListElement = document.querySelector('.js-order-checkout-product-list');

    var discountPrice = $discountPriceId.attr('data-discount-price') ? parseFloat($discountPriceId.attr('data-discount-price')) : 0;

    var discountDelivery = $specialDeliveryPrice.attr('data-special-delivery-price') ? parseFloat($specialDeliveryPrice.attr('data-special-delivery-price')) : 0;

    var companyDiscount = $companyDiscount.attr('data-company-discount-price') ? parseFloat($companyDiscount.attr('data-company-discount-price')) : 0;

    $('input[id*="accessory-"]').each(function () {
        if ($(this).is(':checked')) {
            accessoriesPrice = accessoriesPrice + parseFloat($(this).attr('data-acc-price'));
        }
    });

    var accessoryInputs = document.querySelectorAll('.js-accessory-quantity');
    if (accessoryInputs.length > 0) {
        accessoryInputs.forEach(function (input) {
            if (input.value > 0) {
                accessoriesPrice += parseFloat(input.getAttribute('data-acc-price') * parseFloat(input.value));
            }
        });
    }

    document.querySelectorAll('.js-service').forEach(function (service) {
        if (service.checked && service.dataset.accPrice > 0) {
            servicesPrice = servicesPrice + parseFloat(service.dataset.accPrice);
        }
    });
    checkAndDisplayServiceTotalLine();

    document.querySelectorAll('.js-custom-sticker').forEach(function (sticker) {
        if (sticker.checked && sticker.dataset.accPrice > 0) {
            stickersPrice = stickersPrice + parseFloat(sticker.dataset.accPrice);
        }
    });

    var accessoryTotalLines = document.querySelectorAll(".js-order-product-accessory-line");
    accessoryTotalLines.forEach(function (accessoryTotalLine) {
        if (accessoryTotalLine) {
            if (accessoriesPrice > 0) {
                accessoryTotalLine.classList.remove('hidden-line');
            } else {
                accessoryTotalLine.classList.add('hidden-line');
            }
        }
    });

    checkAndDisplayAccessoryLines();

    /* Order is a cart and can have multiple products */
    if (productListElement && productListElement.dataset.iscart === '1') {
        totalProductPrice = 0;
        document.querySelectorAll('.js-order-product').forEach(function (block) {
            var quantity = parseInt(block.querySelector('.js-order-product-quantity').dataset.productQuantity);
            var sizeElement = block.querySelector('.js-order-select-size');
            var unitPrice = void 0;
            if (sizeElement.tagName === 'SELECT') {
                unitPrice = parseFloat(sizeElement.querySelector('option:checked').dataset.sizePrice);
            } else {
                unitPrice = parseFloat(sizeElement.dataset.sizePrice);
            }
            totalProductPrice += quantity * unitPrice;
        });
    } else {
        var totalProductPriceDIY = document.querySelector(".js-total-diy");
        if (totalProductPriceDIY) {
            totalProductPrice = parseFloat(totalProductPriceDIY.dataset.totalProductPrice);
        } else {
            var unitProductPrice = parseFloat(window.jQuery(productPrices + ' option:selected').attr('data-size-price')) || parseFloat(window.jQuery(productPrices).attr('data-size-price'));
            var productQuantityElement = document.querySelector('.js-order-product-quantity');
            var productQuantity = productQuantityElement ? parseInt(productQuantityElement.dataset.productQuantity, 10) : 1;
            totalProductPrice = unitProductPrice * productQuantity;
        }
    }

    var totalPrice = totalProductPrice + accessoriesPrice + servicesPrice + stickersPrice + deliveryPrice - discountPrice - discountDelivery - companyDiscount;

    $('[data-switch="product-price"]').text(totalProductPrice.toFixed(2).replace('.', separator) + '\xa0' + currency);
    $('[data-switch="accessories-price"]').text(accessoriesPrice.toFixed(2).replace('.', separator) + '\xa0' + currency);
    if (document.querySelector('[data-switch="services-price"]')) {
        document.querySelector('[data-switch="services-price"]').textContent = servicesPrice.toFixed(2).replace('.', separator) + '\xa0' + currency;
    }

    if (document.querySelector('[data-switch="custom-stickers-price"]')) {
        document.querySelector('[data-switch="custom-stickers-price"]').textContent = stickersPrice.toFixed(2).replace('.', separator) + '\xa0' + currency;
    }

    $('[data-switch="total-price"]').text(totalPrice.toFixed(2).replace('.', separator) + '\xa0' + currency);
}

function closeModalSendEmailOrderTracking() {
    var buttonCloseSendMailConfirmationSelfcare = document.getElementById('close-modal-confirmation-selfcare');
    var backGroundModal = document.getElementById('background-modal-confirmation-send-mail-selfcare');
    var modalConfirmationSendMailSelcare = document.getElementById('modal-confirmation-mail-selfcare');
    if (buttonCloseSendMailConfirmationSelfcare !== null) {
        buttonCloseSendMailConfirmationSelfcare.addEventListener('click', function () {
            backGroundModal.style.display = 'none';
            modalConfirmationSendMailSelcare.style.display = 'none';
        });
    }
}

function updateHtmlPriceOALR(el, value, currencyCurrent) {
    var strAmount = value.toFixed(2).replace('.', (0, _utils.getSeparator)(currencyCurrent));
    el.childNodes[0].firstChild.textContent = (0, _utils.getCurrency)(currencyCurrent) + Math.trunc(strAmount);
    el.childNodes[0].lastChild.textContent = strAmount.substr(-3, 3);
}

function priceCalculOALR(currencyCurrent) {

    var $summaryOrderAmount = $('*[data-attr="summary-order-amount"]');
    var $summaryAccessoriesAmount = $('*[data-attr="summary-accessories-amount"]');
    var $summaryTaxAmount = $('*[data-attr="summary-tax-amount"]');
    var $inputsAccessory = $('input[id*="accessory-"]');
    var separator = (0, _utils.getSeparator)(currencyCurrent);
    var currency = (0, _utils.getCurrency)(currencyCurrent);
    var accessoriesPrice = 0;
    var discountDelivery = 0;
    var productPrice = parseFloat($('*[data-attr="summary-product-amount"]').attr('data-value'));
    var deliveryPrice = parseFloat($('*[data-attr="summary-delivery-amount"]').attr('data-value'));
    var discountPrice = parseFloat($('*[data-attr="summary-discount-amount"]').attr('data-value'));
    var orderAmount = parseFloat($summaryOrderAmount.attr('data-value'));

    productPrice = isNaN(productPrice) ? 0 : productPrice;
    deliveryPrice = isNaN(deliveryPrice) ? 0 : deliveryPrice;
    discountPrice = isNaN(discountPrice) ? 0 : discountPrice;

    $inputsAccessory.each(function () {
        if ($(this).is(':checked')) {
            accessoriesPrice = accessoriesPrice + parseFloat($(this).attr('data-acc-price'));
        }
    });

    var taxPrice = calculOALRTax(productPrice, accessoriesPrice, deliveryPrice);
    taxPrice = isNaN(taxPrice) ? 0 : taxPrice;

    orderAmount = productPrice + deliveryPrice + accessoriesPrice + taxPrice - discountPrice - discountDelivery;

    var elOrderAmount = document.querySelector('*[data-attr="summary-order-amount"]');
    var elAccessoriesAmount = document.querySelector('*[data-attr="summary-accessories-amount"]');
    var elTaxAmount = document.querySelector('*[data-attr="summary-tax-amount"]');

    updateHtmlPriceOALR(elTaxAmount, taxPrice, currencyCurrent);
    updateHtmlPriceOALR(elAccessoriesAmount, accessoriesPrice, currencyCurrent);
    updateHtmlPriceOALR(elOrderAmount, orderAmount, currencyCurrent);

    accessoriesPrice > 0 ? $summaryAccessoriesAmount.parent().removeClass('hide').show() : $summaryAccessoriesAmount.parent().hide();
}

function calculOALRTax(productPrice, accessoriesPrice, deliveryPrice) {
    return parseFloat(((productPrice + accessoriesPrice + deliveryPrice) * window.AQUA.TAX_RATE).toFixed(2));
}

function toolsBoxCall(currency) {
    var $deliveryPriceID = $('#delivery-price');
    var $toolboxClass = $('.toolbox-action.free-delivery');
    var $freeDelivery = $toolboxClass.find('i.js-state-action').hasClass('glyphicon-ok');
    var $saveDeliveryPrice = parseFloat($toolboxClass.find('.toolbox-save-delivery-price').val());
    var $saveDeliveryPriceColor = '';
    var $isMinimified = false;
    var fullSize = 0;
    var url = '';

    $toolboxClass.on('click', function () {
        $(this).find('i.js-state-action').toggleClass('glyphicon-remove').toggleClass('glyphicon-ok');
        $freeDelivery = !$freeDelivery;

        if ($freeDelivery) {
            $saveDeliveryPrice = $deliveryPriceID.attr('data-delivery-price');
            $saveDeliveryPriceColor = $deliveryPriceID.css('color');
            $deliveryPriceID.attr('data-delivery-price', '0.00');
            $deliveryPriceID.css('color', 'red').html('0.00 €');
            priceCalcul(currency);
        } else {
            $deliveryPriceID.attr('data-delivery-price', $saveDeliveryPrice);
            $deliveryPriceID.css('color', $saveDeliveryPriceColor).html($saveDeliveryPrice + ' €');
            priceCalcul(currency);
        }

        url = $(this).find('input.toolbox-action-path').val();

        $.post(url);
    });

    var toolboxTitle = '.js-toolbox-title';
    var toolboxMiniHide = '.js-toolbox-mini-hide';
    var toolboxMiniShow = '.js-toolbox-mini-show';

    $(".call-toolbox .js-toolbox-resize").on('click', function () {

        $(this).find('i').toggleClass('glyphicon-minus').toggleClass('glyphicon-plus');
        if (!$isMinimified && fullSize === 0) fullSize = $(this).parent().css('width');
        $isMinimified = !$isMinimified;

        if ($isMinimified) {
            $(toolboxTitle).hide();
            $(toolboxMiniHide).hide();
            $(toolboxMiniShow).show();
            $(this).parent().css('width', '100px');
        } else {
            $(toolboxTitle).show();
            $(toolboxMiniHide).show();
            $(toolboxMiniShow).hide();
            $(this).parent().css('width', fullSize);
        }
    });

    $('[data-toggle="tooltip"]').tooltip();

    $(".js-summary-hide").on('click', function () {
        $('.form-accessories').toggle();
        $(this).find('i').toggleClass('glyphicon-triangle-right').toggleClass('glyphicon-triangle-bottom');
    });

    $(".js-composition-hide").on('click', function () {
        $('.diy-product-list-summary').toggle();
        $(this).find('i').toggleClass('glyphicon-triangle-right').toggleClass('glyphicon-triangle-bottom');
    });
}

function pageOrder(formProductPrices, inputAccessory, currency, productQuantity) {

    // Select
    $(formProductPrices).on('change', function () {
        priceCalcul(currency);
    });

    if (productQuantity) {
        $(productQuantity).on('change', function () {
            priceCalcul(currency);
        });
    }

    // Input accessory
    $(inputAccessory).on('click', function () {
        priceCalcul(currency);
    });

    // Input service
    document.querySelectorAll('.js-service').forEach(function (service) {
        service.addEventListener('click', function () {
            priceCalcul(currency);
        });
    });
    checkAndDisplayServiceTotalLine();

    // Input stickers
    document.querySelectorAll('.js-custom-sticker').forEach(function (sticker) {
        sticker.addEventListener('click', function () {
            priceCalcul(currency);
        });
    });

    // Florist order checkout missing delivery explanation
    var floristMissingDeliveryLink = document.querySelector('.js-form-group-order-recipient-florist-city-missing-link');
    var floristMissingDeliveryBlock = document.querySelector('.js-form-group-order-recipient-florist-city-missing');
    var floristDeliveryExplanationBlock = document.querySelector('.js-form-group-order-recipient-florist-city-explanation');
    if (floristMissingDeliveryLink && floristMissingDeliveryBlock && floristDeliveryExplanationBlock) {
        floristMissingDeliveryLink.addEventListener('click', function () {
            floristMissingDeliveryBlock.style.display = 'none';
            floristDeliveryExplanationBlock.style.display = 'block';
        });
    }

    // Message field suggestion with loco keys
    var messageLocoField = document.querySelector('.js-message');
    var messageLocoSuggestionField = document.querySelector('.js-form-suggestion-loco-message');

    if (messageLocoField && messageLocoSuggestionField) {
        messageLocoSuggestionField.addEventListener("change", function () {
            messageLocoField.value = this.value;
        });
    }

    // Default Bootstrap radio button style
    checkAndChangeClassForDeliveryTypeFields();

    // Check accessories previously selected
    checkAndDisplayAccessoryLines();

    // Funeral message checkbox
    var funeralMessageField = document.querySelector('.js-funeral-message-field');
    var funeralMessageCheckbox = document.querySelector('.js-funeral-message-checkbox');
    if (funeralMessageField && funeralMessageCheckbox) {
        funeralMessageCheckbox.addEventListener('change', function () {
            if (!funeralMessageCheckbox.checked) {
                funeralMessageField.value = '';
            }
        });
        funeralMessageField.addEventListener('change', function () {
            if (!funeralMessageCheckbox.checked) {
                funeralMessageCheckbox.checked = true;
            }
        });
    }

    // Clear anonymous field
    var messageSuggestionField = document.querySelector('.js-form-suggestion-message');
    var messageField = document.querySelector('.js-form-message');
    var signatureField = document.querySelector('.js-form-signature');
    var anonymousField = document.querySelector('.js-form-anonymous input');

    if (messageSuggestionField && anonymousField && anonymousField.checked) {
        messageSuggestionField.addEventListener('change', function () {
            anonymousField.checked = false;
        });
    }
    if (messageField && anonymousField && anonymousField.checked) {
        messageField.addEventListener('keydown', function () {
            anonymousField.checked = false;
        });
    }
    if (signatureField && anonymousField && anonymousField.checked) {
        signatureField.addEventListener('keydown', function () {
            anonymousField.checked = false;
        });
    }
    if (messageSuggestionField && messageField && signatureField && anonymousField) {
        anonymousField.addEventListener('change', function () {
            if (anonymousField.checked) {
                messageSuggestionField.value = '';
                messageField.value = '';
                signatureField.value = '';
            }
        });
    }

    // AJAX address book address selection
    var selectAddressField = document.querySelector('.js-order-select-address-field');
    if (selectAddressField) {
        var savedAddresses = selectAddressField.querySelectorAll('.js-dropdown-value');
        savedAddresses.forEach(function (savedAddress) {
            savedAddress.addEventListener('click', function () {
                if (savedAddress.dataset.value) {
                    fetch('/select-address/' + savedAddress.dataset.value).then(function (response) {
                        if (response) {
                            response.json().then(function (result) {
                                if (result && result.address) {
                                    prefillAddressFields(result.address);
                                }
                            });
                        }
                    });
                }
            });
        });
    }

    // AJAX planning dropdown select
    var planningDay = document.querySelector('.js-form-planning-day');
    if (planningDay) {
        planningDay.addEventListener('change', function () {
            var form = planningDay.closest('form');
            var formData = new FormData();
            formData.append(planningDay.getAttribute('name'), planningDay.value);
            fetch(form.action, {
                method: form.getAttribute('method'),
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(function (response) {
                return response.text();
            }).then(function (htmlResponse) {
                var htmlDOM = new DOMParser().parseFromString(htmlResponse.toString(), 'text/html');
                checkAndReplaceQuerySelector('.js-form-planning-time-slot', htmlDOM);
            });
        });
    }

    window.addEventListener("load", function () {
        // Add a keyup event listener to zip code input element
        var nameZipCodeInput = document.querySelector('.js-form-autocomplete-recipient-zip-code');
        if (nameZipCodeInput) {
            nameZipCodeInput.addEventListener("keyup", function (event) {
                autocompleteCity(event, document.querySelector('.js-form-autocomplete-results-zip-code'), 'autocomplete-results-zip-code-item', document.querySelector('.js-form-autocomplete-recipient-city'), document.querySelector('.js-form-autocomplete-recipient-zip-code'), 'data-city', 'data-zip-code', false);
            });
        }

        // Add a keyup event listener to city input element
        var nameCityInput = document.querySelector('.js-form-autocomplete-recipient-city');
        if (nameCityInput) {
            nameCityInput.addEventListener("keyup", function (event) {
                autocompleteCity(event, document.querySelector('.js-form-autocomplete-results-city'), 'autocomplete-results-city-item', document.querySelector('.js-form-autocomplete-recipient-zip-code'), document.querySelector('.js-form-autocomplete-recipient-city'), 'data-zip-code', 'data-city', true);
            });
        }

        // create one global XHR object
        // so we can abort old requests when a new one is make
        window.hinterXHR = new XMLHttpRequest();
    });

    var resultsZipCode = document.querySelector('.js-form-autocomplete-results-zip-code');
    var resultsCity = document.querySelector('.js-form-autocomplete-results-city');
    autocompleteMouseLeave(resultsZipCode);
    autocompleteMouseLeave(resultsCity);

    var deliveryTypes = document.querySelectorAll('.js-form-delivery-type');
    var deliveryToGraveCheckbox = document.querySelector('.js-delivery-to-grave-checkbox');
    var planningTimeSlotField = document.querySelector('.js-form-planning-time-slot');
    var recipientNameField = document.querySelector('.js-form-recipient-name');

    if (deliveryToGraveCheckbox) {
        deliveryTypes.forEach(function (deliveryType) {
            var deliveryTypeRadio = deliveryType.querySelector('.js-form-delivery-type-radio');
            if (AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value && deliveryTypeRadio.checked) {
                if (!deliveryToGraveCheckbox.checked) {
                    deliveryToGraveCheckbox.checked = true;
                    checkAndDisplayAccessoryLines();
                }
                changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, true);
            }
            if (planningTimeSlotField && !planningTimeSlotField.value && deliveryTypeRadio.checked) {
                ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio);
            }
            if (deliveryTypeRadio.checked) {
                // change funeral labels for chosen delivery type
                changeFuneralLabel(deliveryTypeRadio.value, 'hour');
                changeFuneralLabel(deliveryTypeRadio.value, 'defunct');
                changeFuneralLabel(deliveryTypeRadio.value, 'address');
                changeFuneralLabel(deliveryTypeRadio.value, 'phone');
                changeFuneralLabel(deliveryTypeRadio.value, 'planning-day-label');
            }

            // check is delivery to grave checked on product page (AQCOM)
            if (deliveryToGraveCheckbox.checked && AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value && !deliveryTypeRadio.checked && !planningTimeSlotField && recipientNameField && !recipientNameField.value) {
                changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, true);
                deliveryTypeRadio.checked = true;
                checkAndChangeClassForDeliveryTypeFields();

                //re-build form with ajax after delivery type change
                ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio);
            }
        });

        deliveryToGraveCheckbox.addEventListener('click', function () {
            changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, true);
        });
    }

    // AJAX planning delivery type select
    if (deliveryTypes) {
        deliveryTypes.forEach(function (deliveryType) {
            deliveryType.addEventListener('click', function () {
                var deliveryTypeRadio = deliveryType.querySelector('.js-form-delivery-type-radio');

                //disable/enable accessory checkboxes
                if (deliveryTypeRadio && deliveryToGraveCheckbox) {
                    deliveryToGraveCheckbox.checked = !!(AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value && deliveryToGraveCheckbox);
                    if (AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value && deliveryToGraveCheckbox) {
                        changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, true);
                    } else {
                        changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, false);
                    }
                }
                checkAndDisplayAccessoryLines();

                // reinitialize date field
                var planningDayLabel = document.querySelector('.js-form-planning-day');
                if (planningDayLabel) {
                    planningDayLabel.value = '';
                }

                // re-build form with ajax after delivery type change
                ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio);

                // update prices
                priceCalcul(currency);
            });

            var deliveryTypeRadio = deliveryType.querySelector('.js-form-delivery-type-radio');
            if (deliveryToGraveCheckbox && AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value) {
                deliveryToGraveCheckbox.addEventListener('click', function () {
                    if (deliveryToGraveCheckbox.checked) {
                        deliveryTypeRadio.checked = true;

                        //re-build form with ajax after delivery type change
                        ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio);

                        // Update Bootstrap radio button style
                        checkAndChangeClassForDeliveryTypeFields();
                    }
                });
            }
        });
    }
}

function zoomAccessoryOrderPage(eventZoom) {
    $(eventZoom).on('show.bs.modal', function (e) {
        var acc = e.relatedTarget;
        var img = $(acc).attr('data-zoom');
        var id = $(acc).attr('data-id');
        // let input= $(acc).parent().parent().prev().find("input[type='checkbox']");
        var input = $("#" + id);

        var txtButton = '';
        var contentHtml = '';

        if ($(input).is(':disabled')) {
            $(eventZoom + ' a').hide();
        } else {
            $(eventZoom + ' a').show();

            $(input).is(':checked') ? txtButton = window.AQUA.PRODUCT.TRANSLATIONS.REMOVE_ACCESSORIES : txtButton = window.AQUA.PRODUCT.TRANSLATIONS.ADD_ACCESSORIES;

            $(eventZoom + ' a').html(txtButton);
        }

        contentHtml += '<img src="' + img + '" width="550" height="550">\n                        <input type="hidden" value="' + $(input).val() + '"/>';

        $(eventZoom + ' .accessory').html(contentHtml);
    });

    $(eventZoom + ' a').on('click', function () {
        var id = $(this).parent().find('input[type="hidden"]').val();
        var input = "input[value='" + id + "'";

        if (id !== undefined && !$(input).is(':disabled')) {
            $(input).trigger('click');
        }

        $(eventZoom).modal('hide');
    });

    $(eventZoom).on('hidden.bs.modal', function () {
        $(eventZoom + ' .accessory').html('');
    });
}

function paymentPage() {

    var $modalValidateVoucherID = $('#modal-validate-voucher');
    var $paymentTypeCardCLass = $('.payment-type-card');
    var $validVoucherPayment = $('#valid-voucher-payment');

    if ($modalValidateVoucherID.length > 0) {
        $modalValidateVoucherID.modal();
    }

    $validVoucherPayment.on('click', function () {
        $modalValidateVoucherID.modal('hide');
    });

    // Payment color
    $paymentTypeCardCLass.on('click', function () {
        $paymentTypeCardCLass.each(function () {
            if ($(this).hasClass('active')) $(this).removeClass('active');
        });
        $(this).toggleClass('active');
    });
}

function loadTemplate(stringJson) {
    var $content = $('#form_order_checkout_message');
    var message = '';

    $.getJSON(stringJson, {
        format: "json"
    }).done(function (data) {
        message = data;
        chargeMessage(message);
    });

    $('#suggestion_mess').on('change', function () {
        var id_mess = $(this).val();
        $content.html(message.message[id_mess]);
        $content.val(message.message[id_mess]);
    });
}

function chargeMessage(data) {
    var category = data.type;
    var selectBox = $('#suggestion_mess');

    $.each(category, function (i) {
        if ((undefined === window.AQUA.FUNERAL_PRODUCT || '' === window.AQUA.FUNERAL_PRODUCT) && 'DEUIL' !== category[i].titre) {
            selectBox.append('<option disabled="disabled" value="-1">-----------------------</option>');
            selectBox.append('<optgroup label="' + category[i].titre + '">');
        }
        if ((undefined === window.AQUA.FUNERAL_PRODUCT || '' === window.AQUA.FUNERAL_PRODUCT) && 'DEUIL' !== category[i].titre || '' !== window.AQUA.FUNERAL_PRODUCT && 'DEUIL' === category[i].titre) {
            var list = category[i].liste;
            $.each(list, function (x) {
                selectBox.append('<option value="' + list[x].i + '">' + list[x].t + '</option>');
            });
            selectBox.append('</optgroup>');
        }
    });
}

function uploadInformationAccordion() {
    var uploadTypes = [{ origin: '.upload-photo__carret', target: '.upload-photo__info' }, { origin: '.upload-video__carret', target: '.upload-video__info' }, { origin: '.accessories-list__carret', target: '.accessories-list__info' }, { origin: '.accessories-list-mobile__carret', target: '.accessories-list-mobile__info' }, { origin: '.total-list__carret', target: '.total-list__info' }];

    uploadTypes.forEach(function (uploadType) {
        return $(uploadType.origin).on('click', function () {
            if ($(this).hasClass('active')) {
                $(uploadType.origin).removeClass('active');
                $(uploadType.target).removeClass('active');
            } else {
                (0, _utils.ufToggleClassElement)('active', [$(this), $(this).attr('data-target')]);
            }
        });
    });
}

function dynamicPriceProductCard() {
    var isProductDIYDynamicPrice = document.querySelector('.js-diy-dynamic-price');
    if (!isProductDIYDynamicPrice) {
        return;
    }

    var products = document.querySelectorAll('.js-component-price');
    var totalProductPrice = document.querySelector('.js-total-diy');
    var productRemoved = document.querySelectorAll('.js-product-remove');

    window.addEventListener('DOMContentLoaded', function () {
        calculProductsPrice(products, totalProductPrice);
    });

    products.forEach(function (productCard) {
        productCard.addEventListener('change', function (event) {
            priceCalcul(window.AQUA.INIT_CURRENCY);
        });
    });

    productRemoved.forEach(function (product) {
        product.addEventListener('click', function (event) {
            var selectedProduct = product.dataset.product;
            var select = document.querySelector(".js-select-" + selectedProduct);
            product.parentElement.dataset.totalPrice = 0;
            product.parentElement.classList.add('hidden');
            select.selectedIndex = 0;
            calculProductsPrice(products, totalProductPrice);
        });
    });
}

function selectsStatutNotification(jsclass) {

    if (jsclass) {
        jsclass.addEventListener('change', function () {
            if (this.value == "") {
                jsclass.classList.remove("select--valid");
                jsclass.classList.add("select--invalid");
            } else {
                jsclass.classList.remove("select--invalid");
                jsclass.classList.add("select--valid");
            }
        });
    }
}

function verifSelectInputStatutNotification() {

    var btnSummit = document.querySelectorAll('.js-button-green');
    btnSummit.forEach(function (elt) {

        elt.addEventListener('click', function (event) {

            var selectsRequired = document.querySelectorAll('select[required]');
            var inputsRequired = document.querySelectorAll('input[required]');

            selectsRequired.forEach(function (selectRequired) {
                selectRequired.value == "" ? selectRequired.classList.add("select--invalid") : null;
            });

            inputsRequired.forEach(function (inputRequired) {
                if (inputRequired.value.length == 0) {
                    inputRequired.classList.add("input--invalid");
                }
            });
        });
    });
}

function inputsStatutNotification() {
    var inputs = document.querySelectorAll("[type='text'][required], [type='tel'], [type='email'] ");
    inputs.forEach(function (elt) {

        elt.addEventListener('input', function (event) {
            event.currentTarget.classList.remove('input--valid', 'input--invalid');
            event.currentTarget.value.length > 0 ? event.currentTarget.classList.add("input--valid") : event.currentTarget.classList.add("input--invalid");
        });

        elt.addEventListener('focusout', function (event) {
            var isValidInput = void 0;
            switch (event.currentTarget.type) {
                case 'text':
                    isValidInput = event.currentTarget.value.length !== 0;
                    break;
                case 'tel':
                    if (window.intlTelInputGlobals) {
                        var iti = window.intlTelInputGlobals.getInstance(event.currentTarget);
                        isValidInput = iti.isValidNumber();
                    }
                    break;
                case 'email':
                    var mailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    isValidInput = mailRegex.test(event.currentTarget.value.toLowerCase());
                    break;
                default:
            }

            event.currentTarget.classList.remove('input--valid', 'input--invalid');
            isValidInput ? event.currentTarget.classList.add("input--valid") : event.currentTarget.classList.add("input--invalid");
        });
    });
}

function ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio) {
    var form = deliveryType.closest('form');
    var formData = new FormData();
    formData.append(deliveryTypeRadio.getAttribute('name'), deliveryTypeRadio.value);
    fetch(form.action, {
        method: form.getAttribute('method'),
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function (response) {
        return response.text();
    }).then(function (htmlResponse) {
        var htmlDOM = new DOMParser().parseFromString(htmlResponse.toString(), 'text/html');
        checkAndReplaceQuerySelector('.js-form-group-planning-time-slot', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-group-funeral-hour', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-title', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-name', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-first-name', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-address', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-additional-address', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-door-code', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-second-door-code', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-stair', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-floor', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-instruction', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-save-address', htmlDOM);

        if (document.querySelector('.js-form-group-recipient-additional-address') && document.querySelector('.js-form-group-recipient-address')) {
            if (AQUA.FUNERAL_DELIVERY_TYPE_RESIDENCE === deliveryTypeRadio.value) {
                document.querySelector('.js-form-group-recipient-address').after(document.querySelector('.js-form-group-recipient-additional-address'));
            } else {
                document.querySelector('.js-form-group-recipient-additional-address').after(document.querySelector('.js-form-group-recipient-address'));
            }
        }

        // change funeral labels for chosen delivery type
        changeFuneralLabel(deliveryTypeRadio.value, 'hour');
        changeFuneralLabel(deliveryTypeRadio.value, 'defunct');
        changeFuneralLabel(deliveryTypeRadio.value, 'address');
        changeFuneralLabel(deliveryTypeRadio.value, 'phone');
        changeFuneralLabel(deliveryTypeRadio.value, 'planning-day-label');

        WoosmapAutocomplete.init();
    });
}

// Autocomplete for form
function autocompleteCity(event, dataList, autoCompleteResultsItemClass, sourceField, destinationField, sourceQualifierName, destinationQualifierName, isCitySource) {

    // retrieve the input element
    var input = event.target;

    // minimum number of characters before we start to generate suggestions
    var minCharacters = 4;

    if (input.value.length >= minCharacters) {

        // abort any pending requests
        window.hinterXHR.abort();

        window.hinterXHR.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {

                // We're expecting a json response so we convert it to an object
                var response = JSON.parse(this.responseText);
                if (dataList) {
                    // clear any previously loaded options in the datalist
                    dataList.innerHTML = "";
                    if (response && response.length > 0) {
                        response.forEach(function (item) {
                            dataList.innerHTML += '<li>' + '<a class="' + autoCompleteResultsItemClass + '" data-city="' + item.name + '" data-zip-code="' + item.zip_code + '">' + (isCitySource ? item.name + ' (' + item.zip_code + ')' : item.zip_code + ' - ' + item.name) + '</a></li>';
                        });
                    }

                    var autocompleteResultsItems = document.querySelectorAll('.' + autoCompleteResultsItemClass);
                    if (autocompleteResultsItems) {
                        autocompleteResultsItems.forEach(function (autocompleteResultsItem) {
                            autocompleteResultsItem.addEventListener('click', function (event) {
                                sourceField.value = autocompleteResultsItem.getAttribute(sourceQualifierName);
                                destinationField.value = autocompleteResultsItem.getAttribute(destinationQualifierName);
                                dataList.style.display = 'none';
                            });
                        });
                    }
                    dataList.style.display = 'block';
                }
            }
        };

        window.hinterXHR.open("GET", "/autocomplete-city/" + input.value, true);
        window.hinterXHR.send();
    }
}

function autocompleteMouseLeave(fieldResults) {
    if (fieldResults) {
        fieldResults.addEventListener("mouseleave", function (event) {
            fieldResults.style.display = 'none';
        }, false);
    }
}

function calculProductsPrice(products, totalProductPrice) {
    var productPrice = 0;

    products.forEach(function (product) {
        productPrice += parseFloat(product.dataset.totalPrice);
    });

    if (totalProductPrice) {
        totalProductPrice.dataset.totalProductPrice = productPrice;
        totalProductPrice.innerHTML = (0, _utils.getFormatedPrice)(window.AQUA.LOCALE, (0, _utils.getCurrency)(window.AQUA.INIT_CURRENCY), parseFloat(productPrice).toFixed(2).replace(".", ","));
        priceCalcul(window.AQUA.INIT_CURRENCY);
    }
}

function changeFuneralLabel(deliveryTypeRadioValue, field) {
    var currentFuneralText = document.querySelector('.js-funeral-' + deliveryTypeRadioValue + '-' + field + '-text');
    var funeralTexts = document.querySelectorAll('.js-funeral-' + field + '-text');
    if (funeralTexts) {
        funeralTexts.forEach(function (funeralText) {
            funeralText.classList.add('hidden');
        });
    }
    if (currentFuneralText) {
        currentFuneralText.classList.remove('hidden');
    }
}

function checkAndChangeClassForDeliveryTypeFields() {
    var deliveryTypeFields = document.querySelectorAll('.js-form-delivery-type');
    deliveryTypeFields.forEach(function (deliveryTypeField) {
        deliveryTypeField.classList.remove('active');
        if (deliveryTypeField) {
            for (var i = 0; i < deliveryTypeField.childNodes.length; i++) {
                if (deliveryTypeField.childNodes[i].checked) {
                    deliveryTypeField.classList.add('active');
                }
            }
        }
    });
}

function checkAndDisplayAccessoryLines() {
    var accessoryLines = document.querySelectorAll(".js-accessory-line");
    accessoryLines.forEach(function (accessoryLine) {
        var accessorySelector = document.querySelector('input[id="accessory-' + accessoryLine.getAttribute('data-accessory-id') + '"]');
        if (undefined !== accessorySelector && accessorySelector.checked) {
            accessoryLine.classList.remove('hidden');
        } else {
            accessoryLine.classList.add('hidden');
        }
    });
}

function checkAndReplaceQuerySelector(selector, htmlDOM) {
    if (document.querySelector(selector) && htmlDOM.querySelector(selector)) {
        // Don't add form error class for ajax field replacement
        var DOMInputElements = htmlDOM.querySelectorAll('input');
        DOMInputElements.forEach(function (DOMInputElement) {
            if (undefined !== DOMInputElement.classList) {
                DOMInputElement.classList.remove('has-error');
            }
        });
        // Replace field
        document.querySelector(selector).replaceWith(htmlDOM.querySelector(selector));
    }
}

function changeCheckboxReadOnlyAttribute(checkbox, isActivated) {
    checkbox.readOnly = isActivated;
    checkbox.labels.forEach(function (label) {
        if (isActivated) {
            label.setAttribute('readOnly', 'readonly');
        } else {
            label.removeAttribute('readOnly');
        }
    });
}

// show hidden schedules block (florist delivery choice page)
function showFloristSchedules() {

    var schedulesBlock = document.querySelector(".js-florist-information-schedules");
    var schedulesBlockHidden = document.querySelector(".js-florist-information-schedules-hidden");

    if (schedulesBlock) {
        schedulesBlock.addEventListener('click', function (event) {
            schedulesBlock.remove();
            schedulesBlockHidden.style.display = "inline";
        });
    }
}

//Florist delivery choice events
function updateFloristDeliveryLocationValue() {
    var floristDeliveryChoiceFormChoices = document.querySelectorAll('.js-florist-delivery-choice-form-choice');
    var floristDeliveryChoiceFormChoiceFlorist = document.querySelector('.js-florist-delivery-choice-form-choice-florist');
    var floristDeliveryChoiceFormDeliveryLocation = document.querySelector('.js-florist-delivery-choice-form-delivery-location');

    if (floristDeliveryChoiceFormChoices && floristDeliveryChoiceFormChoiceFlorist && floristDeliveryChoiceFormDeliveryLocation) {
        floristDeliveryChoiceFormChoices.forEach(function (floristDeliveryChoiceFormChoice) {
            floristDeliveryChoiceFormChoice.addEventListener("click", function () {
                floristDeliveryChoiceFormDeliveryLocation.value = '';
            });
        });
        floristDeliveryChoiceFormDeliveryLocation.addEventListener("change", function () {
            floristDeliveryChoiceFormChoiceFlorist.checked = true;
        });
    }
}

// prefill address fields after saved address selection
function prefillAddressFields(address) {
    var titleBlock = document.querySelector('.js-form-recipient-title');
    if (titleBlock && address.civility && address.civility.id) {
        var titleInputFields = titleBlock.querySelectorAll('[type="radio"]');
        titleInputFields.forEach(function (titleInputField) {
            titleInputField.checked = titleInputField.value === address.civility.id.toString();
        });
    }
    var nameField = document.querySelector('.js-form-recipient-name');
    if (nameField) {
        nameField.value = address.name;
    }
    var firstnameField = document.querySelector('.js-form-recipient-first-name');
    if (firstnameField) {
        firstnameField.value = address.first_name;
    }
    var companyField = document.querySelector('.js-form-recipient-company');
    if (companyField) {
        companyField.value = address.society;
    }
    var addressField = document.querySelector('.js-form-recipient-address');
    if (addressField) {
        addressField.value = address.address_line1;
    }
    var additionalAddressField = document.querySelector('.js-form-recipient-additional-address');
    if (additionalAddressField) {
        additionalAddressField.value = address.address_line2;
    }
    var zipCodeField = document.querySelector('.js-form-autocomplete-recipient-zip-code');
    if (zipCodeField) {
        zipCodeField.value = address.zip_code;
    }
    var cityField = document.querySelector('.js-form-autocomplete-recipient-city');
    if (cityField) {
        cityField.value = address.city;
    }
    var doorCodeField = document.querySelector('.js-form-recipient-door-code-input');
    if (doorCodeField) {
        doorCodeField.value = address.door_code1;
    }
    var secondDoorCodeField = document.querySelector('.js-form-recipient-second-door-code-input');
    if (secondDoorCodeField) {
        secondDoorCodeField.value = address.door_code2;
    }
    var stairField = document.querySelector('.js-form-recipient-stair-input');
    if (stairField) {
        stairField.value = address.staircase;
    }
    var floorField = document.querySelector('.js-form-recipient-floor-input');
    if (floorField) {
        floorField.value = address.floor;
    }
    var phoneField = document.querySelector('.js-form-recipient-phone');
    if (phoneField) {
        phoneField.value = address.phone;
    }
}

function checkAndDisplayServiceTotalLine() {
    if (document.querySelector('[data-switch="services-price"]')) {
        var servicesPrice = 0;

        document.querySelectorAll('.js-service').forEach(function (service) {
            if (service.checked && service.dataset.accPrice > 0) {
                servicesPrice = servicesPrice + parseFloat(service.dataset.accPrice);
            }
        });

        var parentNode = (0, _utils.getParentNode)(document.querySelector('[data-switch="services-price"]'), 'table-summary-line');
        if (parentNode !== false) {
            if (servicesPrice === 0) {
                parentNode.style.display = "none";
            } else {
                parentNode.style.display = "table";
            }
        }
    }
}

function updateProductQuantityOnOrderPage() {
    function updateQuantity(element, increment) {
        var productListElement = element.closest('.js-order-checkout-product-list-item');
        var inputQuantity = productListElement.querySelector('.js-product-quantity');
        var textQuantity = productListElement.querySelector('.js-order-product-quantity');
        var addProductButton = productListElement.querySelector('.js-add-product');
        var removeProductButton = productListElement.querySelector('.js-remove-product');

        var currentQuantity = parseInt(inputQuantity.value, 10);
        var max = parseInt(inputQuantity.getAttribute('max'), 10);
        var min = parseInt(inputQuantity.getAttribute('min'), 10);

        currentQuantity += increment ? 1 : -1;

        addProductButton.classList.remove('quantity-button--disabled');
        removeProductButton.classList.remove('quantity-button--disabled');

        if (currentQuantity >= max) {
            currentQuantity = max;
            addProductButton.classList.add('quantity-button--disabled');
        } else if (currentQuantity <= min) {
            removeProductButton.classList.add('quantity-button--disabled');
            currentQuantity = min;
        }

        inputQuantity.value = currentQuantity;
        textQuantity.innerText = currentQuantity.toString();
        textQuantity.dataset.productQuantity = currentQuantity;

        inputQuantity.dispatchEvent(new Event('change'));
    }
    document.querySelectorAll('.js-add-product').forEach(function (button) {
        button.addEventListener('click', function () {
            updateQuantity(this, true);
        });
    });

    document.querySelectorAll('.js-remove-product').forEach(function (button) {
        button.addEventListener('click', function () {
            updateQuantity(this, false);
        });
    });
}

function updateAccessoryQuantityOnOrderPage() {
    function updateQuantity(element, increment) {
        var accessoryListElement = element.closest('.js-order-checkout-accessory-list-item');
        var inputQuantity = accessoryListElement.querySelector('.js-accessory-quantity');
        var textQuantity = accessoryListElement.querySelector('.js-order-accessory-quantity');
        var addAccessoryButton = accessoryListElement.querySelector('.js-add-accessory');
        var accessorySingleAddButton = accessoryListElement.querySelector('.js-accessory-single-add-button');
        var accessoryButtons = accessoryListElement.querySelector('.js-accessory-buttons');

        var currentQuantity = parseInt(inputQuantity.value, 10);
        var max = parseInt(inputQuantity.getAttribute('max'), 10);
        var min = parseInt(inputQuantity.getAttribute('min'), 10);

        currentQuantity += increment ? 1 : -1;
        accessoryListElement.classList.add('selected');

        if (!increment) {
            addAccessoryButton.classList.remove('quantity-button--disabled');
        }

        if (currentQuantity >= max) {
            currentQuantity = max;
            addAccessoryButton.classList.add('quantity-button--disabled');
        } else if (currentQuantity <= min) {
            currentQuantity = min;
            accessoryListElement.classList.remove('selected');
            accessoryButtons.classList.add('hidden');
            accessorySingleAddButton.classList.remove('hidden');
        } else {
            accessoryButtons.classList.remove('hidden');
            accessorySingleAddButton.classList.add('hidden');
        }

        inputQuantity.value = currentQuantity;
        inputQuantity.dispatchEvent(new Event('click'));
        textQuantity.textContent = currentQuantity.toString();
    }

    document.querySelectorAll('.js-add-accessory').forEach(function (button) {
        button.addEventListener('click', function () {
            updateQuantity(this, true);
        });
    });

    document.querySelectorAll('.js-remove-accessory').forEach(function (button) {
        button.addEventListener('click', function () {
            updateQuantity(this, false);
        });
    });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{"./utils":9,"jquery":16}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.displayAccessoryModeModal = displayAccessoryModeModal;
exports.addAccessoryWithTheModal = addAccessoryWithTheModal;
exports.addAccessoryWithTheCheckbox = addAccessoryWithTheCheckbox;
exports.editFreePrice = editFreePrice;
exports.clickOnAnAccessory = clickOnAnAccessory;
exports.changePriceButtonRadioProduct = changePriceButtonRadioProduct;
exports.changePriceButtonCardProduct = changePriceButtonCardProduct;
exports.changePriceSelectProductMobile = changePriceSelectProductMobile;
exports.changeSizeSelectProduct = changeSizeSelectProduct;
exports.changeQuantitySelectProduct = changeQuantitySelectProduct;
exports.tabsDescriptionProduct = tabsDescriptionProduct;
exports.tabsInfosProduct = tabsInfosProduct;
exports.tableGiftBoxProduct = tableGiftBoxProduct;
exports.toggle = toggle;
exports.calculPriceProductPage = calculPriceProductPage;
exports.changeQuantityForIOS = changeQuantityForIOS;
exports.showMoreProduct = showMoreProduct;
exports.productCardDIY = productCardDIY;
exports.modalProductCard = modalProductCard;
exports.fixedDIYLeftSection = fixedDIYLeftSection;
exports.initializeCarousels = initializeCarousels;

var _utils = require("./utils");

var _order = require("./order");

var _slider = require("../components/slider");

if (window.jQuery === undefined) {
    window.jQuery = window.$ = require('jquery');
}

function displayAccessoryModeModal(element) {
    $(element).on('show.bs.modal', function (e) {
        var $blockClass = $('.fixed-order-block');
        var accessory = e.relatedTarget;
        $blockClass.removeClass('visible-xs-block');
        $blockClass.addClass('hide');
        var descr = $(accessory).prev().find('p').html();
        var img = $(accessory).prev().find('.zoom-hover img').attr('src');
        var imgSrcset = $(accessory).prev().find('.zoom-hover img').attr('srcset');
        var imgSizes = $(accessory).prev().find('.zoom-hover img').attr('sizes');
        var c_acc = $(accessory).attr('data-accessoire');
        var modalAction = '#modal-info-accessoire .modal-body a';
        var modalAccessory = '#modal-info-accessoire .modal-body .accessoire';
        var txtButton = '';
        var contentHtml = '';

        $(accessory).parent().find('input[type="checkbox"]').is(':disabled') ? $(modalAction).hide() : $(modalAction).show();

        $('article[data-accessoire="' + c_acc + '"]').hasClass('active') ? txtButton = window.AQUA.PRODUCT.TRANSLATIONS.REMOVE_ACCESSORIES : txtButton = window.AQUA.PRODUCT.TRANSLATIONS.ADD_ACCESSORIES;

        contentHtml += "<p>" + descr + "</p>\n                <img src=\"" + img + "\" srcset=\"" + imgSrcset + "\" sizes=\"" + imgSizes + "\" width=\"250\" height=\"250\">\n                <input type=\"hidden\" name=\"c_acc\" value=\"" + c_acc + "\">";

        $(modalAccessory).html(contentHtml);
        $(modalAction).html(txtButton);
        $(modalAction).attr('data-item-id', c_acc);
    });
}

function addAccessoryWithTheModal(element, modal) {
    $(element).on("click", function () {
        var accessory = $('input[name="c_acc"]').val();
        $('article[data-accessoire="' + accessory + '"]').find('.hover-accessoire').trigger('click');
        $(modal).modal('hide');
    });
}

function addAccessoryWithTheCheckbox(element) {
    $(element).on('click', function () {
        (0, _utils.ufToggleClassElement)('active', $(this).parent().parent());
        calculPriceProductPage();
    });
}

function editFreePrice(element) {
    $(element).on('input', function () {
        calculPriceProductPage();
    });
}

function clickOnAnAccessory(element) {
    $(element).on('click', function () {
        var input = $(this).parent().find('input');

        if (!input.is(':disabled')) {
            (0, _utils.ufToggleClassElement)('active', $(this).parent().parent());

            input.is(':checked') ? input.prop('checked', false) : input.prop('checked', true);

            calculPriceProductPage();
        }
    });
}

function changePriceButtonRadioProduct(elementRadio, elementSelect) {
    $(elementRadio).on('change', function () {
        var price_selected = $(this).val();

        $(elementSelect).each(function () {
            $(this).removeAttr('selected');
            if ($(this).val() === price_selected) {
                $(this).prop('selected', 'selected');
            }
        });

        calculPriceProductPage();
    });
}

function changePriceButtonCardProduct(elementRadio, elementSelect) {
    $(elementRadio).on('click', function () {
        setTimeout(function () {
            calculPriceProductPage();
        }, 100);
    });
}

function changePriceSelectProductMobile(elementSelect, elementRadio, elementDesktopSelect) {
    $(elementSelect).on('change', function () {
        var price_selected = $(this).val();

        // For the button radio !
        $(elementRadio).each(function () {
            $(this).removeAttr('checked');
            if ($(this).val() === price_selected) {
                $(this).prop('checked', 'checked');
            }
        });
        $(elementDesktopSelect).each(function () {
            $(this).removeAttr('selected');
            if ($(this).val() === price_selected) {
                $(this).prop('selected', 'selected');
            }
        });

        calculPriceProductPage();
    });
}

function changeSizeSelectProduct(elementSelect) {
    $(elementSelect).on('change', function () {
        calculPriceProductPage();
    });
}

function changeQuantitySelectProduct(elementSelect) {
    $(elementSelect).on('change', function () {
        calculPriceProductPage();
    });
}

function tabsDescriptionProduct() {
    // Init
    var ongletClass = ".infos-product .onglet div";
    var txtClass = ".infos-product .txt div";
    var ongletMobileClass = ".description-mob div .onglet";

    //Desktop
    $(ongletClass).on('click', function () {
        $(ongletClass).removeClass('active');
        $(txtClass).removeClass('active');
        (0, _utils.ufToggleClassElement)('active', [$(this), $(this).attr('data-target')]);
    });

    //Phone
    $(ongletMobileClass).click(function () {
        (0, _utils.ufToggleClassElement)('active', [$(this).parent()]);
    });
}

function tabsInfosProduct(title, content) {

    var tabletbreakpoint = 768;

    title = document.querySelector(title);
    content = document.querySelector(content);

    if (title && content) {
        if (screen.width <= tabletbreakpoint) {
            title.classList.remove('active');
            content.classList.remove('active');
        }

        title.addEventListener("click", function () {
            if (title.classList.contains('active')) {
                title.classList.remove('active');
                content.classList.remove('active');
            } else {
                title.classList.add('active');
                content.classList.add('active');
            }
        });
    }
}

function tableGiftBoxProduct(element) {
    if ($(element).length > 0) {
        $(element).dataTable({
            'info': false,
            'lengthMenu': [[5, 10, 25, -1], [5, 10, 25, "All"]],
            'pageLength': 25,
            'order': [2, 'asc'],
            'columnDefs': [{ 'orderable': false, 'searchable': false, 'targets': [0, 1] }],
            'language': {
                search: window.AQUA.SORTTABLE_TRANSLATE.SEARCH,
                lengthMenu: window.AQUA.SORTTABLE_TRANSLATE.LENGTH_MENU,
                paginate: {
                    first: window.AQUA.SORTTABLE_TRANSLATE.PAGINATE.FIRST,
                    previous: window.AQUA.SORTTABLE_TRANSLATE.PAGINATE.PREVIOUS,
                    next: window.AQUA.SORTTABLE_TRANSLATE.PAGINATE.NEXT,
                    last: window.AQUA.SORTTABLE_TRANSLATE.PAGINATE.LAST
                }
            }
        });
    }
}

function toggle(card, btnIcon, block) {
    $(card).on('click', function (e) {
        e.preventDefault();

        var $cardWrapper = $(block);
        var $icon = $(btnIcon);
        var $display = $cardWrapper.css("display");

        if ($display === "none") {
            $cardWrapper.css('display', 'block');
            $icon.toggleClass('fa-chevron-up fa-times');
        } else {
            $cardWrapper.css('display', 'none');
            $icon.toggleClass('fa-times fa-chevron-up');
        }
    });
}

function calculPriceProductPage() {
    var rootElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.product-page';

    if (!document.querySelector(rootElement)) {
        return;
    }

    var productPrice = void 0;
    var accessoryPrice = parseFloat(0);
    var selectElement = void 0;

    if (document.querySelector('.product-prices-select-js')) {
        selectElement = document.querySelector('.product-prices-select-js');
    } else {
        selectElement = document.getElementById('form_product_product_size');
    }

    var quantityElement = document.getElementById('form_product_quantity');
    var quantitySelected = quantityElement ? quantityElement.value : 1;
    var currency = (0, _utils.getCurrency)(window.AQUA.INIT_CURRENCY);

    if (selectElement) {
        var selectedOption = selectElement.options[selectElement.selectedIndex];
        if (selectedOption) {
            productPrice = selectedOption.getAttribute('data-price');
            // If the price is 0, we check whether it is the ‘Prix libre’ option.
            if (productPrice === "0") {
                var freePriceElement = document.getElementById('form_product_product_free_price');
                var freePrice = freePriceElement ? freePriceElement.value : "0";
                productPrice = freePrice || "0";
            }
        } else {
            productPrice = selectElement.getAttribute('data-price') || "0";
        }
    } else {
        var radioSelected = document.getElementsByName('form_product[product_size_radio]');
        for (var i = 0, l = radioSelected.length; i < l; i++) {
            if (radioSelected[i].checked) {
                if (radioSelected[i].value === "0") {
                    // If it is the ‘Prix libre’ option, we retrieve the value from the text input
                    var _freePriceElement = document.getElementById('form_product_product_free_price');
                    productPrice = _freePriceElement ? _freePriceElement.value : "0";
                } else {
                    productPrice = radioSelected[i].dataset.price;
                }
                break;
            }
        }
    }

    var checkedCheckboxes = document.querySelectorAll('article .checkbox:checked');
    for (var _i = 0; _i < checkedCheckboxes.length; _i++) {
        var article = checkedCheckboxes[_i].closest('article');
        accessoryPrice += parseFloat(article.getAttribute('data-price') || 0);
    }

    var totalPrice = parseFloat(productPrice) * parseFloat(quantitySelected) + parseFloat(accessoryPrice);

    displayPrice(totalPrice, currency);
}

function displayPrice(totalPrice, currency) {
    var formatedPrice = parseFloat(totalPrice).toFixed(2).replace(".", ",");
    var formatedPriceWithCurrency = (0, _utils.getFormatedPrice)(window.AQUA.LOCALE, currency, formatedPrice);

    if (0 === totalPrice) {
        $('.js-total-mob span').html('');
        $('.js-total-desktop span').html('');
        $('.product__btn--order').each(function () {
            this.disabled = true;
        });
    } else {
        $('.js-total-mob span').html(formatedPriceWithCurrency);
        $('.js-total-desktop span').html(formatedPriceWithCurrency);
        $('.product__btn--order').each(function () {
            this.disabled = false;
        });
    }
}

function changeQuantityForIOS() {
    if ((0, _utils.isIOS)()) {
        if (document.getElementById('form_product_quantity')) {
            document.getElementById('form_product_quantity').classList.add('ios');
        }
    }
}

function showMoreProduct() {
    var hiddenProduct = document.querySelectorAll('.js-hidden-product');
    var btnShowMore = document.querySelector('.js-show-more');

    if (btnShowMore) {
        btnShowMore.addEventListener('click', function (event) {
            var btnShowMoreText = btnShowMore.innerText;
            btnShowMore.innerText = btnShowMore.dataset.productShowTextToggle;
            btnShowMore.dataset.productShowTextToggle = btnShowMoreText;

            hiddenProduct.forEach(function (element) {
                element.classList.toggle('hidden');
            });
        });
    }
}

function productCardDIY(rootElement) {
    if (!document.querySelector(rootElement)) {
        return;
    }

    var productCard = document.querySelectorAll('.js-product-card');
    var accessoryDiy = document.querySelectorAll('.js-accessory-diy .checkbox');

    productCard.forEach(function (element) {
        calculPriceDIYProductPage(element);
        element.addEventListener('change', function () {
            return calculPriceDIYProductPage(element);
        });
    });

    accessoryDiy.forEach(function (accessory) {
        accessory.addEventListener('change', function () {
            return totalProductDIY();
        });
    });

    function calculPriceDIYProductPage(element) {
        var product = element.value.split(":")[0];

        var quantity = parseFloat(element.value.split(":")[1]);
        var selectedProduct = document.querySelector('[data-product="' + product + '"]');
        var priceComponent = parseFloat(selectedProduct.dataset.price);
        if (0 !== quantity && selectedProduct.classList.contains('js-border-quantity')) {
            selectedProduct.classList.add("product-card__selected");
        } else {
            document.querySelector('[data-product="' + product + '"]').classList.remove("product-card__selected");
        }
        selectedProduct.dataset.totalPrice = priceComponent * quantity;
        totalProductDIY();

        var summaryProductAmout = document.querySelector('.product-data .value[data-attr="summary-product-amount"]');
        if (summaryProductAmout) {
            (0, _order.priceCalculOALR)(window.AQUA.INIT_CURRENCY);
        }

        //Summary sticky block update
        var summaryProductQuantityValues = document.querySelectorAll('.js-component-data-quantity-' + product);
        var summaryProductPriceBlocks = document.querySelectorAll('.js-component-price-' + product);

        summaryProductQuantityValues.forEach(function (summaryProductQuantity) {
            summaryProductQuantity.innerHTML = quantity.toFixed();
        });

        summaryProductPriceBlocks.forEach(function (summaryProductPriceBlock) {
            if (summaryProductPriceBlock) {
                if (quantity > 0) {
                    summaryProductPriceBlock.style.display = 'flex';
                } else {
                    summaryProductPriceBlock.style.display = 'none';
                }
            }
        });
    }

    function totalProductDIY() {
        var componentPrice = document.querySelectorAll('.js-component-price');
        var productPrice = 0;

        var totalPrice = document.querySelector(".js-total-diy");
        var totalPriceMobile = document.querySelector(".js-total-diy-mobile");
        componentPrice.forEach(function (element) {
            productPrice += parseFloat(element.dataset.totalPrice);
            totalPrice.dataset.totalProductPrice = productPrice;
            totalPrice.dataset.value = productPrice;
        });

        if (productPrice !== 0) {
            productPrice += getAccesoriesPrice();
            totalPrice.dataset.totalProductPrice = productPrice;
            totalPrice.dataset.value = productPrice;
        }

        totalPrice.innerHTML = (0, _utils.getFormatedPrice)(window.AQUA.LOCALE, (0, _utils.getCurrency)(window.AQUA.INIT_CURRENCY), parseFloat(productPrice).toFixed(2).replace(".", ","));
        if (totalPriceMobile) {
            totalPriceMobile.innerHTML = totalPrice.innerHTML;
        }

        toggleOrder(productPrice);
    }

    function toggleOrder(productPrice) {
        var productOrderButton = document.querySelectorAll('.js-product-btn-order');
        if (productPrice === 0) {
            productOrderButton.forEach(function (element) {
                element.disabled = true;
            });
        } else {
            productOrderButton.forEach(function (element) {
                element.disabled = false;
            });
        }
    }

    function getAccesoriesPrice() {
        var accessoriesDiy = document.querySelectorAll('.js-accessory-diy .checkbox');
        var price = 0;
        accessoriesDiy.forEach(function (accessory) {
            if (accessory.checked) {
                price += parseFloat(accessory.dataset.accessoryAmount);
            }
        });
        return price;
    }
}

function modalProductCard() {
    var modal = document.querySelector(".js-modal");
    var images = document.querySelectorAll(".js-image");
    var modalImg = document.querySelector(".js-modal-image");
    var captionText = document.querySelector(".js-caption");

    images.forEach(function (img) {
        img.addEventListener('click', function (event) {
            modal.style.display = "block";
            modalImg.src = img.dataset.imgModal ? img.dataset.imgModal : img.src;
            captionText.innerHTML = img.alt;
        });
    });

    var span = document.getElementsByClassName("close-modal-diy")[0];

    if (modal) {
        modal.addEventListener('click', function (event) {
            modal.style.display = "none";
        });
    }
    if (span) {
        span.addEventListener('click', function (event) {
            span.onclick = function () {
                modal.style.display = "none";
            };
        });
    }
}

function fixedDIYLeftSection() {
    var maxWitdh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1200;

    if (window.screen.width < maxWitdh) {
        return;
    }
    window.onresize = fixedDIYLeftSection;
    var diyProductList = document.querySelector('.diy-product-list');
    var diyProductLeft = document.querySelector('.diy-product__left');
    var diyProductRight = document.querySelector('.diy-product__right');
    var mainImage = document.querySelector('.main-image');

    if (!diyProductList || !diyProductLeft || !diyProductRight || !mainImage) {
        return;
    }

    var diyProductListOffsetTop = diyProductList.offsetTop;
    var diyProductLeftOffsetTop = diyProductLeft.offsetTop;
    var mainImageHeight = mainImage.offsetHeight;

    window.addEventListener('scroll', function (e) {
        var diyProductListHeight = diyProductList.offsetHeight;
        var scrollY = window.scrollY;

        diyProductRight.classList.remove('fixed');
        diyProductLeft.classList.remove('fixed');

        if (scrollY > diyProductLeftOffsetTop) {
            diyProductLeft.classList.remove('absolute');
            diyProductLeft.classList.add('fixed');
            diyProductLeft.style.top = "0";
            diyProductRight.classList.add('fixed');
        }

        if (scrollY + mainImageHeight > diyProductListOffsetTop + diyProductListHeight) {
            diyProductLeft.classList.remove('fixed');
            diyProductLeft.classList.add('absolute');
            diyProductRight.classList.add('fixed');
            diyProductLeft.style.top = diyProductListOffsetTop + diyProductListHeight - mainImageHeight + "px";
        }
    });
}
function initializeCarousels() {
    (0, _slider.initializeCarousel)('.suggested-products-slider', 4, 100000, {
        1024: {
            perView: 3,
            gap: 10
        },
        768: {
            perView: 2,
            gap: 10
        },
        480: {
            perView: 1.5,
            gap: 10
        }
    }, true);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{"../components/slider":7,"./order":5,"./utils":9,"jquery":16}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initializeCarousel = initializeCarousel;

var _glide = require('@glidejs/glide');

var _glide2 = _interopRequireDefault(_glide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializeCarousel(elementSelector, perView) {
    var autoplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var breakpoints = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var customControl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;


    var element = document.querySelector(elementSelector);
    var slidesToDisplay = perView;
    if (element) {
        var slides = element.querySelector('.glide__slides').children;
        var numOfSlides = slides.length;
        slidesToDisplay = numOfSlides > perView ? perView : numOfSlides;
    }

    if (document.querySelector(elementSelector)) {
        var glide = new _glide2.default(elementSelector, {
            type: 'carousel',
            focusAt: 0,
            perView: slidesToDisplay,
            animationDuration: 400,
            gap: 20,
            rewindDuration: 0,
            autoplay: false,
            startAt: 0,
            breakpoints: breakpoints
        });
        glide.mount();

        if (customControl) {
            var glideArrowLeft = document.querySelector('.glide__arrow-wrap--prev');
            var glideArrowRight = document.querySelector('.glide__arrow-wrap--next');
            glideArrowLeft.addEventListener('click', function () {
                glide.go('<');
            });

            glideArrowRight.addEventListener('click', function () {
                glide.go('>');
            });
        }
    }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{"@glidejs/glide":11}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initIntlTelInput = initIntlTelInput;

var _intlTelInput = require('intl-tel-input');

var _intlTelInput2 = _interopRequireDefault(_intlTelInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Phone Form plugin
 * @param element
 * @param country
 */
function initIntlTelInput(element, country) {

    var phoneFields = element;
    var iti = (0, _intlTelInput2.default)(phoneFields, {
        initialCountry: country,
        nationalMode: true,
        autoPlaceholder: "off",
        excludeCountries: ['AS', 'VI', 'TC', 'TT', 'SX', 'VC', 'LC', 'KN', 'MP', 'MS', 'GD', 'DM', 'KY', 'VG', 'BM', 'BS', 'AG', 'AI'],
        preferredCountries: ['FR', 'GB', 'US', 'DE', 'ES', 'BE', 'NL', 'LU'],
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.2/js/utils.js'
    });

    var appendDialCodeIfNeeded = function appendDialCodeIfNeeded() {
        if (iti.getSelectedCountryData().iso2.toUpperCase() !== country) {
            if (phoneFields.value.length === 0 && !phoneFields.value.includes('+')) {
                phoneFields.value = '+' + iti.getSelectedCountryData().dialCode + iti.getNumber();
            }
        } else {
            phoneFields.value = '';
        }
    };

    setTimeout(function () {
        if (iti.getSelectedCountryData().iso2.toUpperCase() !== country) {
            appendDialCodeIfNeeded();
        }

        var phoneFieldsAttributeValue = phoneFields.getAttribute('value');
        if (phoneFieldsAttributeValue !== null && phoneFields.value !== phoneFieldsAttributeValue && phoneFieldsAttributeValue.includes('+' + iti.getSelectedCountryData().dialCode) && !phoneFields.value.includes('+')) {
            phoneFields.value = phoneFields.getAttribute('value');
        }
    }, 1000);

    phoneFields.addEventListener('countrychange', appendDialCodeIfNeeded);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{"intl-tel-input":15}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toTop = toTop;
exports.dropdownMenu = dropdownMenu;
exports.headerFixed = headerFixed;
exports.initBanner = initBanner;
exports.getFormatedPrice = getFormatedPrice;
exports.getCurrency = getCurrency;
exports.getSeparator = getSeparator;
exports.hasScrollToTop = hasScrollToTop;
exports.popitup = popitup;
exports.backToTop = backToTop;
exports.changePlaceholderAndLabelForTheLogin = changePlaceholderAndLabelForTheLogin;
exports.toggleLoginPlaceholderAndLabel = toggleLoginPlaceholderAndLabel;
exports.closeModal = closeModal;
exports.zoomModalPhoto = zoomModalPhoto;
exports.zoomModalMultiPhotos = zoomModalMultiPhotos;
exports.loadProductSameday = loadProductSameday;
exports.ufToggleClassElement = ufToggleClassElement;
exports.thumbnailProduct = thumbnailProduct;
exports.selectSizeCustomByRadio = selectSizeCustomByRadio;
exports.clickOnCatalogMobileProduct = clickOnCatalogMobileProduct;
exports.lazyLoadingImg = lazyLoadingImg;
exports.isIOS = isIOS;
exports.clickOnCheckboxInputReadOnly = clickOnCheckboxInputReadOnly;
exports.getParentNode = getParentNode;

var _cookieconsent = require('cookieconsent');

var _cookieconsent2 = _interopRequireDefault(_cookieconsent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

if (window.jQuery === undefined) {
    window.jQuery = window.$ = require('jquery');
}
function toTop(element) {
    if ($(element).length) {
        var scrollTrigger = 300,
            // px
        _backToTop = function _backToTop() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
                $(element).addClass('show');
            } else {
                $(element).removeClass('show');
            }
        };

        _backToTop();
        $(window).on('scroll', function () {
            _backToTop();
        });

        $(element).on('click', function () {
            $('html,body').animate({
                scrollTop: 0
            }, 700);
        });
    }
}

function dropdownMenu() {
    $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).parent().siblings().removeClass('open');
        $(this).parent().toggleClass('open');
    });
    $('.js-dropdown-last-item>a').on('click', function () {
        var $el = $(this);
        if ($el.length && $el.attr('href')) {
            location.href = $el.attr('href');
        }
    });
}

function headerFixed() {
    var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var headerFixed = document.querySelector('.js-header-fixed');
    var body = document.querySelector('.js-body');

    if (enabled && headerFixed) {
        window.addEventListener('scroll', function () {
            var headerHeight = headerFixed.offsetHeight;

            if (window.scrollY > 0) {
                headerFixed.classList.add('header-fixed');
                body.style.paddingTop = headerHeight + 'px';
            } else {
                headerFixed.classList.remove('header-fixed');
                body.style.paddingTop = '';
            }
        });
    }
}

function initBanner() {
    window.cookieconsent.initialise({
        "theme": "aqua",
        "position": "bottom-right",
        "content": {
            "message": window.AQUA.BANNER_MESSAGE,
            "dismiss": window.AQUA.BANNER_DISMISS,
            "link": window.AQUA.BANNER_LINK,
            "href": window.AQUA.BANNER_HREF
        },
        "cookie": {
            "domain": window.AQUA.BANNER_DOMAIN
        }
    });
}

function getFormatedPrice(locale, currency, price) {
    if (locale === 'en') {
        return window.AQUA.PARTNER === '12' ? getFormatedPriceOalr(price, currency) : currency + price;
    } else {
        return price + '\xa0' + currency;
    }
}

function getFormatedPriceOalr(price, currency) {
    var priceSplited = price.replace(',', '.').split('.');
    return '<span class="format-price">' + currency + priceSplited[0] + '</span>';
}

function getCurrency(initCurrency) {
    var currency = '';
    if (initCurrency === 'EUR') {
        currency = '€';
    } else if (initCurrency === 'CHF') {
        currency = 'CHF';
    } else if (initCurrency === 'USD') {
        currency = '$';
    } else if (initCurrency === 'GBP') {
        currency = 'GBP';
    }

    return currency;
}

function getSeparator(initCurrency) {
    var separator = '';
    if (initCurrency === 'EUR') {
        separator = ',';
    } else if (initCurrency === 'CHF') {
        separator = ',';
    } else if (initCurrency === 'USD') {
        separator = '.';
    } else if (initCurrency === 'GBP') {
        separator = '.';
    }

    return separator;
}

function hasScrollToTop() {
    $('.navigation a').on('click', function () {
        var page = $(this).attr('href');
        var speed = 750;
        $('html, body').animate({ scrollTop: $(page).offset().top }, speed);
        return false;
    });
}

function popitup(url) {
    var newWindow = window.open(url, 'name', 'height=600,width=500');
    if (window.focus) {
        newWindow.focus();
    }
    return false;
}

function backToTop(element) {
    if ($(element).length) {
        var scrollTrigger = 300,
            // px
        _backToTop2 = function _backToTop2() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
                $(element).addClass('show');
            } else {
                $(element).removeClass('show');
            }
        };

        _backToTop2();
        $(window).on('scroll', function () {
            _backToTop2();
        });

        $(element).on('click', function () {
            $('html,body').animate({
                scrollTop: 0
            }, 700);
        });
    }
}

function changePlaceholderAndLabelForTheLogin() {

    var $label = $('.connect-form .username-label-js');
    var $input = $('.connect-form #username');
    var $inputMobile = $('.connect-form #mobile-username');
    var $Registerbtn = $('.js-register-account-btn');
    var $resetPasswordLink = $('.js-reset-password-link');
    var hrefResetPasswordLink = $resetPasswordLink.attr('href');

    $('input:radio[name=_type]').on('change', function () {
        changeLoginLabel(this, $label, $input, $inputMobile);
        changeRegisterButton(this, $Registerbtn);
        changeResetPassword(this, $resetPasswordLink, hrefResetPasswordLink);
    });

    if (location.href.split('?')[1] !== undefined && location.href.split('?')[1] === 'mode=register') {
        $("button[data-target='#modal-create-account']").trigger('click');
    }

    $('input:radio[name=_type][checked]').each(function () {
        changeLoginLabel(this, $label, $input, $inputMobile);
    });
}

function toggleLoginPlaceholderAndLabel(forms) {
    forms.forEach(function (form) {
        var usernameLabel = $(form.querySelector('.username-label-js'));
        var usernameInput = $(form.querySelector('.username-input-js'));

        [].concat(_toConsumableArray(form.querySelectorAll('input[type=radio][name=_type]'))).forEach(function (input) {
            input.addEventListener('change', function (event) {
                changeLoginLabel(input, usernameLabel, usernameInput, usernameInput);
            });

            if (input.checked) {
                changeLoginLabel(input, usernameLabel, usernameInput, usernameInput);
            }
        });
    });
}

function closeModal(element) {
    $(element).on('click', function () {
        ufToggleClassElement('active', [$(this).parent()]);
    });
}

function zoomModalPhoto() {
    var modalPhoto = document.querySelector('.js-modal-photo');
    var modalPhotoZoom = document.querySelector('.js-modal-photo-zoom');
    var modalClosePhoto = document.querySelector('.js-modal-photo-close');

    if (modalPhoto && modalPhotoZoom && modalClosePhoto) {
        modalPhoto.addEventListener('click', function () {
            modalPhotoZoom.style.display = "block";
            modalPhotoZoom.classList.add("in");
        });
        modalClosePhoto.addEventListener("click", function () {
            modalPhotoZoom.style.display = "none";
        });
    }
}

function zoomModalMultiPhotos() {
    var modalPhotos = document.querySelectorAll('.js-modal-multi-photo');
    var modalPhotoZoom = document.querySelector('.js-modal-multi-photo-zoom');
    var modalClosePhoto = document.querySelector('.js-modal-multi-photo-close');
    var modalImg = document.querySelector('.js-modal-multi-photo-zoom .resume-order__img');

    if (modalPhotos) {
        modalPhotos.forEach(function (modalPhoto, iteration) {
            var modalPhotoId = modalPhoto.dataset.photoId;
            modalPhoto.addEventListener('click', function () {
                if (iteration > 0) {
                    modalImg.src = modalImg.src.replace('.jpg', '-' + modalPhotoId + '.jpg');
                }
                modalPhotoZoom.style.display = "block";
                modalPhotoZoom.classList.add("in");
            });
            modalClosePhoto.addEventListener("click", function () {
                if (iteration > 0) {
                    modalImg.src = modalImg.src.replace('-' + modalPhotoId + '.jpg', '.jpg');
                }
                modalPhotoZoom.style.display = "none";
            });
        });
    }
}

function loadProductSameday() {
    var modalSamedayCatalog = '#modal-sameday-catalog';
    var modalSamedayBody = '#modal-sameday-catalog .modal-body';

    $(modalSamedayCatalog).on('show.bs.modal', function () {
        if ($(modalSamedayCatalog + ' section[data-section=catalog]').length == 0) {
            $.ajax({
                url: window.AQUA.URL_LOAD_SAMEDAY
            }).done(function (response) {
                $(modalSamedayBody).html(response);
                $(modalSamedayBody + ' article').on('click', function () {
                    if ($(this).find('a.btn-commander.btn-commander-js').is(':hidden')) {
                        location.href = $(this).find('div.product-button a').attr('href');
                    }
                });
            });
        }
    });
}

function ufToggleClassElement(element, targets) {
    $(targets).each(function (key) {
        $(targets[key]).toggleClass(element);
    });
}

// Protected, don't touch !
function changeLoginLabel(context, $label, $input, $inputMobile) {
    if (context !== undefined) {
        if (context.value == 1) {
            $label.html(window.AQUA.AUTH.TRANSLATIONS.EMAIL_LABEL);
            $input.attr({ placeholder: window.AQUA.AUTH.TRANSLATIONS.EMAIL_PLACEHOLDER });
            $inputMobile.attr({ placeholder: window.AQUA.AUTH.TRANSLATIONS.EMAIL_PLACEHOLDER });
        }

        if (context.value == 2) {
            $label.html(window.AQUA.AUTH.TRANSLATIONS.CODE_LABEL);
            $input.attr({ placeholder: window.AQUA.AUTH.TRANSLATIONS.CODE_PLACEHOLDER });
            $inputMobile.attr({ placeholder: window.AQUA.AUTH.TRANSLATIONS.CODE_PLACEHOLDER });
        }
    }
}

function changeRegisterButton(context, $registerButton) {

    if (context !== undefined) {
        if (context.value == 1) {
            $registerButton.attr({ href: $registerButton.data('private') });
        } else if (context.value == 2) {
            $registerButton.attr({ href: $registerButton.data('business') });
        }
    }
}

function changeResetPassword(context, $resetPasswordLink, hrefResetPasswordLink) {

    if (context !== undefined) {
        if (context.value == 1) {
            $resetPasswordLink.attr({ href: hrefResetPasswordLink + "?b2b=0" });
        } else if (context.value == 2) {
            $resetPasswordLink.attr({ href: hrefResetPasswordLink + "?b2b=1" });
        }
    }
}

function thumbnailProduct() {

    var modalImageProductId = '#modal-img-produit';

    $(document).on('click', '.more', function () {
        ufToggleClassElement('active', [$(this), $(this).prev()]);
    });

    $(document).on('click', '.hide-full-txt', function () {
        ufToggleClassElement('active', [$(this).parent(), $(this).parent().next()]);
    });

    $(document).on('click', ".zoom", function () {
        $(modalImageProductId + ' .modal-body').html('<img src="' + $(this).attr("data-img") + '" />');
        $(modalImageProductId).modal('show');
    });
}

function selectSizeCustomByRadio(element) {
    var radios = document.querySelectorAll(element);
    if (radios.length) {
        radios.forEach(function (radio) {
            radio.addEventListener('click', function (event) {
                var targetRadio = radio.getAttribute("data-target");
                var radioContainer = event.currentTarget.closest('.price-radio');

                if (document.querySelectorAll('input#' + targetRadio).length) {
                    var previousRadioSelected = radioContainer.querySelector(element + '.radio-selected');
                    previousRadioSelected.classList.remove('radio-selected');
                    event.currentTarget.classList.add('radio-selected');

                    radioContainer.querySelectorAll('input[type="radio"]').forEach(function (radioInput) {
                        radioInput.checked = false;
                        if (radioInput.getAttribute('id') === targetRadio) {
                            radioInput.checked = true;
                        }
                    });
                }
            });
        });
    }
}

function clickOnCatalogMobileProduct() {
    $('section[data-section="catalog"] article').on('click', function (e) {
        if ($(this).find('a.btn-commander.btn-commander-js').is(':hidden')) location.href = $(this).find('div.product-button a').attr('href');
    });
}

function lazyLoadingImg(imgElement) {
    var options = {
        root: null,
        rootMargin: '120px 0px',
        threshold: 0
    };

    if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    getPicture(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, options);

        [].concat(_toConsumableArray(document.querySelectorAll(imgElement))).forEach(function (img) {
            if (img.nodeName === "IMG" && img !== null) {
                observer.observe(img);
            }
        });
    } else {
        var img = document.querySelectorAll(imgElement);
        for (var i = 0; i < img.length; i++) {
            getPicture(img[i]);
        }
    }
}

function getPicture(element) {
    element.src = element.attributes["data-src"] ? element.attributes["data-src"].value : element.src;
    element.srcset = element.attributes["data-srcset"] ? element.attributes["data-srcset"].value : element.srcset;
    element.removeAttribute("data-src");
    element.removeAttribute("data-srcset");
}

function isIOS() {
    var onlySafari = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var userAgent = navigator.userAgent;
    var Safari = onlySafari === true ? userAgent.match(/Safari/i) !== null : true;
    var AppleDevices = ['iPhone', 'IOS', 'Ipod'];

    return AppleDevices.some(function (device) {
        return userAgent.match(new RegExp(device, 'i')) && Safari;
    });
}

function clickOnCheckboxInputReadOnly(label, inputReadOnly, inputCheckbox) {
    label = document.querySelector(label);
    inputReadOnly = document.querySelector(inputReadOnly);
    inputCheckbox = document.querySelector(inputCheckbox);

    if (label) {
        label.addEventListener('click', function () {
            inputCheckbox.checked === false ? inputReadOnly.readOnly = true : inputReadOnly.readOnly = false;
        });
    }
}

function getParentNode(node, parentSelector) {
    var found = false;

    while (node != document.body) {
        if (!node) break;

        if (node.classList && node.classList.contains(parentSelector)) {
            found = true;
            break;
        }
        node = node.parentNode;
    }

    if (!found) return false;

    return node;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{"cookieconsent":13,"jquery":16}],10:[function(require,module,exports){
'use strict';

var _newsletters = require('./components/newsletters');

var _product = require('./components/product');

var _login = require('./components/login');

var _telInputUtils = require('./components/telInputUtils');

var _utils = require('./components/utils');

var _CitySelector = require('./components/CitySelector');

if (window.jQuery === undefined) {
    window.jQuery = window.$ = require('jquery');
}

require('bootstrap-sass');

/**
 * Add an event when the dom is loaded to init js components
 */
document.addEventListener('DOMContentLoaded', function () {
    if (window.bs === undefined || !window.bs) {
        require('bootstrap-sass');
        window.bs = true;
    }

    (0, _newsletters.loadNewsletter)();
    (0, _utils.changePlaceholderAndLabelForTheLogin)();
    (0, _utils.closeModal)('.close-popup');

    (0, _login.togglePassword)();

    new _CitySelector.CitySelector(document.querySelector('#register_zipCode'), document.querySelector('#cityList'), document.querySelector('#register_city'));

    //phone
    var elementIntlTelInput = document.querySelectorAll('.js-phone-input');
    elementIntlTelInput.forEach(function (inputPhone) {
        (0, _telInputUtils.initIntlTelInput)(inputPhone, window.AQUA.COUNTRY);
    });

    // Cookies
    if (window.AQUA.BANNER_COOKIES) {
        (0, _utils.initBanner)();
    }

    // Product Summary
    if (window.AQUA.PRODUCT_SUMMARY) {
        (0, _product.toggle)('.js-card', '.js-card button .fa', '.card__wrapper');
    }
}, false);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{"./components/CitySelector":1,"./components/login":3,"./components/newsletters":4,"./components/product":6,"./components/telInputUtils":8,"./components/utils":9,"bootstrap-sass":12,"jquery":16}],11:[function(require,module,exports){
/*!
 * Glide.js v3.6.0
 * (c) 2013-2022 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Glide = factory());
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get;
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }

        return desc.value;
      };
    }

    return _get.apply(this, arguments);
  }

  var defaults = {
    /**
     * Type of the movement.
     *
     * Available types:
     * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
     * `carousel` - Changes slides without starting over when it reaches the first or last slide.
     *
     * @type {String}
     */
    type: 'slider',

    /**
     * Start at specific slide number defined with zero-based index.
     *
     * @type {Number}
     */
    startAt: 0,

    /**
     * A number of slides visible on the single viewport.
     *
     * @type {Number}
     */
    perView: 1,

    /**
     * Focus currently active slide at a specified position in the track.
     *
     * Available inputs:
     * `center` - Current slide will be always focused at the center of a track.
     * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
     *
     * @type {String|Number}
     */
    focusAt: 0,

    /**
     * A size of the gap added between slides.
     *
     * @type {Number}
     */
    gap: 10,

    /**
     * Change slides after a specified interval. Use `false` for turning off autoplay.
     *
     * @type {Number|Boolean}
     */
    autoplay: false,

    /**
     * Stop autoplay on mouseover event.
     *
     * @type {Boolean}
     */
    hoverpause: true,

    /**
     * Allow for changing slides with left and right keyboard arrows.
     *
     * @type {Boolean}
     */
    keyboard: true,

    /**
     * Stop running `perView` number of slides from the end. Use this
     * option if you don't want to have an empty space after
     * a slider. Works only with `slider` type and a
     * non-centered `focusAt` setting.
     *
     * @type {Boolean}
     */
    bound: false,

    /**
     * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
     *
     * @type {Number|Boolean}
     */
    swipeThreshold: 80,

    /**
     * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
     *
     * @type {Number|Boolean}
     */
    dragThreshold: 120,

    /**
     * A number of slides moved on single swipe.
     *
     * Available types:
     * `` - Moves slider by one slide per swipe
     * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
     *
     * @type {String}
     */
    perSwipe: '',

    /**
     * Moving distance ratio of the slides on a swiping and dragging.
     *
     * @type {Number}
     */
    touchRatio: 0.5,

    /**
     * Angle required to activate slides moving on swiping or dragging.
     *
     * @type {Number}
     */
    touchAngle: 45,

    /**
     * Duration of the animation in milliseconds.
     *
     * @type {Number}
     */
    animationDuration: 400,

    /**
     * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
     *
     * @type {Boolean}
     */
    rewind: true,

    /**
     * Duration of the rewinding animation of the `slider` type in milliseconds.
     *
     * @type {Number}
     */
    rewindDuration: 800,

    /**
     * Easing function for the animation.
     *
     * @type {String}
     */
    animationTimingFunc: 'cubic-bezier(.165, .840, .440, 1)',

    /**
     * Wait for the animation to finish until the next user input can be processed
     *
     * @type {boolean}
     */
    waitForTransition: true,

    /**
     * Throttle costly events at most once per every wait milliseconds.
     *
     * @type {Number}
     */
    throttle: 10,

    /**
     * Moving direction mode.
     *
     * Available inputs:
     * - 'ltr' - left to right movement,
     * - 'rtl' - right to left movement.
     *
     * @type {String}
     */
    direction: 'ltr',

    /**
     * The distance value of the next and previous viewports which
     * have to peek in the current view. Accepts number and
     * pixels as a string. Left and right peeking can be
     * set up separately with a directions object.
     *
     * For example:
     * `100` - Peek 100px on the both sides.
     * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
     *
     * @type {Number|String|Object}
     */
    peek: 0,

    /**
     * Defines how many clones of current viewport will be generated.
     *
     * @type {Number}
     */
    cloningRatio: 1,

    /**
     * Collection of options applied at specified media breakpoints.
     * For example: display two slides per view under 800px.
     * `{
     *   '800px': {
     *     perView: 2
     *   }
     * }`
     */
    breakpoints: {},

    /**
     * Collection of internally used HTML classes.
     *
     * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
     * @type {Object}
     */
    classes: {
      swipeable: 'glide--swipeable',
      dragging: 'glide--dragging',
      direction: {
        ltr: 'glide--ltr',
        rtl: 'glide--rtl'
      },
      type: {
        slider: 'glide--slider',
        carousel: 'glide--carousel'
      },
      slide: {
        clone: 'glide__slide--clone',
        active: 'glide__slide--active'
      },
      arrow: {
        disabled: 'glide__arrow--disabled'
      },
      nav: {
        active: 'glide__bullet--active'
      }
    }
  };

  /**
   * Outputs warning message to the bowser console.
   *
   * @param  {String} msg
   * @return {Void}
   */
  function warn(msg) {
    console.error("[Glide warn]: ".concat(msg));
  }

  /**
   * Converts value entered as number
   * or string to integer value.
   *
   * @param {String} value
   * @returns {Number}
   */
  function toInt(value) {
    return parseInt(value);
  }
  /**
   * Converts value entered as number
   * or string to flat value.
   *
   * @param {String} value
   * @returns {Number}
   */

  function toFloat(value) {
    return parseFloat(value);
  }
  /**
   * Indicates whether the specified value is a string.
   *
   * @param  {*}   value
   * @return {Boolean}
   */

  function isString(value) {
    return typeof value === 'string';
  }
  /**
   * Indicates whether the specified value is an object.
   *
   * @param  {*} value
   * @return {Boolean}
   *
   * @see https://github.com/jashkenas/underscore
   */

  function isObject(value) {
    var type = _typeof(value);

    return type === 'function' || type === 'object' && !!value; // eslint-disable-line no-mixed-operators
  }
  /**
   * Indicates whether the specified value is a function.
   *
   * @param  {*} value
   * @return {Boolean}
   */

  function isFunction(value) {
    return typeof value === 'function';
  }
  /**
   * Indicates whether the specified value is undefined.
   *
   * @param  {*} value
   * @return {Boolean}
   */

  function isUndefined(value) {
    return typeof value === 'undefined';
  }
  /**
   * Indicates whether the specified value is an array.
   *
   * @param  {*} value
   * @return {Boolean}
   */

  function isArray(value) {
    return value.constructor === Array;
  }

  /**
   * Creates and initializes specified collection of extensions.
   * Each extension receives access to instance of glide and rest of components.
   *
   * @param {Object} glide
   * @param {Object} extensions
   *
   * @returns {Object}
   */

  function mount(glide, extensions, events) {
    var components = {};

    for (var name in extensions) {
      if (isFunction(extensions[name])) {
        components[name] = extensions[name](glide, components, events);
      } else {
        warn('Extension must be a function');
      }
    }

    for (var _name in components) {
      if (isFunction(components[_name].mount)) {
        components[_name].mount();
      }
    }

    return components;
  }

  /**
   * Defines getter and setter property on the specified object.
   *
   * @param  {Object} obj         Object where property has to be defined.
   * @param  {String} prop        Name of the defined property.
   * @param  {Object} definition  Get and set definitions for the property.
   * @return {Void}
   */
  function define(obj, prop, definition) {
    Object.defineProperty(obj, prop, definition);
  }
  /**
   * Sorts aphabetically object keys.
   *
   * @param  {Object} obj
   * @return {Object}
   */

  function sortKeys(obj) {
    return Object.keys(obj).sort().reduce(function (r, k) {
      r[k] = obj[k];
      return r[k], r;
    }, {});
  }
  /**
   * Merges passed settings object with default options.
   *
   * @param  {Object} defaults
   * @param  {Object} settings
   * @return {Object}
   */

  function mergeOptions(defaults, settings) {
    var options = Object.assign({}, defaults, settings); // `Object.assign` do not deeply merge objects, so we
    // have to do it manually for every nested object
    // in options. Although it does not look smart,
    // it's smaller and faster than some fancy
    // merging deep-merge algorithm script.

    if (settings.hasOwnProperty('classes')) {
      options.classes = Object.assign({}, defaults.classes, settings.classes);

      if (settings.classes.hasOwnProperty('direction')) {
        options.classes.direction = Object.assign({}, defaults.classes.direction, settings.classes.direction);
      }

      if (settings.classes.hasOwnProperty('type')) {
        options.classes.type = Object.assign({}, defaults.classes.type, settings.classes.type);
      }

      if (settings.classes.hasOwnProperty('slide')) {
        options.classes.slide = Object.assign({}, defaults.classes.slide, settings.classes.slide);
      }

      if (settings.classes.hasOwnProperty('arrow')) {
        options.classes.arrow = Object.assign({}, defaults.classes.arrow, settings.classes.arrow);
      }

      if (settings.classes.hasOwnProperty('nav')) {
        options.classes.nav = Object.assign({}, defaults.classes.nav, settings.classes.nav);
      }
    }

    if (settings.hasOwnProperty('breakpoints')) {
      options.breakpoints = Object.assign({}, defaults.breakpoints, settings.breakpoints);
    }

    return options;
  }

  var EventsBus = /*#__PURE__*/function () {
    /**
     * Construct a EventBus instance.
     *
     * @param {Object} events
     */
    function EventsBus() {
      var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, EventsBus);

      this.events = events;
      this.hop = events.hasOwnProperty;
    }
    /**
     * Adds listener to the specifed event.
     *
     * @param {String|Array} event
     * @param {Function} handler
     */


    _createClass(EventsBus, [{
      key: "on",
      value: function on(event, handler) {
        if (isArray(event)) {
          for (var i = 0; i < event.length; i++) {
            this.on(event[i], handler);
          }

          return;
        } // Create the event's object if not yet created


        if (!this.hop.call(this.events, event)) {
          this.events[event] = [];
        } // Add the handler to queue


        var index = this.events[event].push(handler) - 1; // Provide handle back for removal of event

        return {
          remove: function remove() {
            delete this.events[event][index];
          }
        };
      }
      /**
       * Runs registered handlers for specified event.
       *
       * @param {String|Array} event
       * @param {Object=} context
       */

    }, {
      key: "emit",
      value: function emit(event, context) {
        if (isArray(event)) {
          for (var i = 0; i < event.length; i++) {
            this.emit(event[i], context);
          }

          return;
        } // If the event doesn't exist, or there's no handlers in queue, just leave


        if (!this.hop.call(this.events, event)) {
          return;
        } // Cycle through events queue, fire!


        this.events[event].forEach(function (item) {
          item(context || {});
        });
      }
    }]);

    return EventsBus;
  }();

  var Glide$1 = /*#__PURE__*/function () {
    /**
     * Construct glide.
     *
     * @param  {String} selector
     * @param  {Object} options
     */
    function Glide(selector) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Glide);

      this._c = {};
      this._t = [];
      this._e = new EventsBus();
      this.disabled = false;
      this.selector = selector;
      this.settings = mergeOptions(defaults, options);
      this.index = this.settings.startAt;
    }
    /**
     * Initializes glide.
     *
     * @param {Object} extensions Collection of extensions to initialize.
     * @return {Glide}
     */


    _createClass(Glide, [{
      key: "mount",
      value: function mount$1() {
        var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this._e.emit('mount.before');

        if (isObject(extensions)) {
          this._c = mount(this, extensions, this._e);
        } else {
          warn('You need to provide a object on `mount()`');
        }

        this._e.emit('mount.after');

        return this;
      }
      /**
       * Collects an instance `translate` transformers.
       *
       * @param  {Array} transformers Collection of transformers.
       * @return {Void}
       */

    }, {
      key: "mutate",
      value: function mutate() {
        var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        if (isArray(transformers)) {
          this._t = transformers;
        } else {
          warn('You need to provide a array on `mutate()`');
        }

        return this;
      }
      /**
       * Updates glide with specified settings.
       *
       * @param {Object} settings
       * @return {Glide}
       */

    }, {
      key: "update",
      value: function update() {
        var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.settings = mergeOptions(this.settings, settings);

        if (settings.hasOwnProperty('startAt')) {
          this.index = settings.startAt;
        }

        this._e.emit('update');

        return this;
      }
      /**
       * Change slide with specified pattern. A pattern must be in the special format:
       * `>` - Move one forward
       * `<` - Move one backward
       * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
       * `>>` - Rewinds to end (last slide)
       * `<<` - Rewinds to start (first slide)
       * `|>` - Move one viewport forward
       * `|<` - Move one viewport backward
       *
       * @param {String} pattern
       * @return {Glide}
       */

    }, {
      key: "go",
      value: function go(pattern) {
        this._c.Run.make(pattern);

        return this;
      }
      /**
       * Move track by specified distance.
       *
       * @param {String} distance
       * @return {Glide}
       */

    }, {
      key: "move",
      value: function move(distance) {
        this._c.Transition.disable();

        this._c.Move.make(distance);

        return this;
      }
      /**
       * Destroy instance and revert all changes done by this._c.
       *
       * @return {Glide}
       */

    }, {
      key: "destroy",
      value: function destroy() {
        this._e.emit('destroy');

        return this;
      }
      /**
       * Start instance autoplaying.
       *
       * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
       * @return {Glide}
       */

    }, {
      key: "play",
      value: function play() {
        var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (interval) {
          this.settings.autoplay = interval;
        }

        this._e.emit('play');

        return this;
      }
      /**
       * Stop instance autoplaying.
       *
       * @return {Glide}
       */

    }, {
      key: "pause",
      value: function pause() {
        this._e.emit('pause');

        return this;
      }
      /**
       * Sets glide into a idle status.
       *
       * @return {Glide}
       */

    }, {
      key: "disable",
      value: function disable() {
        this.disabled = true;
        return this;
      }
      /**
       * Sets glide into a active status.
       *
       * @return {Glide}
       */

    }, {
      key: "enable",
      value: function enable() {
        this.disabled = false;
        return this;
      }
      /**
       * Adds cuutom event listener with handler.
       *
       * @param  {String|Array} event
       * @param  {Function} handler
       * @return {Glide}
       */

    }, {
      key: "on",
      value: function on(event, handler) {
        this._e.on(event, handler);

        return this;
      }
      /**
       * Checks if glide is a precised type.
       *
       * @param  {String} name
       * @return {Boolean}
       */

    }, {
      key: "isType",
      value: function isType(name) {
        return this.settings.type === name;
      }
      /**
       * Gets value of the core options.
       *
       * @return {Object}
       */

    }, {
      key: "settings",
      get: function get() {
        return this._o;
      }
      /**
       * Sets value of the core options.
       *
       * @param  {Object} o
       * @return {Void}
       */
      ,
      set: function set(o) {
        if (isObject(o)) {
          this._o = o;
        } else {
          warn('Options must be an `object` instance.');
        }
      }
      /**
       * Gets current index of the slider.
       *
       * @return {Object}
       */

    }, {
      key: "index",
      get: function get() {
        return this._i;
      }
      /**
       * Sets current index a slider.
       *
       * @return {Object}
       */
      ,
      set: function set(i) {
        this._i = toInt(i);
      }
      /**
       * Gets type name of the slider.
       *
       * @return {String}
       */

    }, {
      key: "type",
      get: function get() {
        return this.settings.type;
      }
      /**
       * Gets value of the idle status.
       *
       * @return {Boolean}
       */

    }, {
      key: "disabled",
      get: function get() {
        return this._d;
      }
      /**
       * Sets value of the idle status.
       *
       * @return {Boolean}
       */
      ,
      set: function set(status) {
        this._d = !!status;
      }
    }]);

    return Glide;
  }();

  function Run (Glide, Components, Events) {
    var Run = {
      /**
       * Initializes autorunning of the glide.
       *
       * @return {Void}
       */
      mount: function mount() {
        this._o = false;
      },

      /**
       * Makes glides running based on the passed moving schema.
       *
       * @param {String} move
       */
      make: function make(move) {
        var _this = this;

        if (!Glide.disabled) {
          !Glide.settings.waitForTransition || Glide.disable();
          this.move = move;
          Events.emit('run.before', this.move);
          this.calculate();
          Events.emit('run', this.move);
          Components.Transition.after(function () {
            if (_this.isStart()) {
              Events.emit('run.start', _this.move);
            }

            if (_this.isEnd()) {
              Events.emit('run.end', _this.move);
            }

            if (_this.isOffset()) {
              _this._o = false;
              Events.emit('run.offset', _this.move);
            }

            Events.emit('run.after', _this.move);
            Glide.enable();
          });
        }
      },

      /**
       * Calculates current index based on defined move.
       *
       * @return {Number|Undefined}
       */
      calculate: function calculate() {
        var move = this.move,
            length = this.length;
        var steps = move.steps,
            direction = move.direction; // By default assume that size of view is equal to one slide

        var viewSize = 1; // While direction is `=` we want jump to
        // a specified index described in steps.

        if (direction === '=') {
          // Check if bound is true, 
          // as we want to avoid whitespaces.
          if (Glide.settings.bound && toInt(steps) > length) {
            Glide.index = length;
            return;
          }

          Glide.index = steps;
          return;
        } // When pattern is equal to `>>` we want
        // fast forward to the last slide.


        if (direction === '>' && steps === '>') {
          Glide.index = length;
          return;
        } // When pattern is equal to `<<` we want
        // fast forward to the first slide.


        if (direction === '<' && steps === '<') {
          Glide.index = 0;
          return;
        } // pagination movement


        if (direction === '|') {
          viewSize = Glide.settings.perView || 1;
        } // we are moving forward


        if (direction === '>' || direction === '|' && steps === '>') {
          var index = calculateForwardIndex(viewSize);

          if (index > length) {
            this._o = true;
          }

          Glide.index = normalizeForwardIndex(index, viewSize);
          return;
        } // we are moving backward


        if (direction === '<' || direction === '|' && steps === '<') {
          var _index = calculateBackwardIndex(viewSize);

          if (_index < 0) {
            this._o = true;
          }

          Glide.index = normalizeBackwardIndex(_index, viewSize);
          return;
        }

        warn("Invalid direction pattern [".concat(direction).concat(steps, "] has been used"));
      },

      /**
       * Checks if we are on the first slide.
       *
       * @return {Boolean}
       */
      isStart: function isStart() {
        return Glide.index <= 0;
      },

      /**
       * Checks if we are on the last slide.
       *
       * @return {Boolean}
       */
      isEnd: function isEnd() {
        return Glide.index >= this.length;
      },

      /**
       * Checks if we are making a offset run.
       *
       * @param {String} direction
       * @return {Boolean}
       */
      isOffset: function isOffset() {
        var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

        if (!direction) {
          return this._o;
        }

        if (!this._o) {
          return false;
        } // did we view to the right?


        if (direction === '|>') {
          return this.move.direction === '|' && this.move.steps === '>';
        } // did we view to the left?


        if (direction === '|<') {
          return this.move.direction === '|' && this.move.steps === '<';
        }

        return this.move.direction === direction;
      },

      /**
       * Checks if bound mode is active
       *
       * @return {Boolean}
       */
      isBound: function isBound() {
        return Glide.isType('slider') && Glide.settings.focusAt !== 'center' && Glide.settings.bound;
      }
    };
    /**
     * Returns index value to move forward/to the right
     *
     * @param viewSize
     * @returns {Number}
     */

    function calculateForwardIndex(viewSize) {
      var index = Glide.index;

      if (Glide.isType('carousel')) {
        return index + viewSize;
      }

      return index + (viewSize - index % viewSize);
    }
    /**
     * Normalizes the given forward index based on glide settings, preventing it to exceed certain boundaries
     *
     * @param index
     * @param length
     * @param viewSize
     * @returns {Number}
     */


    function normalizeForwardIndex(index, viewSize) {
      var length = Run.length;

      if (index <= length) {
        return index;
      }

      if (Glide.isType('carousel')) {
        return index - (length + 1);
      }

      if (Glide.settings.rewind) {
        // bound does funny things with the length, therefor we have to be certain
        // that we are on the last possible index value given by bound
        if (Run.isBound() && !Run.isEnd()) {
          return length;
        }

        return 0;
      }

      if (Run.isBound()) {
        return length;
      }

      return Math.floor(length / viewSize) * viewSize;
    }
    /**
     * Calculates index value to move backward/to the left
     *
     * @param viewSize
     * @returns {Number}
     */


    function calculateBackwardIndex(viewSize) {
      var index = Glide.index;

      if (Glide.isType('carousel')) {
        return index - viewSize;
      } // ensure our back navigation results in the same index as a forward navigation
      // to experience a homogeneous paging


      var view = Math.ceil(index / viewSize);
      return (view - 1) * viewSize;
    }
    /**
     * Normalizes the given backward index based on glide settings, preventing it to exceed certain boundaries
     *
     * @param index
     * @param length
     * @param viewSize
     * @returns {*}
     */


    function normalizeBackwardIndex(index, viewSize) {
      var length = Run.length;

      if (index >= 0) {
        return index;
      }

      if (Glide.isType('carousel')) {
        return index + (length + 1);
      }

      if (Glide.settings.rewind) {
        // bound does funny things with the length, therefor we have to be certain
        // that we are on first possible index value before we to rewind to the length given by bound
        if (Run.isBound() && Run.isStart()) {
          return length;
        }

        return Math.floor(length / viewSize) * viewSize;
      }

      return 0;
    }

    define(Run, 'move', {
      /**
       * Gets value of the move schema.
       *
       * @returns {Object}
       */
      get: function get() {
        return this._m;
      },

      /**
       * Sets value of the move schema.
       *
       * @returns {Object}
       */
      set: function set(value) {
        var step = value.substr(1);
        this._m = {
          direction: value.substr(0, 1),
          steps: step ? toInt(step) ? toInt(step) : step : 0
        };
      }
    });
    define(Run, 'length', {
      /**
       * Gets value of the running distance based
       * on zero-indexing number of slides.
       *
       * @return {Number}
       */
      get: function get() {
        var settings = Glide.settings;
        var length = Components.Html.slides.length; // If the `bound` option is active, a maximum running distance should be
        // reduced by `perView` and `focusAt` settings. Running distance
        // should end before creating an empty space after instance.

        if (this.isBound()) {
          return length - 1 - (toInt(settings.perView) - 1) + toInt(settings.focusAt);
        }

        return length - 1;
      }
    });
    define(Run, 'offset', {
      /**
       * Gets status of the offsetting flag.
       *
       * @return {Boolean}
       */
      get: function get() {
        return this._o;
      }
    });
    return Run;
  }

  /**
   * Returns a current time.
   *
   * @return {Number}
   */
  function now() {
    return new Date().getTime();
  }

  /**
   * Returns a function, that, when invoked, will only be triggered
   * at most once during a given window of time.
   *
   * @param {Function} func
   * @param {Number} wait
   * @param {Object=} options
   * @return {Function}
   *
   * @see https://github.com/jashkenas/underscore
   */

  function throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function later() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function throttled() {
      var at = now();
      if (!previous && options.leading === false) previous = at;
      var remaining = wait - (at - previous);
      context = this;
      args = arguments;

      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }

        previous = at;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }

      return result;
    };

    throttled.cancel = function () {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  var MARGIN_TYPE = {
    ltr: ['marginLeft', 'marginRight'],
    rtl: ['marginRight', 'marginLeft']
  };
  function Gaps (Glide, Components, Events) {
    var Gaps = {
      /**
       * Applies gaps between slides. First and last
       * slides do not receive it's edge margins.
       *
       * @param {HTMLCollection} slides
       * @return {Void}
       */
      apply: function apply(slides) {
        for (var i = 0, len = slides.length; i < len; i++) {
          var style = slides[i].style;
          var direction = Components.Direction.value;

          if (i !== 0) {
            style[MARGIN_TYPE[direction][0]] = "".concat(this.value / 2, "px");
          } else {
            style[MARGIN_TYPE[direction][0]] = '';
          }

          if (i !== slides.length - 1) {
            style[MARGIN_TYPE[direction][1]] = "".concat(this.value / 2, "px");
          } else {
            style[MARGIN_TYPE[direction][1]] = '';
          }
        }
      },

      /**
       * Removes gaps from the slides.
       *
       * @param {HTMLCollection} slides
       * @returns {Void}
      */
      remove: function remove(slides) {
        for (var i = 0, len = slides.length; i < len; i++) {
          var style = slides[i].style;
          style.marginLeft = '';
          style.marginRight = '';
        }
      }
    };
    define(Gaps, 'value', {
      /**
       * Gets value of the gap.
       *
       * @returns {Number}
       */
      get: function get() {
        return toInt(Glide.settings.gap);
      }
    });
    define(Gaps, 'grow', {
      /**
       * Gets additional dimensions value caused by gaps.
       * Used to increase width of the slides wrapper.
       *
       * @returns {Number}
       */
      get: function get() {
        return Gaps.value * Components.Sizes.length;
      }
    });
    define(Gaps, 'reductor', {
      /**
       * Gets reduction value caused by gaps.
       * Used to subtract width of the slides.
       *
       * @returns {Number}
       */
      get: function get() {
        var perView = Glide.settings.perView;
        return Gaps.value * (perView - 1) / perView;
      }
    });
    /**
     * Apply calculated gaps:
     * - after building, so slides (including clones) will receive proper margins
     * - on updating via API, to recalculate gaps with new options
     */

    Events.on(['build.after', 'update'], throttle(function () {
      Gaps.apply(Components.Html.wrapper.children);
    }, 30));
    /**
     * Remove gaps:
     * - on destroying to bring markup to its inital state
     */

    Events.on('destroy', function () {
      Gaps.remove(Components.Html.wrapper.children);
    });
    return Gaps;
  }

  /**
   * Finds siblings nodes of the passed node.
   *
   * @param  {Element} node
   * @return {Array}
   */
  function siblings(node) {
    if (node && node.parentNode) {
      var n = node.parentNode.firstChild;
      var matched = [];

      for (; n; n = n.nextSibling) {
        if (n.nodeType === 1 && n !== node) {
          matched.push(n);
        }
      }

      return matched;
    }

    return [];
  }
  /**
   * Checks if passed node exist and is a valid element.
   *
   * @param  {Element} node
   * @return {Boolean}
   */

  function exist(node) {
    if (node && node instanceof window.HTMLElement) {
      return true;
    }

    return false;
  }
  /**
   * Coerces a NodeList to an Array.
   *
   * @param  {NodeList} nodeList
   * @return {Array}
   */

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  var TRACK_SELECTOR = '[data-glide-el="track"]';
  function Html (Glide, Components, Events) {
    var Html = {
      /**
       * Setup slider HTML nodes.
       *
       * @param {Glide} glide
       */
      mount: function mount() {
        this.root = Glide.selector;
        this.track = this.root.querySelector(TRACK_SELECTOR);
        this.collectSlides();
      },

      /**
       * Collect slides
       */
      collectSlides: function collectSlides() {
        this.slides = toArray(this.wrapper.children).filter(function (slide) {
          return !slide.classList.contains(Glide.settings.classes.slide.clone);
        });
      }
    };
    define(Html, 'root', {
      /**
       * Gets node of the glide main element.
       *
       * @return {Object}
       */
      get: function get() {
        return Html._r;
      },

      /**
       * Sets node of the glide main element.
       *
       * @return {Object}
       */
      set: function set(r) {
        if (isString(r)) {
          r = document.querySelector(r);
        }

        if (exist(r)) {
          Html._r = r;
        } else {
          warn('Root element must be a existing Html node');
        }
      }
    });
    define(Html, 'track', {
      /**
       * Gets node of the glide track with slides.
       *
       * @return {Object}
       */
      get: function get() {
        return Html._t;
      },

      /**
       * Sets node of the glide track with slides.
       *
       * @return {Object}
       */
      set: function set(t) {
        if (exist(t)) {
          Html._t = t;
        } else {
          warn("Could not find track element. Please use ".concat(TRACK_SELECTOR, " attribute."));
        }
      }
    });
    define(Html, 'wrapper', {
      /**
       * Gets node of the slides wrapper.
       *
       * @return {Object}
       */
      get: function get() {
        return Html.track.children[0];
      }
    });
    /**
     * Add/remove/reorder dynamic slides
     */

    Events.on('update', function () {
      Html.collectSlides();
    });
    return Html;
  }

  function Peek (Glide, Components, Events) {
    var Peek = {
      /**
       * Setups how much to peek based on settings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.value = Glide.settings.peek;
      }
    };
    define(Peek, 'value', {
      /**
       * Gets value of the peek.
       *
       * @returns {Number|Object}
       */
      get: function get() {
        return Peek._v;
      },

      /**
       * Sets value of the peek.
       *
       * @param {Number|Object} value
       * @return {Void}
       */
      set: function set(value) {
        if (isObject(value)) {
          value.before = toInt(value.before);
          value.after = toInt(value.after);
        } else {
          value = toInt(value);
        }

        Peek._v = value;
      }
    });
    define(Peek, 'reductor', {
      /**
       * Gets reduction value caused by peek.
       *
       * @returns {Number}
       */
      get: function get() {
        var value = Peek.value;
        var perView = Glide.settings.perView;

        if (isObject(value)) {
          return value.before / perView + value.after / perView;
        }

        return value * 2 / perView;
      }
    });
    /**
     * Recalculate peeking sizes on:
     * - when resizing window to update to proper percents
     */

    Events.on(['resize', 'update'], function () {
      Peek.mount();
    });
    return Peek;
  }

  function Move (Glide, Components, Events) {
    var Move = {
      /**
       * Constructs move component.
       *
       * @returns {Void}
       */
      mount: function mount() {
        this._o = 0;
      },

      /**
       * Calculates a movement value based on passed offset and currently active index.
       *
       * @param  {Number} offset
       * @return {Void}
       */
      make: function make() {
        var _this = this;

        var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        this.offset = offset;
        Events.emit('move', {
          movement: this.value
        });
        Components.Transition.after(function () {
          Events.emit('move.after', {
            movement: _this.value
          });
        });
      }
    };
    define(Move, 'offset', {
      /**
       * Gets an offset value used to modify current translate.
       *
       * @return {Object}
       */
      get: function get() {
        return Move._o;
      },

      /**
       * Sets an offset value used to modify current translate.
       *
       * @return {Object}
       */
      set: function set(value) {
        Move._o = !isUndefined(value) ? toInt(value) : 0;
      }
    });
    define(Move, 'translate', {
      /**
       * Gets a raw movement value.
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Sizes.slideWidth * Glide.index;
      }
    });
    define(Move, 'value', {
      /**
       * Gets an actual movement value corrected by offset.
       *
       * @return {Number}
       */
      get: function get() {
        var offset = this.offset;
        var translate = this.translate;

        if (Components.Direction.is('rtl')) {
          return translate + offset;
        }

        return translate - offset;
      }
    });
    /**
     * Make movement to proper slide on:
     * - before build, so glide will start at `startAt` index
     * - on each standard run to move to newly calculated index
     */

    Events.on(['build.before', 'run'], function () {
      Move.make();
    });
    return Move;
  }

  function Sizes (Glide, Components, Events) {
    var Sizes = {
      /**
       * Setups dimensions of slides.
       *
       * @return {Void}
       */
      setupSlides: function setupSlides() {
        var width = "".concat(this.slideWidth, "px");
        var slides = Components.Html.slides;

        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = width;
        }
      },

      /**
       * Setups dimensions of slides wrapper.
       *
       * @return {Void}
       */
      setupWrapper: function setupWrapper() {
        Components.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
      },

      /**
       * Removes applied styles from HTML elements.
       *
       * @returns {Void}
       */
      remove: function remove() {
        var slides = Components.Html.slides;

        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = '';
        }

        Components.Html.wrapper.style.width = '';
      }
    };
    define(Sizes, 'length', {
      /**
       * Gets count number of the slides.
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Html.slides.length;
      }
    });
    define(Sizes, 'width', {
      /**
       * Gets width value of the slider (visible area).
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Html.track.offsetWidth;
      }
    });
    define(Sizes, 'wrapperSize', {
      /**
       * Gets size of the slides wrapper.
       *
       * @return {Number}
       */
      get: function get() {
        return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
      }
    });
    define(Sizes, 'slideWidth', {
      /**
       * Gets width value of a single slide.
       *
       * @return {Number}
       */
      get: function get() {
        return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
      }
    });
    /**
     * Apply calculated glide's dimensions:
     * - before building, so other dimensions (e.g. translate) will be calculated propertly
     * - when resizing window to recalculate sildes dimensions
     * - on updating via API, to calculate dimensions based on new options
     */

    Events.on(['build.before', 'resize', 'update'], function () {
      Sizes.setupSlides();
      Sizes.setupWrapper();
    });
    /**
     * Remove calculated glide's dimensions:
     * - on destoting to bring markup to its inital state
     */

    Events.on('destroy', function () {
      Sizes.remove();
    });
    return Sizes;
  }

  function Build (Glide, Components, Events) {
    var Build = {
      /**
       * Init glide building. Adds classes, sets
       * dimensions and setups initial state.
       *
       * @return {Void}
       */
      mount: function mount() {
        Events.emit('build.before');
        this.typeClass();
        this.activeClass();
        Events.emit('build.after');
      },

      /**
       * Adds `type` class to the glide element.
       *
       * @return {Void}
       */
      typeClass: function typeClass() {
        Components.Html.root.classList.add(Glide.settings.classes.type[Glide.settings.type]);
      },

      /**
       * Sets active class to current slide.
       *
       * @return {Void}
       */
      activeClass: function activeClass() {
        var classes = Glide.settings.classes;
        var slide = Components.Html.slides[Glide.index];

        if (slide) {
          slide.classList.add(classes.slide.active);
          siblings(slide).forEach(function (sibling) {
            sibling.classList.remove(classes.slide.active);
          });
        }
      },

      /**
       * Removes HTML classes applied at building.
       *
       * @return {Void}
       */
      removeClasses: function removeClasses() {
        var _Glide$settings$class = Glide.settings.classes,
            type = _Glide$settings$class.type,
            slide = _Glide$settings$class.slide;
        Components.Html.root.classList.remove(type[Glide.settings.type]);
        Components.Html.slides.forEach(function (sibling) {
          sibling.classList.remove(slide.active);
        });
      }
    };
    /**
     * Clear building classes:
     * - on destroying to bring HTML to its initial state
     * - on updating to remove classes before remounting component
     */

    Events.on(['destroy', 'update'], function () {
      Build.removeClasses();
    });
    /**
     * Remount component:
     * - on resizing of the window to calculate new dimensions
     * - on updating settings via API
     */

    Events.on(['resize', 'update'], function () {
      Build.mount();
    });
    /**
     * Swap active class of current slide:
     * - after each move to the new index
     */

    Events.on('move.after', function () {
      Build.activeClass();
    });
    return Build;
  }

  function Clones (Glide, Components, Events) {
    var Clones = {
      /**
       * Create pattern map and collect slides to be cloned.
       */
      mount: function mount() {
        this.items = [];

        if (Glide.isType('carousel')) {
          this.items = this.collect();
        }
      },

      /**
       * Collect clones with pattern.
       *
       * @return {[]}
       */
      collect: function collect() {
        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var slides = Components.Html.slides;
        var _Glide$settings = Glide.settings,
            perView = _Glide$settings.perView,
            classes = _Glide$settings.classes,
            cloningRatio = _Glide$settings.cloningRatio;

        if (slides.length !== 0) {
          var peekIncrementer = +!!Glide.settings.peek;
          var cloneCount = perView + peekIncrementer + Math.round(perView / 2);
          var append = slides.slice(0, cloneCount).reverse();
          var prepend = slides.slice(cloneCount * -1);

          for (var r = 0; r < Math.max(cloningRatio, Math.floor(perView / slides.length)); r++) {
            for (var i = 0; i < append.length; i++) {
              var clone = append[i].cloneNode(true);
              clone.classList.add(classes.slide.clone);
              items.push(clone);
            }

            for (var _i = 0; _i < prepend.length; _i++) {
              var _clone = prepend[_i].cloneNode(true);

              _clone.classList.add(classes.slide.clone);

              items.unshift(_clone);
            }
          }
        }

        return items;
      },

      /**
       * Append cloned slides with generated pattern.
       *
       * @return {Void}
       */
      append: function append() {
        var items = this.items;
        var _Components$Html = Components.Html,
            wrapper = _Components$Html.wrapper,
            slides = _Components$Html.slides;
        var half = Math.floor(items.length / 2);
        var prepend = items.slice(0, half).reverse();
        var append = items.slice(half * -1).reverse();
        var width = "".concat(Components.Sizes.slideWidth, "px");

        for (var i = 0; i < append.length; i++) {
          wrapper.appendChild(append[i]);
        }

        for (var _i2 = 0; _i2 < prepend.length; _i2++) {
          wrapper.insertBefore(prepend[_i2], slides[0]);
        }

        for (var _i3 = 0; _i3 < items.length; _i3++) {
          items[_i3].style.width = width;
        }
      },

      /**
       * Remove all cloned slides.
       *
       * @return {Void}
       */
      remove: function remove() {
        var items = this.items;

        for (var i = 0; i < items.length; i++) {
          Components.Html.wrapper.removeChild(items[i]);
        }
      }
    };
    define(Clones, 'grow', {
      /**
       * Gets additional dimensions value caused by clones.
       *
       * @return {Number}
       */
      get: function get() {
        return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
      }
    });
    /**
     * Append additional slide's clones:
     * - while glide's type is `carousel`
     */

    Events.on('update', function () {
      Clones.remove();
      Clones.mount();
      Clones.append();
    });
    /**
     * Append additional slide's clones:
     * - while glide's type is `carousel`
     */

    Events.on('build.before', function () {
      if (Glide.isType('carousel')) {
        Clones.append();
      }
    });
    /**
     * Remove clones HTMLElements:
     * - on destroying, to bring HTML to its initial state
     */

    Events.on('destroy', function () {
      Clones.remove();
    });
    return Clones;
  }

  var EventsBinder = /*#__PURE__*/function () {
    /**
     * Construct a EventsBinder instance.
     */
    function EventsBinder() {
      var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, EventsBinder);

      this.listeners = listeners;
    }
    /**
     * Adds events listeners to arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Function} closure
     * @param  {Boolean|Object} capture
     * @return {Void}
     */


    _createClass(EventsBinder, [{
      key: "on",
      value: function on(events, el, closure) {
        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        if (isString(events)) {
          events = [events];
        }

        for (var i = 0; i < events.length; i++) {
          this.listeners[events[i]] = closure;
          el.addEventListener(events[i], this.listeners[events[i]], capture);
        }
      }
      /**
       * Removes event listeners from arrows HTML elements.
       *
       * @param  {String|Array} events
       * @param  {Element|Window|Document} el
       * @param  {Boolean|Object} capture
       * @return {Void}
       */

    }, {
      key: "off",
      value: function off(events, el) {
        var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (isString(events)) {
          events = [events];
        }

        for (var i = 0; i < events.length; i++) {
          el.removeEventListener(events[i], this.listeners[events[i]], capture);
        }
      }
      /**
       * Destroy collected listeners.
       *
       * @returns {Void}
       */

    }, {
      key: "destroy",
      value: function destroy() {
        delete this.listeners;
      }
    }]);

    return EventsBinder;
  }();

  function Resize (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var Resize = {
      /**
       * Initializes window bindings.
       */
      mount: function mount() {
        this.bind();
      },

      /**
       * Binds `rezsize` listener to the window.
       * It's a costly event, so we are debouncing it.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('resize', window, throttle(function () {
          Events.emit('resize');
        }, Glide.settings.throttle));
      },

      /**
       * Unbinds listeners from the window.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('resize', window);
      }
    };
    /**
     * Remove bindings from window:
     * - on destroying, to remove added EventListener
     */

    Events.on('destroy', function () {
      Resize.unbind();
      Binder.destroy();
    });
    return Resize;
  }

  var VALID_DIRECTIONS = ['ltr', 'rtl'];
  var FLIPED_MOVEMENTS = {
    '>': '<',
    '<': '>',
    '=': '='
  };
  function Direction (Glide, Components, Events) {
    var Direction = {
      /**
       * Setups gap value based on settings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.value = Glide.settings.direction;
      },

      /**
       * Resolves pattern based on direction value
       *
       * @param {String} pattern
       * @returns {String}
       */
      resolve: function resolve(pattern) {
        var token = pattern.slice(0, 1);

        if (this.is('rtl')) {
          return pattern.split(token).join(FLIPED_MOVEMENTS[token]);
        }

        return pattern;
      },

      /**
       * Checks value of direction mode.
       *
       * @param {String} direction
       * @returns {Boolean}
       */
      is: function is(direction) {
        return this.value === direction;
      },

      /**
       * Applies direction class to the root HTML element.
       *
       * @return {Void}
       */
      addClass: function addClass() {
        Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
      },

      /**
       * Removes direction class from the root HTML element.
       *
       * @return {Void}
       */
      removeClass: function removeClass() {
        Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
      }
    };
    define(Direction, 'value', {
      /**
       * Gets value of the direction.
       *
       * @returns {Number}
       */
      get: function get() {
        return Direction._v;
      },

      /**
       * Sets value of the direction.
       *
       * @param {String} value
       * @return {Void}
       */
      set: function set(value) {
        if (VALID_DIRECTIONS.indexOf(value) > -1) {
          Direction._v = value;
        } else {
          warn('Direction value must be `ltr` or `rtl`');
        }
      }
    });
    /**
     * Clear direction class:
     * - on destroy to bring HTML to its initial state
     * - on update to remove class before reappling bellow
     */

    Events.on(['destroy', 'update'], function () {
      Direction.removeClass();
    });
    /**
     * Remount component:
     * - on update to reflect changes in direction value
     */

    Events.on('update', function () {
      Direction.mount();
    });
    /**
     * Apply direction class:
     * - before building to apply class for the first time
     * - on updating to reapply direction class that may changed
     */

    Events.on(['build.before', 'update'], function () {
      Direction.addClass();
    });
    return Direction;
  }

  /**
   * Reflects value of glide movement.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Rtl (Glide, Components) {
    return {
      /**
       * Negates the passed translate if glide is in RTL option.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        if (Components.Direction.is('rtl')) {
          return -translate;
        }

        return translate;
      }
    };
  }

  /**
   * Updates glide movement with a `gap` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Gap (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with number in the `gap` settings.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        var multiplier = Math.floor(translate / Components.Sizes.slideWidth);
        return translate + Components.Gaps.value * multiplier;
      }
    };
  }

  /**
   * Updates glide movement with width of additional clones width.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Grow (Glide, Components) {
    return {
      /**
       * Adds to the passed translate width of the half of clones.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        return translate + Components.Clones.grow / 2;
      }
    };
  }

  /**
   * Updates glide movement with a `peek` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */

  function Peeking (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with a `peek` setting.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        if (Glide.settings.focusAt >= 0) {
          var peek = Components.Peek.value;

          if (isObject(peek)) {
            return translate - peek.before;
          }

          return translate - peek;
        }

        return translate;
      }
    };
  }

  /**
   * Updates glide movement with a `focusAt` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Focusing (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with index in the `focusAt` setting.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        var gap = Components.Gaps.value;
        var width = Components.Sizes.width;
        var focusAt = Glide.settings.focusAt;
        var slideWidth = Components.Sizes.slideWidth;

        if (focusAt === 'center') {
          return translate - (width / 2 - slideWidth / 2);
        }

        return translate - slideWidth * focusAt - gap * focusAt;
      }
    };
  }

  /**
   * Applies diffrent transformers on translate value.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */

  function mutator (Glide, Components, Events) {
    /**
     * Merge instance transformers with collection of default transformers.
     * It's important that the Rtl component be last on the list,
     * so it reflects all previous transformations.
     *
     * @type {Array}
     */
    var TRANSFORMERS = [Gap, Grow, Peeking, Focusing].concat(Glide._t, [Rtl]);
    return {
      /**
       * Piplines translate value with registered transformers.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      mutate: function mutate(translate) {
        for (var i = 0; i < TRANSFORMERS.length; i++) {
          var transformer = TRANSFORMERS[i];

          if (isFunction(transformer) && isFunction(transformer().modify)) {
            translate = transformer(Glide, Components, Events).modify(translate);
          } else {
            warn('Transformer should be a function that returns an object with `modify()` method');
          }
        }

        return translate;
      }
    };
  }

  function Translate (Glide, Components, Events) {
    var Translate = {
      /**
       * Sets value of translate on HTML element.
       *
       * @param {Number} value
       * @return {Void}
       */
      set: function set(value) {
        var transform = mutator(Glide, Components).mutate(value);
        var translate3d = "translate3d(".concat(-1 * transform, "px, 0px, 0px)");
        Components.Html.wrapper.style.mozTransform = translate3d; // needed for supported Firefox 10-15

        Components.Html.wrapper.style.webkitTransform = translate3d; // needed for supported Chrome 10-35, Safari 5.1-8, and Opera 15-22

        Components.Html.wrapper.style.transform = translate3d;
      },

      /**
       * Removes value of translate from HTML element.
       *
       * @return {Void}
       */
      remove: function remove() {
        Components.Html.wrapper.style.transform = '';
      },

      /**
       * @return {number}
       */
      getStartIndex: function getStartIndex() {
        var length = Components.Sizes.length;
        var index = Glide.index;
        var perView = Glide.settings.perView;

        if (Components.Run.isOffset('>') || Components.Run.isOffset('|>')) {
          return length + (index - perView);
        } // "modulo length" converts an index that equals length to zero


        return (index + perView) % length;
      },

      /**
       * @return {number}
       */
      getTravelDistance: function getTravelDistance() {
        var travelDistance = Components.Sizes.slideWidth * Glide.settings.perView;

        if (Components.Run.isOffset('>') || Components.Run.isOffset('|>')) {
          // reverse travel distance so that we don't have to change subtract operations
          return travelDistance * -1;
        }

        return travelDistance;
      }
    };
    /**
     * Set new translate value:
     * - on move to reflect index change
     * - on updating via API to reflect possible changes in options
     */

    Events.on('move', function (context) {
      if (!Glide.isType('carousel') || !Components.Run.isOffset()) {
        return Translate.set(context.movement);
      }

      Components.Transition.after(function () {
        Events.emit('translate.jump');
        Translate.set(Components.Sizes.slideWidth * Glide.index);
      });
      var startWidth = Components.Sizes.slideWidth * Components.Translate.getStartIndex();
      return Translate.set(startWidth - Components.Translate.getTravelDistance());
    });
    /**
     * Remove translate:
     * - on destroying to bring markup to its inital state
     */

    Events.on('destroy', function () {
      Translate.remove();
    });
    return Translate;
  }

  function Transition (Glide, Components, Events) {
    /**
     * Holds inactivity status of transition.
     * When true transition is not applied.
     *
     * @type {Boolean}
     */
    var disabled = false;
    var Transition = {
      /**
       * Composes string of the CSS transition.
       *
       * @param {String} property
       * @return {String}
       */
      compose: function compose(property) {
        var settings = Glide.settings;

        if (!disabled) {
          return "".concat(property, " ").concat(this.duration, "ms ").concat(settings.animationTimingFunc);
        }

        return "".concat(property, " 0ms ").concat(settings.animationTimingFunc);
      },

      /**
       * Sets value of transition on HTML element.
       *
       * @param {String=} property
       * @return {Void}
       */
      set: function set() {
        var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
        Components.Html.wrapper.style.transition = this.compose(property);
      },

      /**
       * Removes value of transition from HTML element.
       *
       * @return {Void}
       */
      remove: function remove() {
        Components.Html.wrapper.style.transition = '';
      },

      /**
       * Runs callback after animation.
       *
       * @param  {Function} callback
       * @return {Void}
       */
      after: function after(callback) {
        setTimeout(function () {
          callback();
        }, this.duration);
      },

      /**
       * Enable transition.
       *
       * @return {Void}
       */
      enable: function enable() {
        disabled = false;
        this.set();
      },

      /**
       * Disable transition.
       *
       * @return {Void}
       */
      disable: function disable() {
        disabled = true;
        this.set();
      }
    };
    define(Transition, 'duration', {
      /**
       * Gets duration of the transition based
       * on currently running animation type.
       *
       * @return {Number}
       */
      get: function get() {
        var settings = Glide.settings;

        if (Glide.isType('slider') && Components.Run.offset) {
          return settings.rewindDuration;
        }

        return settings.animationDuration;
      }
    });
    /**
     * Set transition `style` value:
     * - on each moving, because it may be cleared by offset move
     */

    Events.on('move', function () {
      Transition.set();
    });
    /**
     * Disable transition:
     * - before initial build to avoid transitioning from `0` to `startAt` index
     * - while resizing window and recalculating dimensions
     * - on jumping from offset transition at start and end edges in `carousel` type
     */

    Events.on(['build.before', 'resize', 'translate.jump'], function () {
      Transition.disable();
    });
    /**
     * Enable transition:
     * - on each running, because it may be disabled by offset move
     */

    Events.on('run', function () {
      Transition.enable();
    });
    /**
     * Remove transition:
     * - on destroying to bring markup to its inital state
     */

    Events.on('destroy', function () {
      Transition.remove();
    });
    return Transition;
  }

  /**
   * Test via a getter in the options object to see
   * if the passive property is accessed.
   *
   * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
   */
  var supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {}

  var supportsPassive$1 = supportsPassive;

  var START_EVENTS = ['touchstart', 'mousedown'];
  var MOVE_EVENTS = ['touchmove', 'mousemove'];
  var END_EVENTS = ['touchend', 'touchcancel', 'mouseup', 'mouseleave'];
  var MOUSE_EVENTS = ['mousedown', 'mousemove', 'mouseup', 'mouseleave'];
  function Swipe (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var swipeSin = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var disabled = false;
    var capture = supportsPassive$1 ? {
      passive: true
    } : false;
    var Swipe = {
      /**
       * Initializes swipe bindings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.bindSwipeStart();
      },

      /**
       * Handler for `swipestart` event. Calculates entry points of the user's tap.
       *
       * @param {Object} event
       * @return {Void}
       */
      start: function start(event) {
        if (!disabled && !Glide.disabled) {
          this.disable();
          var swipe = this.touches(event);
          swipeSin = null;
          swipeStartX = toInt(swipe.pageX);
          swipeStartY = toInt(swipe.pageY);
          this.bindSwipeMove();
          this.bindSwipeEnd();
          Events.emit('swipe.start');
        }
      },

      /**
       * Handler for `swipemove` event. Calculates user's tap angle and distance.
       *
       * @param {Object} event
       */
      move: function move(event) {
        if (!Glide.disabled) {
          var _Glide$settings = Glide.settings,
              touchAngle = _Glide$settings.touchAngle,
              touchRatio = _Glide$settings.touchRatio,
              classes = _Glide$settings.classes;
          var swipe = this.touches(event);
          var subExSx = toInt(swipe.pageX) - swipeStartX;
          var subEySy = toInt(swipe.pageY) - swipeStartY;
          var powEX = Math.abs(subExSx << 2);
          var powEY = Math.abs(subEySy << 2);
          var swipeHypotenuse = Math.sqrt(powEX + powEY);
          var swipeCathetus = Math.sqrt(powEY);
          swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);

          if (swipeSin * 180 / Math.PI < touchAngle) {
            event.stopPropagation();
            Components.Move.make(subExSx * toFloat(touchRatio));
            Components.Html.root.classList.add(classes.dragging);
            Events.emit('swipe.move');
          } else {
            return false;
          }
        }
      },

      /**
       * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
       *
       * @param {Object} event
       * @return {Void}
       */
      end: function end(event) {
        if (!Glide.disabled) {
          var _Glide$settings2 = Glide.settings,
              perSwipe = _Glide$settings2.perSwipe,
              touchAngle = _Glide$settings2.touchAngle,
              classes = _Glide$settings2.classes;
          var swipe = this.touches(event);
          var threshold = this.threshold(event);
          var swipeDistance = swipe.pageX - swipeStartX;
          var swipeDeg = swipeSin * 180 / Math.PI;
          this.enable();

          if (swipeDistance > threshold && swipeDeg < touchAngle) {
            Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
          } else if (swipeDistance < -threshold && swipeDeg < touchAngle) {
            Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
          } else {
            // While swipe don't reach distance apply previous transform.
            Components.Move.make();
          }

          Components.Html.root.classList.remove(classes.dragging);
          this.unbindSwipeMove();
          this.unbindSwipeEnd();
          Events.emit('swipe.end');
        }
      },

      /**
       * Binds swipe's starting event.
       *
       * @return {Void}
       */
      bindSwipeStart: function bindSwipeStart() {
        var _this = this;

        var _Glide$settings3 = Glide.settings,
            swipeThreshold = _Glide$settings3.swipeThreshold,
            dragThreshold = _Glide$settings3.dragThreshold;

        if (swipeThreshold) {
          Binder.on(START_EVENTS[0], Components.Html.wrapper, function (event) {
            _this.start(event);
          }, capture);
        }

        if (dragThreshold) {
          Binder.on(START_EVENTS[1], Components.Html.wrapper, function (event) {
            _this.start(event);
          }, capture);
        }
      },

      /**
       * Unbinds swipe's starting event.
       *
       * @return {Void}
       */
      unbindSwipeStart: function unbindSwipeStart() {
        Binder.off(START_EVENTS[0], Components.Html.wrapper, capture);
        Binder.off(START_EVENTS[1], Components.Html.wrapper, capture);
      },

      /**
       * Binds swipe's moving event.
       *
       * @return {Void}
       */
      bindSwipeMove: function bindSwipeMove() {
        var _this2 = this;

        Binder.on(MOVE_EVENTS, Components.Html.wrapper, throttle(function (event) {
          _this2.move(event);
        }, Glide.settings.throttle), capture);
      },

      /**
       * Unbinds swipe's moving event.
       *
       * @return {Void}
       */
      unbindSwipeMove: function unbindSwipeMove() {
        Binder.off(MOVE_EVENTS, Components.Html.wrapper, capture);
      },

      /**
       * Binds swipe's ending event.
       *
       * @return {Void}
       */
      bindSwipeEnd: function bindSwipeEnd() {
        var _this3 = this;

        Binder.on(END_EVENTS, Components.Html.wrapper, function (event) {
          _this3.end(event);
        });
      },

      /**
       * Unbinds swipe's ending event.
       *
       * @return {Void}
       */
      unbindSwipeEnd: function unbindSwipeEnd() {
        Binder.off(END_EVENTS, Components.Html.wrapper);
      },

      /**
       * Normalizes event touches points accorting to different types.
       *
       * @param {Object} event
       */
      touches: function touches(event) {
        if (MOUSE_EVENTS.indexOf(event.type) > -1) {
          return event;
        }

        return event.touches[0] || event.changedTouches[0];
      },

      /**
       * Gets value of minimum swipe distance settings based on event type.
       *
       * @return {Number}
       */
      threshold: function threshold(event) {
        var settings = Glide.settings;

        if (MOUSE_EVENTS.indexOf(event.type) > -1) {
          return settings.dragThreshold;
        }

        return settings.swipeThreshold;
      },

      /**
       * Enables swipe event.
       *
       * @return {self}
       */
      enable: function enable() {
        disabled = false;
        Components.Transition.enable();
        return this;
      },

      /**
       * Disables swipe event.
       *
       * @return {self}
       */
      disable: function disable() {
        disabled = true;
        Components.Transition.disable();
        return this;
      }
    };
    /**
     * Add component class:
     * - after initial building
     */

    Events.on('build.after', function () {
      Components.Html.root.classList.add(Glide.settings.classes.swipeable);
    });
    /**
     * Remove swiping bindings:
     * - on destroying, to remove added EventListeners
     */

    Events.on('destroy', function () {
      Swipe.unbindSwipeStart();
      Swipe.unbindSwipeMove();
      Swipe.unbindSwipeEnd();
      Binder.destroy();
    });
    return Swipe;
  }

  function Images (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var Images = {
      /**
       * Binds listener to glide wrapper.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.bind();
      },

      /**
       * Binds `dragstart` event on wrapper to prevent dragging images.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('dragstart', Components.Html.wrapper, this.dragstart);
      },

      /**
       * Unbinds `dragstart` event on wrapper.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('dragstart', Components.Html.wrapper);
      },

      /**
       * Event handler. Prevents dragging.
       *
       * @return {Void}
       */
      dragstart: function dragstart(event) {
        event.preventDefault();
      }
    };
    /**
     * Remove bindings from images:
     * - on destroying, to remove added EventListeners
     */

    Events.on('destroy', function () {
      Images.unbind();
      Binder.destroy();
    });
    return Images;
  }

  function Anchors (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    /**
     * Holds detaching status of anchors.
     * Prevents detaching of already detached anchors.
     *
     * @private
     * @type {Boolean}
     */

    var detached = false;
    /**
     * Holds preventing status of anchors.
     * If `true` redirection after click will be disabled.
     *
     * @private
     * @type {Boolean}
     */

    var prevented = false;
    var Anchors = {
      /**
       * Setups a initial state of anchors component.
       *
       * @returns {Void}
       */
      mount: function mount() {
        /**
         * Holds collection of anchors elements.
         *
         * @private
         * @type {HTMLCollection}
         */
        this._a = Components.Html.wrapper.querySelectorAll('a');
        this.bind();
      },

      /**
       * Binds events to anchors inside a track.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('click', Components.Html.wrapper, this.click);
      },

      /**
       * Unbinds events attached to anchors inside a track.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('click', Components.Html.wrapper);
      },

      /**
       * Handler for click event. Prevents clicks when glide is in `prevent` status.
       *
       * @param  {Object} event
       * @return {Void}
       */
      click: function click(event) {
        if (prevented) {
          event.stopPropagation();
          event.preventDefault();
        }
      },

      /**
       * Detaches anchors click event inside glide.
       *
       * @return {self}
       */
      detach: function detach() {
        prevented = true;

        if (!detached) {
          for (var i = 0; i < this.items.length; i++) {
            this.items[i].draggable = false;
          }

          detached = true;
        }

        return this;
      },

      /**
       * Attaches anchors click events inside glide.
       *
       * @return {self}
       */
      attach: function attach() {
        prevented = false;

        if (detached) {
          for (var i = 0; i < this.items.length; i++) {
            this.items[i].draggable = true;
          }

          detached = false;
        }

        return this;
      }
    };
    define(Anchors, 'items', {
      /**
       * Gets collection of the arrows HTML elements.
       *
       * @return {HTMLElement[]}
       */
      get: function get() {
        return Anchors._a;
      }
    });
    /**
     * Detach anchors inside slides:
     * - on swiping, so they won't redirect to its `href` attributes
     */

    Events.on('swipe.move', function () {
      Anchors.detach();
    });
    /**
     * Attach anchors inside slides:
     * - after swiping and transitions ends, so they can redirect after click again
     */

    Events.on('swipe.end', function () {
      Components.Transition.after(function () {
        Anchors.attach();
      });
    });
    /**
     * Unbind anchors inside slides:
     * - on destroying, to bring anchors to its initial state
     */

    Events.on('destroy', function () {
      Anchors.attach();
      Anchors.unbind();
      Binder.destroy();
    });
    return Anchors;
  }

  var NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
  var CONTROLS_SELECTOR = '[data-glide-el^="controls"]';
  var PREVIOUS_CONTROLS_SELECTOR = "".concat(CONTROLS_SELECTOR, " [data-glide-dir*=\"<\"]");
  var NEXT_CONTROLS_SELECTOR = "".concat(CONTROLS_SELECTOR, " [data-glide-dir*=\">\"]");
  function Controls (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var capture = supportsPassive$1 ? {
      passive: true
    } : false;
    var Controls = {
      /**
       * Inits arrows. Binds events listeners
       * to the arrows HTML elements.
       *
       * @return {Void}
       */
      mount: function mount() {
        /**
         * Collection of navigation HTML elements.
         *
         * @private
         * @type {HTMLCollection}
         */
        this._n = Components.Html.root.querySelectorAll(NAV_SELECTOR);
        /**
         * Collection of controls HTML elements.
         *
         * @private
         * @type {HTMLCollection}
         */

        this._c = Components.Html.root.querySelectorAll(CONTROLS_SELECTOR);
        /**
         * Collection of arrow control HTML elements.
         *
         * @private
         * @type {Object}
         */

        this._arrowControls = {
          previous: Components.Html.root.querySelectorAll(PREVIOUS_CONTROLS_SELECTOR),
          next: Components.Html.root.querySelectorAll(NEXT_CONTROLS_SELECTOR)
        };
        this.addBindings();
      },

      /**
       * Sets active class to current slide.
       *
       * @return {Void}
       */
      setActive: function setActive() {
        for (var i = 0; i < this._n.length; i++) {
          this.addClass(this._n[i].children);
        }
      },

      /**
       * Removes active class to current slide.
       *
       * @return {Void}
       */
      removeActive: function removeActive() {
        for (var i = 0; i < this._n.length; i++) {
          this.removeClass(this._n[i].children);
        }
      },

      /**
       * Toggles active class on items inside navigation.
       *
       * @param  {HTMLElement} controls
       * @return {Void}
       */
      addClass: function addClass(controls) {
        var settings = Glide.settings;
        var item = controls[Glide.index];

        if (!item) {
          return;
        }

        if (item) {
          item.classList.add(settings.classes.nav.active);
          siblings(item).forEach(function (sibling) {
            sibling.classList.remove(settings.classes.nav.active);
          });
        }
      },

      /**
       * Removes active class from active control.
       *
       * @param  {HTMLElement} controls
       * @return {Void}
       */
      removeClass: function removeClass(controls) {
        var item = controls[Glide.index];

        if (item) {
          item.classList.remove(Glide.settings.classes.nav.active);
        }
      },

      /**
       * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
       */
      setArrowState: function setArrowState() {
        if (Glide.settings.rewind) {
          return;
        }

        var next = Controls._arrowControls.next;
        var previous = Controls._arrowControls.previous;
        this.resetArrowState(next, previous);

        if (Glide.index === 0) {
          this.disableArrow(previous);
        }

        if (Glide.index === Components.Run.length) {
          this.disableArrow(next);
        }
      },

      /**
       * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
       *
       * @param {NodeList[]} lists
       */
      resetArrowState: function resetArrowState() {
        var settings = Glide.settings;

        for (var _len = arguments.length, lists = new Array(_len), _key = 0; _key < _len; _key++) {
          lists[_key] = arguments[_key];
        }

        lists.forEach(function (list) {
          toArray(list).forEach(function (element) {
            element.classList.remove(settings.classes.arrow.disabled);
          });
        });
      },

      /**
       * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
       *
       * @param {NodeList[]} lists
       */
      disableArrow: function disableArrow() {
        var settings = Glide.settings;

        for (var _len2 = arguments.length, lists = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          lists[_key2] = arguments[_key2];
        }

        lists.forEach(function (list) {
          toArray(list).forEach(function (element) {
            element.classList.add(settings.classes.arrow.disabled);
          });
        });
      },

      /**
       * Adds handles to the each group of controls.
       *
       * @return {Void}
       */
      addBindings: function addBindings() {
        for (var i = 0; i < this._c.length; i++) {
          this.bind(this._c[i].children);
        }
      },

      /**
       * Removes handles from the each group of controls.
       *
       * @return {Void}
       */
      removeBindings: function removeBindings() {
        for (var i = 0; i < this._c.length; i++) {
          this.unbind(this._c[i].children);
        }
      },

      /**
       * Binds events to arrows HTML elements.
       *
       * @param {HTMLCollection} elements
       * @return {Void}
       */
      bind: function bind(elements) {
        for (var i = 0; i < elements.length; i++) {
          Binder.on('click', elements[i], this.click);
          Binder.on('touchstart', elements[i], this.click, capture);
        }
      },

      /**
       * Unbinds events binded to the arrows HTML elements.
       *
       * @param {HTMLCollection} elements
       * @return {Void}
       */
      unbind: function unbind(elements) {
        for (var i = 0; i < elements.length; i++) {
          Binder.off(['click', 'touchstart'], elements[i]);
        }
      },

      /**
       * Handles `click` event on the arrows HTML elements.
       * Moves slider in direction given via the
       * `data-glide-dir` attribute.
       *
       * @param {Object} event
       * @return {void}
       */
      click: function click(event) {
        if (!supportsPassive$1 && event.type === 'touchstart') {
          event.preventDefault();
        }

        var direction = event.currentTarget.getAttribute('data-glide-dir');
        Components.Run.make(Components.Direction.resolve(direction));
      }
    };
    define(Controls, 'items', {
      /**
       * Gets collection of the controls HTML elements.
       *
       * @return {HTMLElement[]}
       */
      get: function get() {
        return Controls._c;
      }
    });
    /**
     * Swap active class of current navigation item:
     * - after mounting to set it to initial index
     * - after each move to the new index
     */

    Events.on(['mount.after', 'move.after'], function () {
      Controls.setActive();
    });
    /**
     * Add or remove disabled class of arrow elements
     */

    Events.on(['mount.after', 'run'], function () {
      Controls.setArrowState();
    });
    /**
     * Remove bindings and HTML Classes:
     * - on destroying, to bring markup to its initial state
     */

    Events.on('destroy', function () {
      Controls.removeBindings();
      Controls.removeActive();
      Binder.destroy();
    });
    return Controls;
  }

  function Keyboard (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var Keyboard = {
      /**
       * Binds keyboard events on component mount.
       *
       * @return {Void}
       */
      mount: function mount() {
        if (Glide.settings.keyboard) {
          this.bind();
        }
      },

      /**
       * Adds keyboard press events.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('keyup', document, this.press);
      },

      /**
       * Removes keyboard press events.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('keyup', document);
      },

      /**
       * Handles keyboard's arrows press and moving glide foward and backward.
       *
       * @param  {Object} event
       * @return {Void}
       */
      press: function press(event) {
        var perSwipe = Glide.settings.perSwipe;

        if (event.code === 'ArrowRight') {
          Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
        }

        if (event.code === 'ArrowLeft') {
          Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
        }
      }
    };
    /**
     * Remove bindings from keyboard:
     * - on destroying to remove added events
     * - on updating to remove events before remounting
     */

    Events.on(['destroy', 'update'], function () {
      Keyboard.unbind();
    });
    /**
     * Remount component
     * - on updating to reflect potential changes in settings
     */

    Events.on('update', function () {
      Keyboard.mount();
    });
    /**
     * Destroy binder:
     * - on destroying to remove listeners
     */

    Events.on('destroy', function () {
      Binder.destroy();
    });
    return Keyboard;
  }

  function Autoplay (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var Autoplay = {
      /**
       * Initializes autoplaying and events.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.enable();
        this.start();

        if (Glide.settings.hoverpause) {
          this.bind();
        }
      },

      /**
       * Enables autoplaying
       *
       * @returns {Void}
       */
      enable: function enable() {
        this._e = true;
      },

      /**
       * Disables autoplaying.
       *
       * @returns {Void}
       */
      disable: function disable() {
        this._e = false;
      },

      /**
       * Starts autoplaying in configured interval.
       *
       * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
       * @return {Void}
       */
      start: function start() {
        var _this = this;

        if (!this._e) {
          return;
        }

        this.enable();

        if (Glide.settings.autoplay) {
          if (isUndefined(this._i)) {
            this._i = setInterval(function () {
              _this.stop();

              Components.Run.make('>');

              _this.start();

              Events.emit('autoplay');
            }, this.time);
          }
        }
      },

      /**
       * Stops autorunning of the glide.
       *
       * @return {Void}
       */
      stop: function stop() {
        this._i = clearInterval(this._i);
      },

      /**
       * Stops autoplaying while mouse is over glide's area.
       *
       * @return {Void}
       */
      bind: function bind() {
        var _this2 = this;

        Binder.on('mouseover', Components.Html.root, function () {
          if (_this2._e) {
            _this2.stop();
          }
        });
        Binder.on('mouseout', Components.Html.root, function () {
          if (_this2._e) {
            _this2.start();
          }
        });
      },

      /**
       * Unbind mouseover events.
       *
       * @returns {Void}
       */
      unbind: function unbind() {
        Binder.off(['mouseover', 'mouseout'], Components.Html.root);
      }
    };
    define(Autoplay, 'time', {
      /**
       * Gets time period value for the autoplay interval. Prioritizes
       * times in `data-glide-autoplay` attrubutes over options.
       *
       * @return {Number}
       */
      get: function get() {
        var autoplay = Components.Html.slides[Glide.index].getAttribute('data-glide-autoplay');

        if (autoplay) {
          return toInt(autoplay);
        }

        return toInt(Glide.settings.autoplay);
      }
    });
    /**
     * Stop autoplaying and unbind events:
     * - on destroying, to clear defined interval
     * - on updating via API to reset interval that may changed
     */

    Events.on(['destroy', 'update'], function () {
      Autoplay.unbind();
    });
    /**
     * Stop autoplaying:
     * - before each run, to restart autoplaying
     * - on pausing via API
     * - on destroying, to clear defined interval
     * - while starting a swipe
     * - on updating via API to reset interval that may changed
     */

    Events.on(['run.before', 'swipe.start', 'update'], function () {
      Autoplay.stop();
    });
    Events.on(['pause', 'destroy'], function () {
      Autoplay.disable();
      Autoplay.stop();
    });
    /**
     * Start autoplaying:
     * - after each run, to restart autoplaying
     * - on playing via API
     * - while ending a swipe
     */

    Events.on(['run.after', 'swipe.end'], function () {
      Autoplay.start();
    });
    /**
     * Start autoplaying:
     * - after each run, to restart autoplaying
     * - on playing via API
     * - while ending a swipe
     */

    Events.on(['play'], function () {
      Autoplay.enable();
      Autoplay.start();
    });
    /**
     * Remount autoplaying:
     * - on updating via API to reset interval that may changed
     */

    Events.on('update', function () {
      Autoplay.mount();
    });
    /**
     * Destroy a binder:
     * - on destroying glide instance to clearup listeners
     */

    Events.on('destroy', function () {
      Binder.destroy();
    });
    return Autoplay;
  }

  /**
   * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
   *
   * @param {Object} points
   * @returns {Object}
   */

  function sortBreakpoints(points) {
    if (isObject(points)) {
      return sortKeys(points);
    } else {
      warn("Breakpoints option must be an object");
    }

    return {};
  }

  function Breakpoints (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    /**
     * Holds reference to settings.
     *
     * @type {Object}
     */

    var settings = Glide.settings;
    /**
     * Holds reference to breakpoints object in settings. Sorts breakpoints
     * from smaller to larger. It is required in order to proper
     * matching currently active breakpoint settings.
     *
     * @type {Object}
     */

    var points = sortBreakpoints(settings.breakpoints);
    /**
     * Cache initial settings before overwritting.
     *
     * @type {Object}
     */

    var defaults = Object.assign({}, settings);
    var Breakpoints = {
      /**
       * Matches settings for currectly matching media breakpoint.
       *
       * @param {Object} points
       * @returns {Object}
       */
      match: function match(points) {
        if (typeof window.matchMedia !== 'undefined') {
          for (var point in points) {
            if (points.hasOwnProperty(point)) {
              if (window.matchMedia("(max-width: ".concat(point, "px)")).matches) {
                return points[point];
              }
            }
          }
        }

        return defaults;
      }
    };
    /**
     * Overwrite instance settings with currently matching breakpoint settings.
     * This happens right after component initialization.
     */

    Object.assign(settings, Breakpoints.match(points));
    /**
     * Update glide with settings of matched brekpoint:
     * - window resize to update slider
     */

    Binder.on('resize', window, throttle(function () {
      Glide.settings = mergeOptions(settings, Breakpoints.match(points));
    }, Glide.settings.throttle));
    /**
     * Resort and update default settings:
     * - on reinit via API, so breakpoint matching will be performed with options
     */

    Events.on('update', function () {
      points = sortBreakpoints(points);
      defaults = Object.assign({}, settings);
    });
    /**
     * Unbind resize listener:
     * - on destroying, to bring markup to its initial state
     */

    Events.on('destroy', function () {
      Binder.off('resize', window);
    });
    return Breakpoints;
  }

  var COMPONENTS = {
    // Required
    Html: Html,
    Translate: Translate,
    Transition: Transition,
    Direction: Direction,
    Peek: Peek,
    Sizes: Sizes,
    Gaps: Gaps,
    Move: Move,
    Clones: Clones,
    Resize: Resize,
    Build: Build,
    Run: Run,
    // Optional
    Swipe: Swipe,
    Images: Images,
    Anchors: Anchors,
    Controls: Controls,
    Keyboard: Keyboard,
    Autoplay: Autoplay,
    Breakpoints: Breakpoints
  };

  var Glide = /*#__PURE__*/function (_Core) {
    _inherits(Glide, _Core);

    var _super = _createSuper(Glide);

    function Glide() {
      _classCallCheck(this, Glide);

      return _super.apply(this, arguments);
    }

    _createClass(Glide, [{
      key: "mount",
      value: function mount() {
        var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _get(_getPrototypeOf(Glide.prototype), "mount", this).call(this, Object.assign({}, COMPONENTS, extensions));
      }
    }]);

    return Glide;
  }(Glide$1);

  return Glide;

}));

},{}],12:[function(require,module,exports){
/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */

if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery')
}

+function ($) {
  'use strict';
  var version = $.fn.jquery.split(' ')[0].split('.')
  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
  }
}(jQuery);

/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: alert.js v3.3.7
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.7'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector === '#' ? [] : selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);

/* ========================================================================
 * Bootstrap: button.js v3.3.7
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.7'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);

/* ========================================================================
 * Bootstrap: carousel.js v3.3.7
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.3.7'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this   = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.3.7'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: dropdown.js v3.3.7
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.7'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);

/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.7'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.7'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.7
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.7'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.7'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

/* ========================================================================
 * Bootstrap: affix.js v3.3.7
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.7'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);

},{}],13:[function(require,module,exports){
!function(e){if(!e.hasInitialised){var t={escapeRegExp:function(e){return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")},hasClass:function(e,t){var i=" ";return 1===e.nodeType&&(i+e.className+i).replace(/[\n\t]/g,i).indexOf(i+t+i)>=0},addClass:function(e,t){e.className+=" "+t},removeClass:function(e,t){var i=new RegExp("\\b"+this.escapeRegExp(t)+"\\b");e.className=e.className.replace(i,"")},interpolateString:function(e,t){return e.replace(/{{([a-z][a-z0-9\-_]*)}}/gi,function(e){return t(arguments[1])||""})},getCookie:function(e){var t=("; "+document.cookie).split("; "+e+"=");return t.length<2?void 0:t.pop().split(";").shift()},setCookie:function(e,t,i,n,o,s){var r=new Date;r.setHours(r.getHours()+24*(i||365));var a=[e+"="+t,"expires="+r.toUTCString(),"path="+(o||"/")];n&&a.push("domain="+n),s&&a.push("secure"),document.cookie=a.join(";")},deepExtend:function(e,t){for(var i in t)t.hasOwnProperty(i)&&(i in e&&this.isPlainObject(e[i])&&this.isPlainObject(t[i])?this.deepExtend(e[i],t[i]):e[i]=t[i]);return e},throttle:function(e,t){var i=!1;return function(){i||(e.apply(this,arguments),i=!0,setTimeout(function(){i=!1},t))}},hash:function(e){var t,i,n=0;if(0===e.length)return n;for(t=0,i=e.length;t<i;++t)n=(n<<5)-n+e.charCodeAt(t),n|=0;return n},normaliseHex:function(e){return"#"==e[0]&&(e=e.substr(1)),3==e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]),e},getContrast:function(e){return e=this.normaliseHex(e),(299*parseInt(e.substr(0,2),16)+587*parseInt(e.substr(2,2),16)+114*parseInt(e.substr(4,2),16))/1e3>=128?"#000":"#fff"},getLuminance:function(e){var t=parseInt(this.normaliseHex(e),16),i=38+(t>>16),n=38+(t>>8&255),o=38+(255&t);return"#"+(16777216+65536*(i<255?i<1?0:i:255)+256*(n<255?n<1?0:n:255)+(o<255?o<1?0:o:255)).toString(16).slice(1)},isMobile:function(){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)},isPlainObject:function(e){return"object"==typeof e&&null!==e&&e.constructor==Object},traverseDOMPath:function(e,i){return e&&e.parentNode?t.hasClass(e,i)?e:this.traverseDOMPath(e.parentNode,i):null}};e.status={deny:"deny",allow:"allow",dismiss:"dismiss"},e.transitionEnd=function(){var e=document.createElement("div"),t={t:"transitionend",OT:"oTransitionEnd",msT:"MSTransitionEnd",MozT:"transitionend",WebkitT:"webkitTransitionEnd"};for(var i in t)if(t.hasOwnProperty(i)&&void 0!==e.style[i+"ransition"])return t[i];return""}(),e.hasTransition=!!e.transitionEnd;var i=Object.keys(e.status).map(t.escapeRegExp);e.customStyles={},e.Popup=function(){var n={enabled:!0,container:null,cookie:{name:"cookieconsent_status",path:"/",domain:"",expiryDays:365,secure:!1},onPopupOpen:function(){},onPopupClose:function(){},onInitialise:function(e){},onStatusChange:function(e,t){},onRevokeChoice:function(){},onNoCookieLaw:function(e,t){},content:{header:"Cookies used on the website!",message:"This website uses cookies to ensure you get the best experience on our website.",dismiss:"Got it!",allow:"Allow cookies",deny:"Decline",link:"Learn more",href:"https://www.cookiesandyou.com",close:"&#x274c;",target:"_blank",policy:"Cookie Policy"},elements:{header:'<span class="cc-header">{{header}}</span>&nbsp;',message:'<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',messagelink:'<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a></span>',dismiss:'<a aria-label="dismiss cookie message" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',allow:'<a aria-label="allow cookies" role=button tabindex="0"  class="cc-btn cc-allow">{{allow}}</a>',deny:'<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',link:'<a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a>',close:'<span aria-label="dismiss cookie message" role=button tabindex="0" class="cc-close">{{close}}</span>'},window:'<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}">\x3c!--googleoff: all--\x3e{{children}}\x3c!--googleon: all--\x3e</div>',revokeBtn:'<div class="cc-revoke {{classes}}">{{policy}}</div>',compliance:{info:'<div class="cc-compliance">{{dismiss}}</div>',"opt-in":'<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>',"opt-out":'<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>'},type:"info",layouts:{basic:"{{messagelink}}{{compliance}}","basic-close":"{{messagelink}}{{compliance}}{{close}}","basic-header":"{{header}}{{message}}{{link}}{{compliance}}"},layout:"basic",position:"bottom",theme:"block",static:!1,palette:null,revokable:!1,animateRevokable:!0,showLink:!0,dismissOnScroll:!1,dismissOnTimeout:!1,dismissOnWindowClick:!1,ignoreClicksFrom:["cc-revoke","cc-btn"],autoOpen:!0,autoAttach:!0,whitelistPage:[],blacklistPage:[],overrideHTML:null};function o(){this.initialise.apply(this,arguments)}function s(e){this.openingTimeout=null,t.removeClass(e,"cc-invisible")}function r(t){t.style.display="none",t.removeEventListener(e.transitionEnd,this.afterTransition),this.afterTransition=null}function a(){var e=this.options.position.split("-"),t=[];return e.forEach(function(e){t.push("cc-"+e)}),t}function c(n){var o=this.options,s=document.createElement("div"),r=o.container&&1===o.container.nodeType?o.container:document.body;s.innerHTML=n;var a=s.children[0];return a.style.display="none",t.hasClass(a,"cc-window")&&e.hasTransition&&t.addClass(a,"cc-invisible"),this.onButtonClick=function(n){var o=t.traverseDOMPath(n.target,"cc-btn")||n.target;if(t.hasClass(o,"cc-btn")){var s=o.className.match(new RegExp("\\bcc-("+i.join("|")+")\\b")),r=s&&s[1]||!1;r&&(this.setStatus(r),this.close(!0))}t.hasClass(o,"cc-close")&&(this.setStatus(e.status.dismiss),this.close(!0));t.hasClass(o,"cc-revoke")&&this.revokeChoice()}.bind(this),a.addEventListener("click",this.onButtonClick),o.autoAttach&&(r.firstChild?r.insertBefore(a,r.firstChild):r.appendChild(a)),a}function l(e){return"000000"==(e=t.normaliseHex(e))?"#222":t.getLuminance(e)}function u(e,t){for(var i=0,n=e.length;i<n;++i){var o=e[i];if(o instanceof RegExp&&o.test(t)||"string"==typeof o&&o.length&&o===t)return!0}return!1}return o.prototype.initialise=function(i){this.options&&this.destroy(),t.deepExtend(this.options={},n),t.isPlainObject(i)&&t.deepExtend(this.options,i),function(){var t=this.options.onInitialise.bind(this);if(!window.navigator.cookieEnabled)return t(e.status.deny),!0;if(window.CookiesOK||window.navigator.CookiesOK)return t(e.status.allow),!0;var i=Object.keys(e.status),n=this.getStatus(),o=i.indexOf(n)>=0;o&&t(n);return o}.call(this)&&(this.options.enabled=!1),u(this.options.blacklistPage,location.pathname)&&(this.options.enabled=!1),u(this.options.whitelistPage,location.pathname)&&(this.options.enabled=!0);var o=this.options.window.replace("{{classes}}",function(){var i=this.options,n="top"==i.position||"bottom"==i.position?"banner":"floating";t.isMobile()&&(n="floating");var o=["cc-"+n,"cc-type-"+i.type,"cc-theme-"+i.theme];i.static&&o.push("cc-static");o.push.apply(o,a.call(this));(function(i){var n=t.hash(JSON.stringify(i)),o="cc-color-override-"+n,s=t.isPlainObject(i);this.customStyleSelector=s?o:null,s&&function(i,n,o){if(e.customStyles[i])return void++e.customStyles[i].references;var s={},r=n.popup,a=n.button,c=n.highlight;r&&(r.text=r.text?r.text:t.getContrast(r.background),r.link=r.link?r.link:r.text,s[o+".cc-window"]=["color: "+r.text,"background-color: "+r.background],s[o+".cc-revoke"]=["color: "+r.text,"background-color: "+r.background],s[o+" .cc-link,"+o+" .cc-link:active,"+o+" .cc-link:visited"]=["color: "+r.link],a&&(a.text=a.text?a.text:t.getContrast(a.background),a.border=a.border?a.border:"transparent",s[o+" .cc-btn"]=["color: "+a.text,"border-color: "+a.border,"background-color: "+a.background],a.padding&&s[o+" .cc-btn"].push("padding: "+a.padding),"transparent"!=a.background&&(s[o+" .cc-btn:hover, "+o+" .cc-btn:focus"]=["background-color: "+(a.hover||l(a.background))]),c?(c.text=c.text?c.text:t.getContrast(c.background),c.border=c.border?c.border:"transparent",s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+c.text,"border-color: "+c.border,"background-color: "+c.background]):s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+r.text]));var u=document.createElement("style");document.head.appendChild(u),e.customStyles[i]={references:1,element:u.sheet};var h=-1;for(var p in s)s.hasOwnProperty(p)&&u.sheet.insertRule(p+"{"+s[p].join(";")+"}",++h)}(n,i,"."+o);return s}).call(this,this.options.palette);this.customStyleSelector&&o.push(this.customStyleSelector);return o}.call(this).join(" ")).replace("{{children}}",function(){var e={},i=this.options;i.showLink||(i.elements.link="",i.elements.messagelink=i.elements.message);Object.keys(i.elements).forEach(function(n){e[n]=t.interpolateString(i.elements[n],function(e){var t=i.content[e];return e&&"string"==typeof t&&t.length?t:""})});var n=i.compliance[i.type];n||(n=i.compliance.info);e.compliance=t.interpolateString(n,function(t){return e[t]});var o=i.layouts[i.layout];o||(o=i.layouts.basic);return t.interpolateString(o,function(t){return e[t]})}.call(this)),s=this.options.overrideHTML;if("string"==typeof s&&s.length&&(o=s),this.options.static){var r=c.call(this,'<div class="cc-grower">'+o+"</div>");r.style.display="",this.element=r.firstChild,this.element.style.display="none",t.addClass(this.element,"cc-invisible")}else this.element=c.call(this,o);(function(){var i=this.setStatus.bind(this),n=this.close.bind(this),o=this.options.dismissOnTimeout;"number"==typeof o&&o>=0&&(this.dismissTimeout=window.setTimeout(function(){i(e.status.dismiss),n(!0)},Math.floor(o)));var s=this.options.dismissOnScroll;if("number"==typeof s&&s>=0){var r=function(t){window.pageYOffset>Math.floor(s)&&(i(e.status.dismiss),n(!0),window.removeEventListener("scroll",r),this.onWindowScroll=null)};this.options.enabled&&(this.onWindowScroll=r,window.addEventListener("scroll",r))}var a=this.options.dismissOnWindowClick,c=this.options.ignoreClicksFrom;if(a){var l=function(o){for(var s=!1,r=o.path.length,a=c.length,u=0;u<r;u++)if(!s)for(var h=0;h<a;h++)s||(s=t.hasClass(o.path[u],c[h]));s||(i(e.status.dismiss),n(!0),window.removeEventListener("click",l),window.removeEventListener("touchend",l),this.onWindowClick=null)}.bind(this);this.options.enabled&&(this.onWindowClick=l,window.addEventListener("click",l),window.addEventListener("touchend",l))}}).call(this),function(){"info"!=this.options.type&&(this.options.revokable=!0);t.isMobile()&&(this.options.animateRevokable=!1);if(this.options.revokable){var e=a.call(this);this.options.animateRevokable&&e.push("cc-animate"),this.customStyleSelector&&e.push(this.customStyleSelector);var i=this.options.revokeBtn.replace("{{classes}}",e.join(" ")).replace("{{policy}}",this.options.content.policy);this.revokeBtn=c.call(this,i);var n=this.revokeBtn;if(this.options.animateRevokable){var o=t.throttle(function(e){var i=!1,o=window.innerHeight-20;t.hasClass(n,"cc-top")&&e.clientY<20&&(i=!0),t.hasClass(n,"cc-bottom")&&e.clientY>o&&(i=!0),i?t.hasClass(n,"cc-active")||t.addClass(n,"cc-active"):t.hasClass(n,"cc-active")&&t.removeClass(n,"cc-active")},200);this.onMouseMove=o,window.addEventListener("mousemove",o)}}}.call(this),this.options.autoOpen&&this.autoOpen()},o.prototype.destroy=function(){this.onButtonClick&&this.element&&(this.element.removeEventListener("click",this.onButtonClick),this.onButtonClick=null),this.dismissTimeout&&(clearTimeout(this.dismissTimeout),this.dismissTimeout=null),this.onWindowScroll&&(window.removeEventListener("scroll",this.onWindowScroll),this.onWindowScroll=null),this.onWindowClick&&(window.removeEventListener("click",this.onWindowClick),this.onWindowClick=null),this.onMouseMove&&(window.removeEventListener("mousemove",this.onMouseMove),this.onMouseMove=null),this.element&&this.element.parentNode&&this.element.parentNode.removeChild(this.element),this.element=null,this.revokeBtn&&this.revokeBtn.parentNode&&this.revokeBtn.parentNode.removeChild(this.revokeBtn),this.revokeBtn=null,function(i){if(t.isPlainObject(i)){var n=t.hash(JSON.stringify(i)),o=e.customStyles[n];if(o&&!--o.references){var s=o.element.ownerNode;s&&s.parentNode&&s.parentNode.removeChild(s),e.customStyles[n]=null}}}(this.options.palette),this.options=null},o.prototype.open=function(t){if(this.element)return this.isOpen()||(e.hasTransition?this.fadeIn():this.element.style.display="",this.options.revokable&&this.toggleRevokeButton(),this.options.onPopupOpen.call(this)),this},o.prototype.close=function(t){if(this.element)return this.isOpen()&&(e.hasTransition?this.fadeOut():this.element.style.display="none",t&&this.options.revokable&&this.toggleRevokeButton(!0),this.options.onPopupClose.call(this)),this},o.prototype.fadeIn=function(){var i=this.element;if(e.hasTransition&&i&&(this.afterTransition&&r.call(this,i),t.hasClass(i,"cc-invisible"))){if(i.style.display="",this.options.static){var n=this.element.clientHeight;this.element.parentNode.style.maxHeight=n+"px"}this.openingTimeout=setTimeout(s.bind(this,i),20)}},o.prototype.fadeOut=function(){var i=this.element;e.hasTransition&&i&&(this.openingTimeout&&(clearTimeout(this.openingTimeout),s.bind(this,i)),t.hasClass(i,"cc-invisible")||(this.options.static&&(this.element.parentNode.style.maxHeight=""),this.afterTransition=r.bind(this,i),i.addEventListener(e.transitionEnd,this.afterTransition),t.addClass(i,"cc-invisible")))},o.prototype.isOpen=function(){return this.element&&""==this.element.style.display&&(!e.hasTransition||!t.hasClass(this.element,"cc-invisible"))},o.prototype.toggleRevokeButton=function(e){this.revokeBtn&&(this.revokeBtn.style.display=e?"":"none")},o.prototype.revokeChoice=function(e){this.options.enabled=!0,this.clearStatus(),this.options.onRevokeChoice.call(this),e||this.autoOpen()},o.prototype.hasAnswered=function(t){return Object.keys(e.status).indexOf(this.getStatus())>=0},o.prototype.hasConsented=function(t){var i=this.getStatus();return i==e.status.allow||i==e.status.dismiss},o.prototype.autoOpen=function(e){!this.hasAnswered()&&this.options.enabled?this.open():this.hasAnswered()&&this.options.revokable&&this.toggleRevokeButton(!0)},o.prototype.setStatus=function(i){var n=this.options.cookie,o=t.getCookie(n.name),s=Object.keys(e.status).indexOf(o)>=0;Object.keys(e.status).indexOf(i)>=0?(t.setCookie(n.name,i,n.expiryDays,n.domain,n.path,n.secure),this.options.onStatusChange.call(this,i,s)):this.clearStatus()},o.prototype.getStatus=function(){return t.getCookie(this.options.cookie.name)},o.prototype.clearStatus=function(){var e=this.options.cookie;t.setCookie(e.name,"",-1,e.domain,e.path)},o}(),e.Location=function(){var e={timeout:5e3,services:["ipinfo"],serviceDefinitions:{ipinfo:function(){return{url:"//ipinfo.io",headers:["Accept: application/json"],callback:function(e,t){try{var i=JSON.parse(t);return i.error?s(i):{code:i.country}}catch(e){return s({error:"Invalid response ("+e+")"})}}}},ipinfodb:function(e){return{url:"//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return"ERROR"==i.statusCode?s({error:i.statusMessage}):{code:i.countryCode}}catch(e){return s({error:"Invalid response ("+e+")"})}}}},maxmind:function(){return{url:"//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js",isScript:!0,callback:function(e){window.geoip2?geoip2.country(function(t){try{e({code:t.country.iso_code})}catch(t){e(s(t))}},function(t){e(s(t))}):e(new Error("Unexpected response format. The downloaded script should have exported `geoip2` to the global scope"))}}}}};function i(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i),this.currentServiceIndex=-1}function n(e,t,i){var n,o=document.createElement("script");o.type="text/"+(e.type||"javascript"),o.src=e.src||e,o.async=!1,o.onreadystatechange=o.onload=function(){var e=o.readyState;clearTimeout(n),t.done||e&&!/loaded|complete/.test(e)||(t.done=!0,t(),o.onreadystatechange=o.onload=null)},document.body.appendChild(o),n=setTimeout(function(){t.done=!0,t(),o.onreadystatechange=o.onload=null},i)}function o(e,t,i,n,o){var s=new(window.XMLHttpRequest||window.ActiveXObject)("MSXML2.XMLHTTP.3.0");if(s.open(n?"POST":"GET",e,1),s.setRequestHeader("Content-type","application/x-www-form-urlencoded"),Array.isArray(o))for(var r=0,a=o.length;r<a;++r){var c=o[r].split(":",2);s.setRequestHeader(c[0].replace(/^\s+|\s+$/g,""),c[1].replace(/^\s+|\s+$/g,""))}"function"==typeof t&&(s.onreadystatechange=function(){s.readyState>3&&t(s)}),s.send(n)}function s(e){return new Error("Error ["+(e.code||"UNKNOWN")+"]: "+e.error)}return i.prototype.getNextService=function(){var e;do{e=this.getServiceByIdx(++this.currentServiceIndex)}while(this.currentServiceIndex<this.options.services.length&&!e);return e},i.prototype.getServiceByIdx=function(e){var i=this.options.services[e];if("function"==typeof i){var n=i();return n.name&&t.deepExtend(n,this.options.serviceDefinitions[n.name](n)),n}return"string"==typeof i?this.options.serviceDefinitions[i]():t.isPlainObject(i)?this.options.serviceDefinitions[i.name](i):null},i.prototype.locate=function(e,t){var i=this.getNextService();i?(this.callbackComplete=e,this.callbackError=t,this.runService(i,this.runNextServiceOnError.bind(this))):t(new Error("No services to run"))},i.prototype.setupUrl=function(e){var t=this.getCurrentServiceOpts();return e.url.replace(/\{(.*?)\}/g,function(i,n){if("callback"===n){var o="callback"+Date.now();return window[o]=function(t){e.__JSONP_DATA=JSON.stringify(t)},o}if(n in t.interpolateUrl)return t.interpolateUrl[n]})},i.prototype.runService=function(e,t){var i=this;e&&e.url&&e.callback&&(e.isScript?n:o)(this.setupUrl(e),function(n){var o=n?n.responseText:"";e.__JSONP_DATA&&(o=e.__JSONP_DATA,delete e.__JSONP_DATA),i.runServiceCallback.call(i,t,e,o)},this.options.timeout,e.data,e.headers)},i.prototype.runServiceCallback=function(e,t,i){var n=this,o=t.callback(function(t){o||n.onServiceResult.call(n,e,t)},i);o&&this.onServiceResult.call(this,e,o)},i.prototype.onServiceResult=function(e,t){t instanceof Error||t&&t.error?e.call(this,t,null):e.call(this,null,t)},i.prototype.runNextServiceOnError=function(e,t){if(e){this.logError(e);var i=this.getNextService();i?this.runService(i,this.runNextServiceOnError.bind(this)):this.completeService.call(this,this.callbackError,new Error("All services failed"))}else this.completeService.call(this,this.callbackComplete,t)},i.prototype.getCurrentServiceOpts=function(){var e=this.options.services[this.currentServiceIndex];return"string"==typeof e?{name:e}:"function"==typeof e?e():t.isPlainObject(e)?e:{}},i.prototype.completeService=function(e,t){this.currentServiceIndex=-1,e&&e(t)},i.prototype.logError=function(e){var t=this.currentServiceIndex,i=this.getServiceByIdx(t);console.warn("The service["+t+"] ("+i.url+") responded with the following error",e)},i}(),e.Law=function(){var e={regionalLaw:!0,hasLaw:["AT","BE","BG","HR","CZ","CY","DK","EE","FI","FR","DE","EL","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","SK","ES","SE","GB","UK","GR","EU"],revokable:["HR","CY","DK","EE","FR","DE","LV","LT","NL","PT","ES"],explicitAction:["HR","IT","ES"]};function i(e){this.initialise.apply(this,arguments)}return i.prototype.initialise=function(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i)},i.prototype.get=function(e){var t=this.options;return{hasLaw:t.hasLaw.indexOf(e)>=0,revokable:t.revokable.indexOf(e)>=0,explicitAction:t.explicitAction.indexOf(e)>=0}},i.prototype.applyLaw=function(e,t){var i=this.get(t);return i.hasLaw||(e.enabled=!1,"function"==typeof e.onNoCookieLaw&&e.onNoCookieLaw(t,i)),this.options.regionalLaw&&(i.revokable&&(e.revokable=!0),i.explicitAction&&(e.dismissOnScroll=!1,e.dismissOnTimeout=!1)),e},i}(),e.initialise=function(i,n,o){var s=new e.Law(i.law);n||(n=function(){}),o||(o=function(){});var r=Object.keys(e.status),a=t.getCookie("cookieconsent_status");r.indexOf(a)>=0?n(new e.Popup(i)):e.getCountryCode(i,function(t){delete i.law,delete i.location,t.code&&(i=s.applyLaw(i,t.code)),n(new e.Popup(i))},function(t){delete i.law,delete i.location,o(t,new e.Popup(i))})},e.getCountryCode=function(t,i,n){t.law&&t.law.countryCode?i({code:t.law.countryCode}):t.location?new e.Location(t.location).locate(function(e){i(e||{})},n):i({})},e.utils=t,e.hasInitialised=!0,window.cookieconsent=e}}(window.cookieconsent||{});
},{}],14:[function(require,module,exports){
/*
 * International Telephone Input v16.1.0
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */

// wrap in UMD
(function(factory) {
    if (typeof module === "object" && module.exports) module.exports = factory(); else window.intlTelInput = factory();
})(function(undefined) {
    "use strict";
    return function() {
        // Array of country objects for the flag dropdown.
        // Here is the criteria for the plugin to support a given country/territory
        // - It has an iso2 code: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
        // - It has it's own country calling code (it is not a sub-region of another country): https://en.wikipedia.org/wiki/List_of_country_calling_codes
        // - It has a flag in the region-flags project: https://github.com/behdad/region-flags/tree/gh-pages/png
        // - It is supported by libphonenumber (it must be listed on this page): https://github.com/googlei18n/libphonenumber/blob/master/resources/ShortNumberMetadata.xml
        // Each country array has the following information:
        // [
        //    Country name,
        //    iso2 code,
        //    International dial code,
        //    Order (if >1 country with same dial code),
        //    Area codes
        // ]
        var allCountries = [ [ "Afghanistan (‫افغانستان‬‎)", "af", "93" ], [ "Albania (Shqipëri)", "al", "355" ], [ "Algeria (‫الجزائر‬‎)", "dz", "213" ], [ "American Samoa", "as", "1", 5, [ "684" ] ], [ "Andorra", "ad", "376" ], [ "Angola", "ao", "244" ], [ "Anguilla", "ai", "1", 6, [ "264" ] ], [ "Antigua and Barbuda", "ag", "1", 7, [ "268" ] ], [ "Argentina", "ar", "54" ], [ "Armenia (Հայաստան)", "am", "374" ], [ "Aruba", "aw", "297" ], [ "Australia", "au", "61", 0 ], [ "Austria (Österreich)", "at", "43" ], [ "Azerbaijan (Azərbaycan)", "az", "994" ], [ "Bahamas", "bs", "1", 8, [ "242" ] ], [ "Bahrain (‫البحرين‬‎)", "bh", "973" ], [ "Bangladesh (বাংলাদেশ)", "bd", "880" ], [ "Barbados", "bb", "1", 9, [ "246" ] ], [ "Belarus (Беларусь)", "by", "375" ], [ "Belgium (België)", "be", "32" ], [ "Belize", "bz", "501" ], [ "Benin (Bénin)", "bj", "229" ], [ "Bermuda", "bm", "1", 10, [ "441" ] ], [ "Bhutan (འབྲུག)", "bt", "975" ], [ "Bolivia", "bo", "591" ], [ "Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387" ], [ "Botswana", "bw", "267" ], [ "Brazil (Brasil)", "br", "55" ], [ "British Indian Ocean Territory", "io", "246" ], [ "British Virgin Islands", "vg", "1", 11, [ "284" ] ], [ "Brunei", "bn", "673" ], [ "Bulgaria (България)", "bg", "359" ], [ "Burkina Faso", "bf", "226" ], [ "Burundi (Uburundi)", "bi", "257" ], [ "Cambodia (កម្ពុជា)", "kh", "855" ], [ "Cameroon (Cameroun)", "cm", "237" ], [ "Canada", "ca", "1", 1, [ "204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905" ] ], [ "Cape Verde (Kabu Verdi)", "cv", "238" ], [ "Caribbean Netherlands", "bq", "599", 1, [ "3", "4", "7" ] ], [ "Cayman Islands", "ky", "1", 12, [ "345" ] ], [ "Central African Republic (République centrafricaine)", "cf", "236" ], [ "Chad (Tchad)", "td", "235" ], [ "Chile", "cl", "56" ], [ "China (中国)", "cn", "86" ], [ "Christmas Island", "cx", "61", 2 ], [ "Cocos (Keeling) Islands", "cc", "61", 1 ], [ "Colombia", "co", "57" ], [ "Comoros (‫جزر القمر‬‎)", "km", "269" ], [ "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243" ], [ "Congo (Republic) (Congo-Brazzaville)", "cg", "242" ], [ "Cook Islands", "ck", "682" ], [ "Costa Rica", "cr", "506" ], [ "Côte d’Ivoire", "ci", "225" ], [ "Croatia (Hrvatska)", "hr", "385" ], [ "Cuba", "cu", "53" ], [ "Curaçao", "cw", "599", 0 ], [ "Cyprus (Κύπρος)", "cy", "357" ], [ "Czech Republic (Česká republika)", "cz", "420" ], [ "Denmark (Danmark)", "dk", "45" ], [ "Djibouti", "dj", "253" ], [ "Dominica", "dm", "1", 13, [ "767" ] ], [ "Dominican Republic (República Dominicana)", "do", "1", 2, [ "809", "829", "849" ] ], [ "Ecuador", "ec", "593" ], [ "Egypt (‫مصر‬‎)", "eg", "20" ], [ "El Salvador", "sv", "503" ], [ "Equatorial Guinea (Guinea Ecuatorial)", "gq", "240" ], [ "Eritrea", "er", "291" ], [ "Estonia (Eesti)", "ee", "372" ], [ "Ethiopia", "et", "251" ], [ "Falkland Islands (Islas Malvinas)", "fk", "500" ], [ "Faroe Islands (Føroyar)", "fo", "298" ], [ "Fiji", "fj", "679" ], [ "Finland (Suomi)", "fi", "358", 0 ], [ "France", "fr", "33" ], [ "French Guiana (Guyane française)", "gf", "594" ], [ "French Polynesia (Polynésie française)", "pf", "689" ], [ "Gabon", "ga", "241" ], [ "Gambia", "gm", "220" ], [ "Georgia (საქართველო)", "ge", "995" ], [ "Germany (Deutschland)", "de", "49" ], [ "Ghana (Gaana)", "gh", "233" ], [ "Gibraltar", "gi", "350" ], [ "Greece (Ελλάδα)", "gr", "30" ], [ "Greenland (Kalaallit Nunaat)", "gl", "299" ], [ "Grenada", "gd", "1", 14, [ "473" ] ], [ "Guadeloupe", "gp", "590", 0 ], [ "Guam", "gu", "1", 15, [ "671" ] ], [ "Guatemala", "gt", "502" ], [ "Guernsey", "gg", "44", 1, [ "1481", "7781", "7839", "7911" ] ], [ "Guinea (Guinée)", "gn", "224" ], [ "Guinea-Bissau (Guiné Bissau)", "gw", "245" ], [ "Guyana", "gy", "592" ], [ "Haiti", "ht", "509" ], [ "Honduras", "hn", "504" ], [ "Hong Kong (香港)", "hk", "852" ], [ "Hungary (Magyarország)", "hu", "36" ], [ "Iceland (Ísland)", "is", "354" ], [ "India (भारत)", "in", "91" ], [ "Indonesia", "id", "62" ], [ "Iran (‫ایران‬‎)", "ir", "98" ], [ "Iraq (‫العراق‬‎)", "iq", "964" ], [ "Ireland", "ie", "353" ], [ "Isle of Man", "im", "44", 2, [ "1624", "74576", "7524", "7924", "7624" ] ], [ "Israel (‫ישראל‬‎)", "il", "972" ], [ "Italy (Italia)", "it", "39", 0 ], [ "Jamaica", "jm", "1", 4, [ "876", "658" ] ], [ "Japan (日本)", "jp", "81" ], [ "Jersey", "je", "44", 3, [ "1534", "7509", "7700", "7797", "7829", "7937" ] ], [ "Jordan (‫الأردن‬‎)", "jo", "962" ], [ "Kazakhstan (Казахстан)", "kz", "7", 1, [ "33", "7" ] ], [ "Kenya", "ke", "254" ], [ "Kiribati", "ki", "686" ], [ "Kosovo", "xk", "383" ], [ "Kuwait (‫الكويت‬‎)", "kw", "965" ], [ "Kyrgyzstan (Кыргызстан)", "kg", "996" ], [ "Laos (ລາວ)", "la", "856" ], [ "Latvia (Latvija)", "lv", "371" ], [ "Lebanon (‫لبنان‬‎)", "lb", "961" ], [ "Lesotho", "ls", "266" ], [ "Liberia", "lr", "231" ], [ "Libya (‫ليبيا‬‎)", "ly", "218" ], [ "Liechtenstein", "li", "423" ], [ "Lithuania (Lietuva)", "lt", "370" ], [ "Luxembourg", "lu", "352" ], [ "Macau (澳門)", "mo", "853" ], [ "Macedonia (FYROM) (Македонија)", "mk", "389" ], [ "Madagascar (Madagasikara)", "mg", "261" ], [ "Malawi", "mw", "265" ], [ "Malaysia", "my", "60" ], [ "Maldives", "mv", "960" ], [ "Mali", "ml", "223" ], [ "Malta", "mt", "356" ], [ "Marshall Islands", "mh", "692" ], [ "Martinique", "mq", "596" ], [ "Mauritania (‫موريتانيا‬‎)", "mr", "222" ], [ "Mauritius (Moris)", "mu", "230" ], [ "Mayotte", "yt", "262", 1, [ "269", "639" ] ], [ "Mexico (México)", "mx", "52" ], [ "Micronesia", "fm", "691" ], [ "Moldova (Republica Moldova)", "md", "373" ], [ "Monaco", "mc", "377" ], [ "Mongolia (Монгол)", "mn", "976" ], [ "Montenegro (Crna Gora)", "me", "382" ], [ "Montserrat", "ms", "1", 16, [ "664" ] ], [ "Morocco (‫المغرب‬‎)", "ma", "212", 0 ], [ "Mozambique (Moçambique)", "mz", "258" ], [ "Myanmar (Burma) (မြန်မာ)", "mm", "95" ], [ "Namibia (Namibië)", "na", "264" ], [ "Nauru", "nr", "674" ], [ "Nepal (नेपाल)", "np", "977" ], [ "Netherlands (Nederland)", "nl", "31" ], [ "New Caledonia (Nouvelle-Calédonie)", "nc", "687" ], [ "New Zealand", "nz", "64" ], [ "Nicaragua", "ni", "505" ], [ "Niger (Nijar)", "ne", "227" ], [ "Nigeria", "ng", "234" ], [ "Niue", "nu", "683" ], [ "Norfolk Island", "nf", "672" ], [ "North Korea (조선 민주주의 인민 공화국)", "kp", "850" ], [ "Northern Mariana Islands", "mp", "1", 17, [ "670" ] ], [ "Norway (Norge)", "no", "47", 0 ], [ "Oman (‫عُمان‬‎)", "om", "968" ], [ "Pakistan (‫پاکستان‬‎)", "pk", "92" ], [ "Palau", "pw", "680" ], [ "Palestine (‫فلسطين‬‎)", "ps", "970" ], [ "Panama (Panamá)", "pa", "507" ], [ "Papua New Guinea", "pg", "675" ], [ "Paraguay", "py", "595" ], [ "Peru (Perú)", "pe", "51" ], [ "Philippines", "ph", "63" ], [ "Poland (Polska)", "pl", "48" ], [ "Portugal", "pt", "351" ], [ "Puerto Rico", "pr", "1", 3, [ "787", "939" ] ], [ "Qatar (‫قطر‬‎)", "qa", "974" ], [ "Réunion (La Réunion)", "re", "262", 0 ], [ "Romania (România)", "ro", "40" ], [ "Russia (Россия)", "ru", "7", 0 ], [ "Rwanda", "rw", "250" ], [ "Saint Barthélemy", "bl", "590", 1 ], [ "Saint Helena", "sh", "290" ], [ "Saint Kitts and Nevis", "kn", "1", 18, [ "869" ] ], [ "Saint Lucia", "lc", "1", 19, [ "758" ] ], [ "Saint Martin (Saint-Martin (partie française))", "mf", "590", 2 ], [ "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508" ], [ "Saint Vincent and the Grenadines", "vc", "1", 20, [ "784" ] ], [ "Samoa", "ws", "685" ], [ "San Marino", "sm", "378" ], [ "São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239" ], [ "Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966" ], [ "Senegal (Sénégal)", "sn", "221" ], [ "Serbia (Србија)", "rs", "381" ], [ "Seychelles", "sc", "248" ], [ "Sierra Leone", "sl", "232" ], [ "Singapore", "sg", "65" ], [ "Sint Maarten", "sx", "1", 21, [ "721" ] ], [ "Slovakia (Slovensko)", "sk", "421" ], [ "Slovenia (Slovenija)", "si", "386" ], [ "Solomon Islands", "sb", "677" ], [ "Somalia (Soomaaliya)", "so", "252" ], [ "South Africa", "za", "27" ], [ "South Korea (대한민국)", "kr", "82" ], [ "South Sudan (‫جنوب السودان‬‎)", "ss", "211" ], [ "Spain (España)", "es", "34" ], [ "Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94" ], [ "Sudan (‫السودان‬‎)", "sd", "249" ], [ "Suriname", "sr", "597" ], [ "Svalbard and Jan Mayen", "sj", "47", 1, [ "79" ] ], [ "Swaziland", "sz", "268" ], [ "Sweden (Sverige)", "se", "46" ], [ "Switzerland (Schweiz)", "ch", "41" ], [ "Syria (‫سوريا‬‎)", "sy", "963" ], [ "Taiwan (台灣)", "tw", "886" ], [ "Tajikistan", "tj", "992" ], [ "Tanzania", "tz", "255" ], [ "Thailand (ไทย)", "th", "66" ], [ "Timor-Leste", "tl", "670" ], [ "Togo", "tg", "228" ], [ "Tokelau", "tk", "690" ], [ "Tonga", "to", "676" ], [ "Trinidad and Tobago", "tt", "1", 22, [ "868" ] ], [ "Tunisia (‫تونس‬‎)", "tn", "216" ], [ "Turkey (Türkiye)", "tr", "90" ], [ "Turkmenistan", "tm", "993" ], [ "Turks and Caicos Islands", "tc", "1", 23, [ "649" ] ], [ "Tuvalu", "tv", "688" ], [ "U.S. Virgin Islands", "vi", "1", 24, [ "340" ] ], [ "Uganda", "ug", "256" ], [ "Ukraine (Україна)", "ua", "380" ], [ "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971" ], [ "United Kingdom", "gb", "44", 0 ], [ "United States", "us", "1", 0 ], [ "Uruguay", "uy", "598" ], [ "Uzbekistan (Oʻzbekiston)", "uz", "998" ], [ "Vanuatu", "vu", "678" ], [ "Vatican City (Città del Vaticano)", "va", "39", 1, [ "06698" ] ], [ "Venezuela", "ve", "58" ], [ "Vietnam (Việt Nam)", "vn", "84" ], [ "Wallis and Futuna (Wallis-et-Futuna)", "wf", "681" ], [ "Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212", 1, [ "5288", "5289" ] ], [ "Yemen (‫اليمن‬‎)", "ye", "967" ], [ "Zambia", "zm", "260" ], [ "Zimbabwe", "zw", "263" ], [ "Åland Islands", "ax", "358", 1, [ "18" ] ] ];
        // loop over all of the countries above, restructuring the data to be objects with named keys
        for (var i = 0; i < allCountries.length; i++) {
            var c = allCountries[i];
            allCountries[i] = {
                name: c[0],
                iso2: c[1],
                dialCode: c[2],
                priority: c[3] || 0,
                areaCodes: c[4] || null
            };
        }
        "use strict";
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }
        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
        }
        var intlTelInputGlobals = {
            getInstance: function getInstance(input) {
                var id = input.getAttribute("data-intl-tel-input-id");
                return window.intlTelInputGlobals.instances[id];
            },
            instances: {}
        };
        if (typeof window === "object") window.intlTelInputGlobals = intlTelInputGlobals;
        // these vars persist through all instances of the plugin
        var id = 0;
        var defaults = {
            // whether or not to allow the dropdown
            allowDropdown: true,
            // if there is just a dial code in the input: remove it on blur
            autoHideDialCode: true,
            // add a placeholder in the input with an example number for the selected country
            autoPlaceholder: "polite",
            // modify the parentClass
            customContainer: "",
            // modify the auto placeholder
            customPlaceholder: null,
            // append menu to specified element
            dropdownContainer: null,
            // don't display these countries
            excludeCountries: [],
            // format the input value during initialisation and on setNumber
            formatOnDisplay: true,
            // geoIp lookup function
            geoIpLookup: null,
            // inject a hidden input with this name, and on submit, populate it with the result of getNumber
            hiddenInput: "",
            // initial country
            initialCountry: "",
            // localized country names e.g. { 'de': 'Deutschland' }
            localizedCountries: null,
            // don't insert international dial codes
            nationalMode: true,
            // display only these countries
            onlyCountries: [],
            // number type to use for placeholders
            placeholderNumberType: "MOBILE",
            // the countries at the top of the list. defaults to united states and united kingdom
            preferredCountries: [ "us", "gb" ],
            // display the country dial code next to the selected flag so it's not part of the typed number
            separateDialCode: false,
            // specify the path to the libphonenumber script to enable validation/formatting
            utilsScript: ""
        };
        // https://en.wikipedia.org/wiki/List_of_North_American_Numbering_Plan_area_codes#Non-geographic_area_codes
        var regionlessNanpNumbers = [ "800", "822", "833", "844", "855", "866", "877", "880", "881", "882", "883", "884", "885", "886", "887", "888", "889" ];
        if (typeof window === "object") {
            // keep track of if the window.load event has fired as impossible to check after the fact
            window.addEventListener("load", function() {
                // UPDATE: use a public static field so we can fudge it in the tests
                window.intlTelInputGlobals.windowLoaded = true;
            });
        }
        // utility function to iterate over an object. can't use Object.entries or native forEach because
        // of IE11
        var forEachProp = function forEachProp(obj, callback) {
            var keys = Object.keys(obj);
            for (var i = 0; i < keys.length; i++) {
                callback(keys[i], obj[keys[i]]);
            }
        };
        // run a method on each instance of the plugin
        var forEachInstance = function forEachInstance(method) {
            forEachProp(window.intlTelInputGlobals.instances, function(key) {
                window.intlTelInputGlobals.instances[key][method]();
            });
        };
        // this is our plugin class that we will create an instance of
        // eslint-disable-next-line no-unused-vars
        var Iti = /*#__PURE__*/
        function() {
            function Iti(input, options) {
                var _this = this;
                _classCallCheck(this, Iti);
                this.id = id++;
                this.telInput = input;
                this.activeItem = null;
                this.highlightedItem = null;
                // process specified options / defaults
                // alternative to Object.assign, which isn't supported by IE11
                var customOptions = options || {};
                this.options = {};
                forEachProp(defaults, function(key, value) {
                    _this.options[key] = customOptions.hasOwnProperty(key) ? customOptions[key] : value;
                });
                this.hadInitialPlaceholder = Boolean(input.getAttribute("placeholder"));
            }
            _createClass(Iti, [ {
                key: "_init",
                value: function _init() {
                    var _this2 = this;
                    // if in nationalMode, disable options relating to dial codes
                    if (this.options.nationalMode) this.options.autoHideDialCode = false;
                    // if separateDialCode then doesn't make sense to A) insert dial code into input
                    // (autoHideDialCode), and B) display national numbers (because we're displaying the country
                    // dial code next to them)
                    if (this.options.separateDialCode) {
                        this.options.autoHideDialCode = this.options.nationalMode = false;
                    }
                    // we cannot just test screen size as some smartphones/website meta tags will report desktop
                    // resolutions
                    // Note: for some reason jasmine breaks if you put this in the main Plugin function with the
                    // rest of these declarations
                    // Note: to target Android Mobiles (and not Tablets), we must find 'Android' and 'Mobile'
                    this.isMobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                    if (this.isMobile) {
                        // trigger the mobile dropdown css
                        document.body.classList.add("iti-mobile");
                        // on mobile, we want a full screen dropdown, so we must append it to the body
                        if (!this.options.dropdownContainer) this.options.dropdownContainer = document.body;
                    }
                    // these promises get resolved when their individual requests complete
                    // this way the dev can do something like iti.promise.then(...) to know when all requests are
                    // complete
                    if (typeof Promise !== "undefined") {
                        var autoCountryPromise = new Promise(function(resolve, reject) {
                            _this2.resolveAutoCountryPromise = resolve;
                            _this2.rejectAutoCountryPromise = reject;
                        });
                        var utilsScriptPromise = new Promise(function(resolve, reject) {
                            _this2.resolveUtilsScriptPromise = resolve;
                            _this2.rejectUtilsScriptPromise = reject;
                        });
                        this.promise = Promise.all([ autoCountryPromise, utilsScriptPromise ]);
                    } else {
                        // prevent errors when Promise doesn't exist
                        this.resolveAutoCountryPromise = this.rejectAutoCountryPromise = function() {};
                        this.resolveUtilsScriptPromise = this.rejectUtilsScriptPromise = function() {};
                    }
                    // in various situations there could be no country selected initially, but we need to be able
                    // to assume this variable exists
                    this.selectedCountryData = {};
                    // process all the data: onlyCountries, excludeCountries, preferredCountries etc
                    this._processCountryData();
                    // generate the markup
                    this._generateMarkup();
                    // set the initial state of the input value and the selected flag
                    this._setInitialState();
                    // start all of the event listeners: autoHideDialCode, input keydown, selectedFlag click
                    this._initListeners();
                    // utils script, and auto country
                    this._initRequests();
                }
            }, {
                key: "_processCountryData",
                value: function _processCountryData() {
                    // process onlyCountries or excludeCountries array if present
                    this._processAllCountries();
                    // process the countryCodes map
                    this._processCountryCodes();
                    // process the preferredCountries
                    this._processPreferredCountries();
                    // translate countries according to localizedCountries option
                    if (this.options.localizedCountries) this._translateCountriesByLocale();
                    // sort countries by name
                    if (this.options.onlyCountries.length || this.options.localizedCountries) {
                        this.countries.sort(this._countryNameSort);
                    }
                }
            }, {
                key: "_addCountryCode",
                value: function _addCountryCode(iso2, dialCode, priority) {
                    if (dialCode.length > this.dialCodeMaxLen) {
                        this.dialCodeMaxLen = dialCode.length;
                    }
                    if (!this.countryCodes.hasOwnProperty(dialCode)) {
                        this.countryCodes[dialCode] = [];
                    }
                    // bail if we already have this country for this dialCode
                    for (var i = 0; i < this.countryCodes[dialCode].length; i++) {
                        if (this.countryCodes[dialCode][i] === iso2) return;
                    }
                    // check for undefined as 0 is falsy
                    var index = priority !== undefined ? priority : this.countryCodes[dialCode].length;
                    this.countryCodes[dialCode][index] = iso2;
                }
            }, {
                key: "_processAllCountries",
                value: function _processAllCountries() {
                    if (this.options.onlyCountries.length) {
                        var lowerCaseOnlyCountries = this.options.onlyCountries.map(function(country) {
                            return country.toLowerCase();
                        });
                        this.countries = allCountries.filter(function(country) {
                            return lowerCaseOnlyCountries.indexOf(country.iso2) > -1;
                        });
                    } else if (this.options.excludeCountries.length) {
                        var lowerCaseExcludeCountries = this.options.excludeCountries.map(function(country) {
                            return country.toLowerCase();
                        });
                        this.countries = allCountries.filter(function(country) {
                            return lowerCaseExcludeCountries.indexOf(country.iso2) === -1;
                        });
                    } else {
                        this.countries = allCountries;
                    }
                }
            }, {
                key: "_translateCountriesByLocale",
                value: function _translateCountriesByLocale() {
                    for (var i = 0; i < this.countries.length; i++) {
                        var iso = this.countries[i].iso2.toLowerCase();
                        if (this.options.localizedCountries.hasOwnProperty(iso)) {
                            this.countries[i].name = this.options.localizedCountries[iso];
                        }
                    }
                }
            }, {
                key: "_countryNameSort",
                value: function _countryNameSort(a, b) {
                    return a.name.localeCompare(b.name);
                }
            }, {
                key: "_processCountryCodes",
                value: function _processCountryCodes() {
                    this.dialCodeMaxLen = 0;
                    this.countryCodes = {};
                    // first: add dial codes
                    for (var i = 0; i < this.countries.length; i++) {
                        var c = this.countries[i];
                        this._addCountryCode(c.iso2, c.dialCode, c.priority);
                    }
                    // next: add area codes
                    // this is a second loop over countries, to make sure we have all of the "root" countries
                    // already in the map, so that we can access them, as each time we add an area code substring
                    // to the map, we also need to include the "root" country's code, as that also matches
                    for (var _i = 0; _i < this.countries.length; _i++) {
                        var _c = this.countries[_i];
                        // area codes
                        if (_c.areaCodes) {
                            var rootCountryCode = this.countryCodes[_c.dialCode][0];
                            // for each area code
                            for (var j = 0; j < _c.areaCodes.length; j++) {
                                var areaCode = _c.areaCodes[j];
                                // for each digit in the area code to add all partial matches as well
                                for (var k = 1; k < areaCode.length; k++) {
                                    var partialDialCode = _c.dialCode + areaCode.substr(0, k);
                                    // start with the root country, as that also matches this dial code
                                    this._addCountryCode(rootCountryCode, partialDialCode);
                                    this._addCountryCode(_c.iso2, partialDialCode);
                                }
                                // add the full area code
                                this._addCountryCode(_c.iso2, _c.dialCode + areaCode);
                            }
                        }
                    }
                }
            }, {
                key: "_processPreferredCountries",
                value: function _processPreferredCountries() {
                    this.preferredCountries = [];
                    for (var i = 0; i < this.options.preferredCountries.length; i++) {
                        var countryCode = this.options.preferredCountries[i].toLowerCase();
                        var countryData = this._getCountryData(countryCode, false, true);
                        if (countryData) this.preferredCountries.push(countryData);
                    }
                }
            }, {
                key: "_createEl",
                value: function _createEl(name, attrs, container) {
                    var el = document.createElement(name);
                    if (attrs) forEachProp(attrs, function(key, value) {
                        return el.setAttribute(key, value);
                    });
                    if (container) container.appendChild(el);
                    return el;
                }
            }, {
                key: "_generateMarkup",
                value: function _generateMarkup() {
                    // if autocomplete does not exist on the element and its form, then
                    // prevent autocomplete as there's no safe, cross-browser event we can react to, so it can
                    // easily put the plugin in an inconsistent state e.g. the wrong flag selected for the
                    // autocompleted number, which on submit could mean wrong number is saved (esp in nationalMode)
                    if (!this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete"))) {
                        this.telInput.setAttribute("autocomplete", "off");
                    }
                    // containers (mostly for positioning)
                    var parentClass = "iti";
                    if (this.options.allowDropdown) parentClass += " iti--allow-dropdown";
                    if (this.options.separateDialCode) parentClass += " iti--separate-dial-code";
                    if (this.options.customContainer) {
                        parentClass += " ";
                        parentClass += this.options.customContainer;
                    }
                    var wrapper = this._createEl("div", {
                        "class": parentClass
                    });
                    this.telInput.parentNode.insertBefore(wrapper, this.telInput);
                    this.flagsContainer = this._createEl("div", {
                        "class": "iti__flag-container"
                    }, wrapper);
                    wrapper.appendChild(this.telInput);
                    // selected flag (displayed to left of input)
                    this.selectedFlag = this._createEl("div", {
                        "class": "iti__selected-flag",
                        role: "combobox",
                        "aria-owns": "country-listbox",
                        "aria-expanded": "false"
                    }, this.flagsContainer);
                    this.selectedFlagInner = this._createEl("div", {
                        "class": "iti__flag"
                    }, this.selectedFlag);
                    if (this.options.separateDialCode) {
                        this.selectedDialCode = this._createEl("div", {
                            "class": "iti__selected-dial-code"
                        }, this.selectedFlag);
                    }
                    if (this.options.allowDropdown) {
                        // make element focusable and tab navigable
                        this.selectedFlag.setAttribute("tabindex", "0");
                        this.dropdownArrow = this._createEl("div", {
                            "class": "iti__arrow"
                        }, this.selectedFlag);
                        // country dropdown: preferred countries, then divider, then all countries
                        this.countryList = this._createEl("ul", {
                            "class": "iti__country-list iti__hide",
                            id: "country-listbox",
                            role: "listbox"
                        });
                        if (this.preferredCountries.length) {
                            this._appendListItems(this.preferredCountries, "iti__preferred");
                            this._createEl("li", {
                                "class": "iti__divider",
                                role: "separator",
                                "aria-disabled": "true"
                            }, this.countryList);
                        }
                        this._appendListItems(this.countries, "iti__standard");
                        // create dropdownContainer markup
                        if (this.options.dropdownContainer) {
                            this.dropdown = this._createEl("div", {
                                "class": "iti iti--container"
                            });
                            this.dropdown.appendChild(this.countryList);
                        } else {
                            this.flagsContainer.appendChild(this.countryList);
                        }
                    }
                    if (this.options.hiddenInput) {
                        var hiddenInputName = this.options.hiddenInput;
                        var name = this.telInput.getAttribute("name");
                        if (name) {
                            var i = name.lastIndexOf("[");
                            // if input name contains square brackets, then give the hidden input the same name,
                            // replacing the contents of the last set of brackets with the given hiddenInput name
                            if (i !== -1) hiddenInputName = "".concat(name.substr(0, i), "[").concat(hiddenInputName, "]");
                        }
                        this.hiddenInput = this._createEl("input", {
                            type: "hidden",
                            name: hiddenInputName
                        });
                        wrapper.appendChild(this.hiddenInput);
                    }
                }
            }, {
                key: "_appendListItems",
                value: function _appendListItems(countries, className) {
                    // we create so many DOM elements, it is faster to build a temp string
                    // and then add everything to the DOM in one go at the end
                    var tmp = "";
                    // for each country
                    for (var i = 0; i < countries.length; i++) {
                        var c = countries[i];
                        // open the list item
                        tmp += "<li class='iti__country ".concat(className, "' tabIndex='-1' id='iti-item-").concat(c.iso2, "' role='option' data-dial-code='").concat(c.dialCode, "' data-country-code='").concat(c.iso2, "'>");
                        // add the flag
                        tmp += "<div class='iti__flag-box'><div class='iti__flag iti__".concat(c.iso2, "'></div></div>");
                        // and the country name and dial code
                        tmp += "<span class='iti__country-name'>".concat(c.name, "</span>");
                        tmp += "<span class='iti__dial-code'>+".concat(c.dialCode, "</span>");
                        // close the list item
                        tmp += "</li>";
                    }
                    this.countryList.insertAdjacentHTML("beforeend", tmp);
                }
            }, {
                key: "_setInitialState",
                value: function _setInitialState() {
                    var val = this.telInput.value;
                    var dialCode = this._getDialCode(val);
                    var isRegionlessNanp = this._isRegionlessNanp(val);
                    var _this$options = this.options, initialCountry = _this$options.initialCountry, nationalMode = _this$options.nationalMode, autoHideDialCode = _this$options.autoHideDialCode, separateDialCode = _this$options.separateDialCode;
                    // if we already have a dial code, and it's not a regionlessNanp, we can go ahead and set the
                    // flag, else fall back to the default country
                    if (dialCode && !isRegionlessNanp) {
                        this._updateFlagFromNumber(val);
                    } else if (initialCountry !== "auto") {
                        // see if we should select a flag
                        if (initialCountry) {
                            this._setFlag(initialCountry.toLowerCase());
                        } else {
                            if (dialCode && isRegionlessNanp) {
                                // has intl dial code, is regionless nanp, and no initialCountry, so default to US
                                this._setFlag("us");
                            } else {
                                // no dial code and no initialCountry, so default to first in list
                                this.defaultCountry = this.preferredCountries.length ? this.preferredCountries[0].iso2 : this.countries[0].iso2;
                                if (!val) {
                                    this._setFlag(this.defaultCountry);
                                }
                            }
                        }
                        // if empty and no nationalMode and no autoHideDialCode then insert the default dial code
                        if (!val && !nationalMode && !autoHideDialCode && !separateDialCode) {
                            this.telInput.value = "+".concat(this.selectedCountryData.dialCode);
                        }
                    }
                    // NOTE: if initialCountry is set to auto, that will be handled separately
                    // format - note this wont be run after _updateDialCode as that's only called if no val
                    if (val) this._updateValFromNumber(val);
                }
            }, {
                key: "_initListeners",
                value: function _initListeners() {
                    this._initKeyListeners();
                    if (this.options.autoHideDialCode) this._initBlurListeners();
                    if (this.options.allowDropdown) this._initDropdownListeners();
                    if (this.hiddenInput) this._initHiddenInputListener();
                }
            }, {
                key: "_initHiddenInputListener",
                value: function _initHiddenInputListener() {
                    var _this3 = this;
                    this._handleHiddenInputSubmit = function() {
                        _this3.hiddenInput.value = _this3.getNumber();
                    };
                    if (this.telInput.form) this.telInput.form.addEventListener("submit", this._handleHiddenInputSubmit);
                }
            }, {
                key: "_getClosestLabel",
                value: function _getClosestLabel() {
                    var el = this.telInput;
                    while (el && el.tagName !== "LABEL") {
                        el = el.parentNode;
                    }
                    return el;
                }
            }, {
                key: "_initDropdownListeners",
                value: function _initDropdownListeners() {
                    var _this4 = this;
                    // hack for input nested inside label (which is valid markup): clicking the selected-flag to
                    // open the dropdown would then automatically trigger a 2nd click on the input which would
                    // close it again
                    this._handleLabelClick = function(e) {
                        // if the dropdown is closed, then focus the input, else ignore the click
                        if (_this4.countryList.classList.contains("iti__hide")) _this4.telInput.focus(); else e.preventDefault();
                    };
                    var label = this._getClosestLabel();
                    if (label) label.addEventListener("click", this._handleLabelClick);
                    // toggle country dropdown on click
                    this._handleClickSelectedFlag = function() {
                        // only intercept this event if we're opening the dropdown
                        // else let it bubble up to the top ("click-off-to-close" listener)
                        // we cannot just stopPropagation as it may be needed to close another instance
                        if (_this4.countryList.classList.contains("iti__hide") && !_this4.telInput.disabled && !_this4.telInput.readOnly) {
                            _this4._showDropdown();
                        }
                    };
                    this.selectedFlag.addEventListener("click", this._handleClickSelectedFlag);
                    // open dropdown list if currently focused
                    this._handleFlagsContainerKeydown = function(e) {
                        var isDropdownHidden = _this4.countryList.classList.contains("iti__hide");
                        if (isDropdownHidden && [ "ArrowUp", "Up", "ArrowDown", "Down", " ", "Enter" ].indexOf(e.key) !== -1) {
                            // prevent form from being submitted if "ENTER" was pressed
                            e.preventDefault();
                            // prevent event from being handled again by document
                            e.stopPropagation();
                            _this4._showDropdown();
                        }
                        // allow navigation from dropdown to input on TAB
                        if (e.key === "Tab") _this4._closeDropdown();
                    };
                    this.flagsContainer.addEventListener("keydown", this._handleFlagsContainerKeydown);
                }
            }, {
                key: "_initRequests",
                value: function _initRequests() {
                    var _this5 = this;
                    // if the user has specified the path to the utils script, fetch it on window.load, else resolve
                    if (this.options.utilsScript && !window.intlTelInputUtils) {
                        // if the plugin is being initialised after the window.load event has already been fired
                        if (window.intlTelInputGlobals.windowLoaded) {
                            window.intlTelInputGlobals.loadUtils(this.options.utilsScript);
                        } else {
                            // wait until the load event so we don't block any other requests e.g. the flags image
                            window.addEventListener("load", function() {
                                window.intlTelInputGlobals.loadUtils(_this5.options.utilsScript);
                            });
                        }
                    } else this.resolveUtilsScriptPromise();
                    if (this.options.initialCountry === "auto") this._loadAutoCountry(); else this.resolveAutoCountryPromise();
                }
            }, {
                key: "_loadAutoCountry",
                value: function _loadAutoCountry() {
                    // 3 options:
                    // 1) already loaded (we're done)
                    // 2) not already started loading (start)
                    // 3) already started loading (do nothing - just wait for loading callback to fire)
                    if (window.intlTelInputGlobals.autoCountry) {
                        this.handleAutoCountry();
                    } else if (!window.intlTelInputGlobals.startedLoadingAutoCountry) {
                        // don't do this twice!
                        window.intlTelInputGlobals.startedLoadingAutoCountry = true;
                        if (typeof this.options.geoIpLookup === "function") {
                            this.options.geoIpLookup(function(countryCode) {
                                window.intlTelInputGlobals.autoCountry = countryCode.toLowerCase();
                                // tell all instances the auto country is ready
                                // TODO: this should just be the current instances
                                // UPDATE: use setTimeout in case their geoIpLookup function calls this callback straight
                                // away (e.g. if they have already done the geo ip lookup somewhere else). Using
                                // setTimeout means that the current thread of execution will finish before executing
                                // this, which allows the plugin to finish initialising.
                                setTimeout(function() {
                                    return forEachInstance("handleAutoCountry");
                                });
                            }, function() {
                                return forEachInstance("rejectAutoCountryPromise");
                            });
                        }
                    }
                }
            }, {
                key: "_initKeyListeners",
                value: function _initKeyListeners() {
                    var _this6 = this;
                    // update flag on keyup
                    this._handleKeyupEvent = function() {
                        if (_this6._updateFlagFromNumber(_this6.telInput.value)) {
                            _this6._triggerCountryChange();
                        }
                    };
                    this.telInput.addEventListener("keyup", this._handleKeyupEvent);
                    // update flag on cut/paste events (now supported in all major browsers)
                    this._handleClipboardEvent = function() {
                        // hack because "paste" event is fired before input is updated
                        setTimeout(_this6._handleKeyupEvent);
                    };
                    this.telInput.addEventListener("cut", this._handleClipboardEvent);
                    this.telInput.addEventListener("paste", this._handleClipboardEvent);
                }
            }, {
                key: "_cap",
                value: function _cap(number) {
                    var max = this.telInput.getAttribute("maxlength");
                    return max && number.length > max ? number.substr(0, max) : number;
                }
            }, {
                key: "_initBlurListeners",
                value: function _initBlurListeners() {
                    var _this7 = this;
                    // on blur or form submit: if just a dial code then remove it
                    this._handleSubmitOrBlurEvent = function() {
                        _this7._removeEmptyDialCode();
                    };
                    if (this.telInput.form) this.telInput.form.addEventListener("submit", this._handleSubmitOrBlurEvent);
                    this.telInput.addEventListener("blur", this._handleSubmitOrBlurEvent);
                }
            }, {
                key: "_removeEmptyDialCode",
                value: function _removeEmptyDialCode() {
                    if (this.telInput.value.charAt(0) === "+") {
                        var numeric = this._getNumeric(this.telInput.value);
                        // if just a plus, or if just a dial code
                        if (!numeric || this.selectedCountryData.dialCode === numeric) {
                            this.telInput.value = "";
                        }
                    }
                }
            }, {
                key: "_getNumeric",
                value: function _getNumeric(s) {
                    return s.replace(/\D/g, "");
                }
            }, {
                key: "_trigger",
                value: function _trigger(name) {
                    // have to use old school document.createEvent as IE11 doesn't support `new Event()` syntax
                    var e = document.createEvent("Event");
                    e.initEvent(name, true, true);
                    // can bubble, and is cancellable
                    this.telInput.dispatchEvent(e);
                }
            }, {
                key: "_showDropdown",
                value: function _showDropdown() {
                    this.countryList.classList.remove("iti__hide");
                    this.selectedFlag.setAttribute("aria-expanded", "true");
                    this._setDropdownPosition();
                    // update highlighting and scroll to active list item
                    if (this.activeItem) {
                        this._highlightListItem(this.activeItem, false);
                        this._scrollTo(this.activeItem, true);
                    }
                    // bind all the dropdown-related listeners: mouseover, click, click-off, keydown
                    this._bindDropdownListeners();
                    // update the arrow
                    this.dropdownArrow.classList.add("iti__arrow--up");
                    this._trigger("open:countrydropdown");
                }
            }, {
                key: "_toggleClass",
                value: function _toggleClass(el, className, shouldHaveClass) {
                    if (shouldHaveClass && !el.classList.contains(className)) el.classList.add(className); else if (!shouldHaveClass && el.classList.contains(className)) el.classList.remove(className);
                }
            }, {
                key: "_setDropdownPosition",
                value: function _setDropdownPosition() {
                    var _this8 = this;
                    if (this.options.dropdownContainer) {
                        this.options.dropdownContainer.appendChild(this.dropdown);
                    }
                    if (!this.isMobile) {
                        var pos = this.telInput.getBoundingClientRect();
                        // windowTop from https://stackoverflow.com/a/14384091/217866
                        var windowTop = window.pageYOffset || document.documentElement.scrollTop;
                        var inputTop = pos.top + windowTop;
                        var dropdownHeight = this.countryList.offsetHeight;
                        // dropdownFitsBelow = (dropdownBottom < windowBottom)
                        var dropdownFitsBelow = inputTop + this.telInput.offsetHeight + dropdownHeight < windowTop + window.innerHeight;
                        var dropdownFitsAbove = inputTop - dropdownHeight > windowTop;
                        // by default, the dropdown will be below the input. If we want to position it above the
                        // input, we add the dropup class.
                        this._toggleClass(this.countryList, "iti__country-list--dropup", !dropdownFitsBelow && dropdownFitsAbove);
                        // if dropdownContainer is enabled, calculate postion
                        if (this.options.dropdownContainer) {
                            // by default the dropdown will be directly over the input because it's not in the flow.
                            // If we want to position it below, we need to add some extra top value.
                            var extraTop = !dropdownFitsBelow && dropdownFitsAbove ? 0 : this.telInput.offsetHeight;
                            // calculate placement
                            this.dropdown.style.top = "".concat(inputTop + extraTop, "px");
                            this.dropdown.style.left = "".concat(pos.left + document.body.scrollLeft, "px");
                            // close menu on window scroll
                            this._handleWindowScroll = function() {
                                return _this8._closeDropdown();
                            };
                            window.addEventListener("scroll", this._handleWindowScroll);
                        }
                    }
                }
            }, {
                key: "_getClosestListItem",
                value: function _getClosestListItem(target) {
                    var el = target;
                    while (el && el !== this.countryList && !el.classList.contains("iti__country")) {
                        el = el.parentNode;
                    }
                    // if we reached the countryList element, then return null
                    return el === this.countryList ? null : el;
                }
            }, {
                key: "_bindDropdownListeners",
                value: function _bindDropdownListeners() {
                    var _this9 = this;
                    // when mouse over a list item, just highlight that one
                    // we add the class "highlight", so if they hit "enter" we know which one to select
                    this._handleMouseoverCountryList = function(e) {
                        // handle event delegation, as we're listening for this event on the countryList
                        var listItem = _this9._getClosestListItem(e.target);
                        if (listItem) _this9._highlightListItem(listItem, false);
                    };
                    this.countryList.addEventListener("mouseover", this._handleMouseoverCountryList);
                    // listen for country selection
                    this._handleClickCountryList = function(e) {
                        var listItem = _this9._getClosestListItem(e.target);
                        if (listItem) _this9._selectListItem(listItem);
                    };
                    this.countryList.addEventListener("click", this._handleClickCountryList);
                    // click off to close
                    // (except when this initial opening click is bubbling up)
                    // we cannot just stopPropagation as it may be needed to close another instance
                    var isOpening = true;
                    this._handleClickOffToClose = function() {
                        if (!isOpening) _this9._closeDropdown();
                        isOpening = false;
                    };
                    document.documentElement.addEventListener("click", this._handleClickOffToClose);
                    // listen for up/down scrolling, enter to select, or letters to jump to country name.
                    // use keydown as keypress doesn't fire for non-char keys and we want to catch if they
                    // just hit down and hold it to scroll down (no keyup event).
                    // listen on the document because that's where key events are triggered if no input has focus
                    var query = "";
                    var queryTimer = null;
                    this._handleKeydownOnDropdown = function(e) {
                        // prevent down key from scrolling the whole page,
                        // and enter key from submitting a form etc
                        e.preventDefault();
                        // up and down to navigate
                        if (e.key === "ArrowUp" || e.key === "Up" || e.key === "ArrowDown" || e.key === "Down") _this9._handleUpDownKey(e.key); else if (e.key === "Enter") _this9._handleEnterKey(); else if (e.key === "Escape") _this9._closeDropdown(); else if (/^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(e.key)) {
                            // jump to countries that start with the query string
                            if (queryTimer) clearTimeout(queryTimer);
                            query += e.key.toLowerCase();
                            _this9._searchForCountry(query);
                            // if the timer hits 1 second, reset the query
                            queryTimer = setTimeout(function() {
                                query = "";
                            }, 1e3);
                        }
                    };
                    document.addEventListener("keydown", this._handleKeydownOnDropdown);
                }
            }, {
                key: "_handleUpDownKey",
                value: function _handleUpDownKey(key) {
                    var next = key === "ArrowUp" || key === "Up" ? this.highlightedItem.previousElementSibling : this.highlightedItem.nextElementSibling;
                    if (next) {
                        // skip the divider
                        if (next.classList.contains("iti__divider")) {
                            next = key === "ArrowUp" || key === "Up" ? next.previousElementSibling : next.nextElementSibling;
                        }
                        this._highlightListItem(next, true);
                    }
                }
            }, {
                key: "_handleEnterKey",
                value: function _handleEnterKey() {
                    if (this.highlightedItem) this._selectListItem(this.highlightedItem);
                }
            }, {
                key: "_searchForCountry",
                value: function _searchForCountry(query) {
                    for (var i = 0; i < this.countries.length; i++) {
                        if (this._startsWith(this.countries[i].name, query)) {
                            var listItem = this.countryList.querySelector("#iti-item-".concat(this.countries[i].iso2));
                            // update highlighting and scroll
                            this._highlightListItem(listItem, false);
                            this._scrollTo(listItem, true);
                            break;
                        }
                    }
                }
            }, {
                key: "_startsWith",
                value: function _startsWith(a, b) {
                    return a.substr(0, b.length).toLowerCase() === b;
                }
            }, {
                key: "_updateValFromNumber",
                value: function _updateValFromNumber(originalNumber) {
                    var number = originalNumber;
                    if (this.options.formatOnDisplay && window.intlTelInputUtils && this.selectedCountryData) {
                        var useNational = !this.options.separateDialCode && (this.options.nationalMode || number.charAt(0) !== "+");
                        var _intlTelInputUtils$nu = intlTelInputUtils.numberFormat, NATIONAL = _intlTelInputUtils$nu.NATIONAL, INTERNATIONAL = _intlTelInputUtils$nu.INTERNATIONAL;
                        var format = useNational ? NATIONAL : INTERNATIONAL;
                        number = intlTelInputUtils.formatNumber(number, this.selectedCountryData.iso2, format);
                    }
                    number = this._beforeSetNumber(number);
                    this.telInput.value = number;
                }
            }, {
                key: "_updateFlagFromNumber",
                value: function _updateFlagFromNumber(originalNumber) {
                    // if we're in nationalMode and we already have US/Canada selected, make sure the number starts
                    // with a +1 so _getDialCode will be able to extract the area code
                    // update: if we dont yet have selectedCountryData, but we're here (trying to update the flag
                    // from the number), that means we're initialising the plugin with a number that already has a
                    // dial code, so fine to ignore this bit
                    var number = originalNumber;
                    var selectedDialCode = this.selectedCountryData.dialCode;
                    var isNanp = selectedDialCode === "1";
                    if (number && this.options.nationalMode && isNanp && number.charAt(0) !== "+") {
                        if (number.charAt(0) !== "1") number = "1".concat(number);
                        number = "+".concat(number);
                    }
                    // update flag if user types area code for another country
                    if (this.options.separateDialCode && selectedDialCode && number.charAt(0) !== "+") {
                        number = "+".concat(selectedDialCode).concat(number);
                    }
                    // try and extract valid dial code from input
                    var dialCode = this._getDialCode(number);
                    var numeric = this._getNumeric(number);
                    var countryCode = null;
                    if (dialCode) {
                        var countryCodes = this.countryCodes[this._getNumeric(dialCode)];
                        // check if the right country is already selected. this should be false if the number is
                        // longer than the matched dial code because in this case we need to make sure that if
                        // there are multiple country matches, that the first one is selected (note: we could
                        // just check that here, but it requires the same loop that we already have later)
                        var alreadySelected = countryCodes.indexOf(this.selectedCountryData.iso2) !== -1 && numeric.length <= dialCode.length - 1;
                        var isRegionlessNanpNumber = selectedDialCode === "1" && this._isRegionlessNanp(numeric);
                        // only update the flag if:
                        // A) NOT (we currently have a NANP flag selected, and the number is a regionlessNanp)
                        // AND
                        // B) the right country is not already selected
                        if (!isRegionlessNanpNumber && !alreadySelected) {
                            // if using onlyCountries option, countryCodes[0] may be empty, so we must find the first
                            // non-empty index
                            for (var j = 0; j < countryCodes.length; j++) {
                                if (countryCodes[j]) {
                                    countryCode = countryCodes[j];
                                    break;
                                }
                            }
                        }
                    } else if (number.charAt(0) === "+" && numeric.length) {
                        // invalid dial code, so empty
                        // Note: use getNumeric here because the number has not been formatted yet, so could contain
                        // bad chars
                        countryCode = "";
                    } else if (!number || number === "+") {
                        // empty, or just a plus, so default
                        countryCode = this.defaultCountry;
                    }
                    if (countryCode !== null) {
                        return this._setFlag(countryCode);
                    }
                    return false;
                }
            }, {
                key: "_isRegionlessNanp",
                value: function _isRegionlessNanp(number) {
                    var numeric = this._getNumeric(number);
                    if (numeric.charAt(0) === "1") {
                        var areaCode = numeric.substr(1, 3);
                        return regionlessNanpNumbers.indexOf(areaCode) !== -1;
                    }
                    return false;
                }
            }, {
                key: "_highlightListItem",
                value: function _highlightListItem(listItem, shouldFocus) {
                    var prevItem = this.highlightedItem;
                    if (prevItem) prevItem.classList.remove("iti__highlight");
                    this.highlightedItem = listItem;
                    this.highlightedItem.classList.add("iti__highlight");
                    if (shouldFocus) this.highlightedItem.focus();
                }
            }, {
                key: "_getCountryData",
                value: function _getCountryData(countryCode, ignoreOnlyCountriesOption, allowFail) {
                    var countryList = ignoreOnlyCountriesOption ? allCountries : this.countries;
                    for (var i = 0; i < countryList.length; i++) {
                        if (countryList[i].iso2 === countryCode) {
                            return countryList[i];
                        }
                    }
                    if (allowFail) {
                        return null;
                    }
                    throw new Error("No country data for '".concat(countryCode, "'"));
                }
            }, {
                key: "_setFlag",
                value: function _setFlag(countryCode) {
                    var prevCountry = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
                    // do this first as it will throw an error and stop if countryCode is invalid
                    this.selectedCountryData = countryCode ? this._getCountryData(countryCode, false, false) : {};
                    // update the defaultCountry - we only need the iso2 from now on, so just store that
                    if (this.selectedCountryData.iso2) {
                        this.defaultCountry = this.selectedCountryData.iso2;
                    }
                    this.selectedFlagInner.setAttribute("class", "iti__flag iti__".concat(countryCode));
                    // update the selected country's title attribute
                    var title = countryCode ? "".concat(this.selectedCountryData.name, ": +").concat(this.selectedCountryData.dialCode) : "Unknown";
                    this.selectedFlag.setAttribute("title", title);
                    if (this.options.separateDialCode) {
                        var dialCode = this.selectedCountryData.dialCode ? "+".concat(this.selectedCountryData.dialCode) : "";
                        this.selectedDialCode.innerHTML = dialCode;
                        // offsetWidth is zero if input is in a hidden container during initialisation
                        var selectedFlagWidth = this.selectedFlag.offsetWidth || this._getHiddenSelectedFlagWidth();
                        // add 6px of padding after the grey selected-dial-code box, as this is what we use in the css
                        this.telInput.style.paddingLeft = "".concat(selectedFlagWidth + 6, "px");
                    }
                    // and the input's placeholder
                    this._updatePlaceholder();
                    // update the active list item
                    if (this.options.allowDropdown) {
                        var prevItem = this.activeItem;
                        if (prevItem) {
                            prevItem.classList.remove("iti__active");
                            prevItem.setAttribute("aria-selected", "false");
                        }
                        if (countryCode) {
                            var nextItem = this.countryList.querySelector("#iti-item-".concat(countryCode));
                            nextItem.setAttribute("aria-selected", "true");
                            nextItem.classList.add("iti__active");
                            this.activeItem = nextItem;
                            this.selectedFlag.setAttribute("aria-activedescendant", nextItem.getAttribute("id"));
                        }
                    }
                    // return if the flag has changed or not
                    return prevCountry.iso2 !== countryCode;
                }
            }, {
                key: "_getHiddenSelectedFlagWidth",
                value: function _getHiddenSelectedFlagWidth() {
                    // to get the right styling to apply, all we need is a shallow clone of the container,
                    // and then to inject a deep clone of the selectedFlag element
                    var containerClone = this.telInput.parentNode.cloneNode();
                    containerClone.style.visibility = "hidden";
                    document.body.appendChild(containerClone);
                    var selectedFlagClone = this.selectedFlag.cloneNode(true);
                    containerClone.appendChild(selectedFlagClone);
                    var width = selectedFlagClone.offsetWidth;
                    containerClone.parentNode.removeChild(containerClone);
                    return width;
                }
            }, {
                key: "_updatePlaceholder",
                value: function _updatePlaceholder() {
                    var shouldSetPlaceholder = this.options.autoPlaceholder === "aggressive" || !this.hadInitialPlaceholder && this.options.autoPlaceholder === "polite";
                    if (window.intlTelInputUtils && shouldSetPlaceholder) {
                        var numberType = intlTelInputUtils.numberType[this.options.placeholderNumberType];
                        var placeholder = this.selectedCountryData.iso2 ? intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2, this.options.nationalMode, numberType) : "";
                        placeholder = this._beforeSetNumber(placeholder);
                        if (typeof this.options.customPlaceholder === "function") {
                            placeholder = this.options.customPlaceholder(placeholder, this.selectedCountryData);
                        }
                        this.telInput.setAttribute("placeholder", placeholder);
                    }
                }
            }, {
                key: "_selectListItem",
                value: function _selectListItem(listItem) {
                    // update selected flag and active list item
                    var flagChanged = this._setFlag(listItem.getAttribute("data-country-code"));
                    this._closeDropdown();
                    this._updateDialCode(listItem.getAttribute("data-dial-code"), true);
                    // focus the input
                    this.telInput.focus();
                    // put cursor at end - this fix is required for FF and IE11 (with nationalMode=false i.e. auto
                    // inserting dial code), who try to put the cursor at the beginning the first time
                    var len = this.telInput.value.length;
                    this.telInput.setSelectionRange(len, len);
                    if (flagChanged) {
                        this._triggerCountryChange();
                    }
                }
            }, {
                key: "_closeDropdown",
                value: function _closeDropdown() {
                    this.countryList.classList.add("iti__hide");
                    this.selectedFlag.setAttribute("aria-expanded", "false");
                    // update the arrow
                    this.dropdownArrow.classList.remove("iti__arrow--up");
                    // unbind key events
                    document.removeEventListener("keydown", this._handleKeydownOnDropdown);
                    document.documentElement.removeEventListener("click", this._handleClickOffToClose);
                    this.countryList.removeEventListener("mouseover", this._handleMouseoverCountryList);
                    this.countryList.removeEventListener("click", this._handleClickCountryList);
                    // remove menu from container
                    if (this.options.dropdownContainer) {
                        if (!this.isMobile) window.removeEventListener("scroll", this._handleWindowScroll);
                        if (this.dropdown.parentNode) this.dropdown.parentNode.removeChild(this.dropdown);
                    }
                    this._trigger("close:countrydropdown");
                }
            }, {
                key: "_scrollTo",
                value: function _scrollTo(element, middle) {
                    var container = this.countryList;
                    // windowTop from https://stackoverflow.com/a/14384091/217866
                    var windowTop = window.pageYOffset || document.documentElement.scrollTop;
                    var containerHeight = container.offsetHeight;
                    var containerTop = container.getBoundingClientRect().top + windowTop;
                    var containerBottom = containerTop + containerHeight;
                    var elementHeight = element.offsetHeight;
                    var elementTop = element.getBoundingClientRect().top + windowTop;
                    var elementBottom = elementTop + elementHeight;
                    var newScrollTop = elementTop - containerTop + container.scrollTop;
                    var middleOffset = containerHeight / 2 - elementHeight / 2;
                    if (elementTop < containerTop) {
                        // scroll up
                        if (middle) newScrollTop -= middleOffset;
                        container.scrollTop = newScrollTop;
                    } else if (elementBottom > containerBottom) {
                        // scroll down
                        if (middle) newScrollTop += middleOffset;
                        var heightDifference = containerHeight - elementHeight;
                        container.scrollTop = newScrollTop - heightDifference;
                    }
                }
            }, {
                key: "_updateDialCode",
                value: function _updateDialCode(newDialCodeBare, hasSelectedListItem) {
                    var inputVal = this.telInput.value;
                    // save having to pass this every time
                    var newDialCode = "+".concat(newDialCodeBare);
                    var newNumber;
                    if (inputVal.charAt(0) === "+") {
                        // there's a plus so we're dealing with a replacement (doesn't matter if nationalMode or not)
                        var prevDialCode = this._getDialCode(inputVal);
                        if (prevDialCode) {
                            // current number contains a valid dial code, so replace it
                            newNumber = inputVal.replace(prevDialCode, newDialCode);
                        } else {
                            // current number contains an invalid dial code, so ditch it
                            // (no way to determine where the invalid dial code ends and the rest of the number begins)
                            newNumber = newDialCode;
                        }
                    } else if (this.options.nationalMode || this.options.separateDialCode) {
                        // don't do anything
                        return;
                    } else {
                        // nationalMode is disabled
                        if (inputVal) {
                            // there is an existing value with no dial code: prefix the new dial code
                            newNumber = newDialCode + inputVal;
                        } else if (hasSelectedListItem || !this.options.autoHideDialCode) {
                            // no existing value and either they've just selected a list item, or autoHideDialCode is
                            // disabled: insert new dial code
                            newNumber = newDialCode;
                        } else {
                            return;
                        }
                    }
                    this.telInput.value = newNumber;
                }
            }, {
                key: "_getDialCode",
                value: function _getDialCode(number) {
                    var dialCode = "";
                    // only interested in international numbers (starting with a plus)
                    if (number.charAt(0) === "+") {
                        var numericChars = "";
                        // iterate over chars
                        for (var i = 0; i < number.length; i++) {
                            var c = number.charAt(i);
                            // if char is number (https://stackoverflow.com/a/8935649/217866)
                            if (!isNaN(parseInt(c, 10))) {
                                numericChars += c;
                                // if current numericChars make a valid dial code
                                if (this.countryCodes[numericChars]) {
                                    // store the actual raw string (useful for matching later)
                                    dialCode = number.substr(0, i + 1);
                                }
                                if (numericChars.length === this.dialCodeMaxLen) {
                                    break;
                                }
                            }
                        }
                    }
                    return dialCode;
                }
            }, {
                key: "_getFullNumber",
                value: function _getFullNumber() {
                    var val = this.telInput.value.trim();
                    var dialCode = this.selectedCountryData.dialCode;
                    var prefix;
                    var numericVal = this._getNumeric(val);
                    if (this.options.separateDialCode && val.charAt(0) !== "+" && dialCode && numericVal) {
                        // when using separateDialCode, it is visible so is effectively part of the typed number
                        prefix = "+".concat(dialCode);
                    } else {
                        prefix = "";
                    }
                    return prefix + val;
                }
            }, {
                key: "_beforeSetNumber",
                value: function _beforeSetNumber(originalNumber) {
                    var number = originalNumber;
                    if (this.options.separateDialCode) {
                        var dialCode = this._getDialCode(number);
                        // if there is a valid dial code
                        if (dialCode) {
                            // in case _getDialCode returned an area code as well
                            dialCode = "+".concat(this.selectedCountryData.dialCode);
                            // a lot of numbers will have a space separating the dial code and the main number, and
                            // some NANP numbers will have a hyphen e.g. +1 684-733-1234 - in both cases we want to get
                            // rid of it
                            // NOTE: don't just trim all non-numerics as may want to preserve an open parenthesis etc
                            var start = number[dialCode.length] === " " || number[dialCode.length] === "-" ? dialCode.length + 1 : dialCode.length;
                            number = number.substr(start);
                        }
                    }
                    return this._cap(number);
                }
            }, {
                key: "_triggerCountryChange",
                value: function _triggerCountryChange() {
                    this._trigger("countrychange");
                }
            }, {
                key: "handleAutoCountry",
                value: function handleAutoCountry() {
                    if (this.options.initialCountry === "auto") {
                        // we must set this even if there is an initial val in the input: in case the initial val is
                        // invalid and they delete it - they should see their auto country
                        this.defaultCountry = window.intlTelInputGlobals.autoCountry;
                        // if there's no initial value in the input, then update the flag
                        if (!this.telInput.value) {
                            this.setCountry(this.defaultCountry);
                        }
                        this.resolveAutoCountryPromise();
                    }
                }
            }, {
                key: "handleUtils",
                value: function handleUtils() {
                    // if the request was successful
                    if (window.intlTelInputUtils) {
                        // if there's an initial value in the input, then format it
                        if (this.telInput.value) {
                            this._updateValFromNumber(this.telInput.value);
                        }
                        this._updatePlaceholder();
                    }
                    this.resolveUtilsScriptPromise();
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    var form = this.telInput.form;
                    if (this.options.allowDropdown) {
                        // make sure the dropdown is closed (and unbind listeners)
                        this._closeDropdown();
                        this.selectedFlag.removeEventListener("click", this._handleClickSelectedFlag);
                        this.flagsContainer.removeEventListener("keydown", this._handleFlagsContainerKeydown);
                        // label click hack
                        var label = this._getClosestLabel();
                        if (label) label.removeEventListener("click", this._handleLabelClick);
                    }
                    // unbind hiddenInput listeners
                    if (this.hiddenInput && form) form.removeEventListener("submit", this._handleHiddenInputSubmit);
                    // unbind autoHideDialCode listeners
                    if (this.options.autoHideDialCode) {
                        if (form) form.removeEventListener("submit", this._handleSubmitOrBlurEvent);
                        this.telInput.removeEventListener("blur", this._handleSubmitOrBlurEvent);
                    }
                    // unbind key events, and cut/paste events
                    this.telInput.removeEventListener("keyup", this._handleKeyupEvent);
                    this.telInput.removeEventListener("cut", this._handleClipboardEvent);
                    this.telInput.removeEventListener("paste", this._handleClipboardEvent);
                    // remove attribute of id instance: data-intl-tel-input-id
                    this.telInput.removeAttribute("data-intl-tel-input-id");
                    // remove markup (but leave the original input)
                    var wrapper = this.telInput.parentNode;
                    wrapper.parentNode.insertBefore(this.telInput, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                    delete window.intlTelInputGlobals.instances[this.id];
                }
            }, {
                key: "getExtension",
                value: function getExtension() {
                    if (window.intlTelInputUtils) {
                        return intlTelInputUtils.getExtension(this._getFullNumber(), this.selectedCountryData.iso2);
                    }
                    return "";
                }
            }, {
                key: "getNumber",
                value: function getNumber(format) {
                    if (window.intlTelInputUtils) {
                        var iso2 = this.selectedCountryData.iso2;
                        return intlTelInputUtils.formatNumber(this._getFullNumber(), iso2, format);
                    }
                    return "";
                }
            }, {
                key: "getNumberType",
                value: function getNumberType() {
                    if (window.intlTelInputUtils) {
                        return intlTelInputUtils.getNumberType(this._getFullNumber(), this.selectedCountryData.iso2);
                    }
                    return -99;
                }
            }, {
                key: "getSelectedCountryData",
                value: function getSelectedCountryData() {
                    return this.selectedCountryData;
                }
            }, {
                key: "getValidationError",
                value: function getValidationError() {
                    if (window.intlTelInputUtils) {
                        var iso2 = this.selectedCountryData.iso2;
                        return intlTelInputUtils.getValidationError(this._getFullNumber(), iso2);
                    }
                    return -99;
                }
            }, {
                key: "isValidNumber",
                value: function isValidNumber() {
                    var val = this._getFullNumber().trim();
                    var countryCode = this.options.nationalMode ? this.selectedCountryData.iso2 : "";
                    return window.intlTelInputUtils ? intlTelInputUtils.isValidNumber(val, countryCode) : null;
                }
            }, {
                key: "setCountry",
                value: function setCountry(originalCountryCode) {
                    var countryCode = originalCountryCode.toLowerCase();
                    // check if already selected
                    if (!this.selectedFlagInner.classList.contains("iti__".concat(countryCode))) {
                        this._setFlag(countryCode);
                        this._updateDialCode(this.selectedCountryData.dialCode, false);
                        this._triggerCountryChange();
                    }
                }
            }, {
                key: "setNumber",
                value: function setNumber(number) {
                    // we must update the flag first, which updates this.selectedCountryData, which is used for
                    // formatting the number before displaying it
                    var flagChanged = this._updateFlagFromNumber(number);
                    this._updateValFromNumber(number);
                    if (flagChanged) {
                        this._triggerCountryChange();
                    }
                }
            }, {
                key: "setPlaceholderNumberType",
                value: function setPlaceholderNumberType(type) {
                    this.options.placeholderNumberType = type;
                    this._updatePlaceholder();
                }
            } ]);
            return Iti;
        }();
        /********************
 *  STATIC METHODS
 ********************/
        // get the country data object
        intlTelInputGlobals.getCountryData = function() {
            return allCountries;
        };
        // inject a <script> element to load utils.js
        var injectScript = function injectScript(path, handleSuccess, handleFailure) {
            // inject a new script element into the page
            var script = document.createElement("script");
            script.onload = function() {
                forEachInstance("handleUtils");
                if (handleSuccess) handleSuccess();
            };
            script.onerror = function() {
                forEachInstance("rejectUtilsScriptPromise");
                if (handleFailure) handleFailure();
            };
            script.className = "iti-load-utils";
            script.async = true;
            script.src = path;
            document.body.appendChild(script);
        };
        // load the utils script
        intlTelInputGlobals.loadUtils = function(path) {
            // 2 options:
            // 1) not already started loading (start)
            // 2) already started loading (do nothing - just wait for the onload callback to fire, which will
            // trigger handleUtils on all instances, invoking their resolveUtilsScriptPromise functions)
            if (!window.intlTelInputUtils && !window.intlTelInputGlobals.startedLoadingUtilsScript) {
                // only do this once
                window.intlTelInputGlobals.startedLoadingUtilsScript = true;
                // if we have promises, then return a promise
                if (typeof Promise !== "undefined") {
                    return new Promise(function(resolve, reject) {
                        return injectScript(path, resolve, reject);
                    });
                }
                injectScript(path);
            }
            return null;
        };
        // default options
        intlTelInputGlobals.defaults = defaults;
        // version
        intlTelInputGlobals.version = "16.1.0";
        // convenience wrapper
        return function(input, options) {
            var iti = new Iti(input, options);
            iti._init();
            input.setAttribute("data-intl-tel-input-id", iti.id);
            window.intlTelInputGlobals.instances[iti.id] = iti;
            return iti;
        };
    }();
});
},{}],15:[function(require,module,exports){
/**
 * Exposing intl-tel-input as a component
 */
module.exports = require("./build/js/intlTelInput");

},{"./build/js/intlTelInput":14}],16:[function(require,module,exports){
/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.4.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code, options ) {
		DOMEval( code, { nonce: options && options.nonce } );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.4
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2019-04-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) &&

				// Support: IE 8 only
				// Exclude object elements
				(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 && rdescend.test( selector ) ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = (elem.ownerDocument || elem).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( typeof elem.contentDocument !== "undefined" ) {
			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								} );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	// Support: IE 9-11 only
	// Also use offsetWidth/offsetHeight for when box sizing is unreliable
	// We use getClientRects() to check for hidden/disconnected.
	// In those cases, the computed value can be trusted to be border-box
	if ( ( !support.boxSizingReliable() && isBorderBox ||
		val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url, options ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

},{}]},{},[10])